"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/tslib/tslib.js
  var require_tslib = __commonJS({
    "node_modules/tslib/tslib.js"(exports, module) {
      var __extends2;
      var __assign3;
      var __rest2;
      var __decorate2;
      var __param2;
      var __metadata2;
      var __awaiter2;
      var __generator2;
      var __exportStar2;
      var __values2;
      var __read2;
      var __spread2;
      var __spreadArrays3;
      var __spreadArray2;
      var __await2;
      var __asyncGenerator2;
      var __asyncDelegator2;
      var __asyncValues2;
      var __makeTemplateObject2;
      var __importStar2;
      var __importDefault2;
      var __classPrivateFieldGet2;
      var __classPrivateFieldSet2;
      var __classPrivateFieldIn2;
      var __createBinding2;
      (function(factory) {
        var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
        if (typeof define === "function" && define.amd) {
          define("tslib", ["exports"], function(exports2) {
            factory(createExporter(root, createExporter(exports2)));
          });
        } else if (typeof module === "object" && typeof module.exports === "object") {
          factory(createExporter(root, createExporter(module.exports)));
        } else {
          factory(createExporter(root));
        }
        function createExporter(exports2, previous) {
          if (exports2 !== root) {
            if (typeof Object.create === "function") {
              Object.defineProperty(exports2, "__esModule", { value: true });
            } else {
              exports2.__esModule = true;
            }
          }
          return function(id, v) {
            return exports2[id] = previous ? previous(id, v) : v;
          };
        }
      })(function(exporter) {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
          d.__proto__ = b;
        } || function(d, b) {
          for (var p in b)
            if (Object.prototype.hasOwnProperty.call(b, p))
              d[p] = b[p];
        };
        __extends2 = function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
        __assign3 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        __rest2 = function(s, e) {
          var t = {};
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
              t[p] = s[p];
          if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
            }
          return t;
        };
        __decorate2 = function(decorators, target, key, desc) {
          var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
            r = Reflect.decorate(decorators, target, key, desc);
          else
            for (var i = decorators.length - 1; i >= 0; i--)
              if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        };
        __param2 = function(paramIndex, decorator) {
          return function(target, key) {
            decorator(target, key, paramIndex);
          };
        };
        __metadata2 = function(metadataKey, metadataValue) {
          if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
            return Reflect.metadata(metadataKey, metadataValue);
        };
        __awaiter2 = function(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        __generator2 = function(thisArg, body) {
          var _ = { label: 0, sent: function() {
            if (t[0] & 1)
              throw t[1];
            return t[1];
          }, trys: [], ops: [] }, f, y, t, g;
          return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
          }), g;
          function verb(n) {
            return function(v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f)
              throw new TypeError("Generator is already executing.");
            while (_)
              try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                  return t;
                if (y = 0, t)
                  op = [op[0] & 2, t.value];
                switch (op[0]) {
                  case 0:
                  case 1:
                    t = op;
                    break;
                  case 4:
                    _.label++;
                    return { value: op[1], done: false };
                  case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                  case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                  default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                      _ = 0;
                      continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                      _.label = op[1];
                      break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                      _.label = t[1];
                      t = op;
                      break;
                    }
                    if (t && _.label < t[2]) {
                      _.label = t[2];
                      _.ops.push(op);
                      break;
                    }
                    if (t[2])
                      _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
              } catch (e) {
                op = [6, e];
                y = 0;
              } finally {
                f = t = 0;
              }
            if (op[0] & 5)
              throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
          }
        };
        __exportStar2 = function(m, o) {
          for (var p in m)
            if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p))
              __createBinding2(o, m, p);
        };
        __createBinding2 = Object.create ? function(o, m, k, k2) {
          if (k2 === void 0)
            k2 = k;
          var desc = Object.getOwnPropertyDescriptor(m, k);
          if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
            desc = { enumerable: true, get: function() {
              return m[k];
            } };
          }
          Object.defineProperty(o, k2, desc);
        } : function(o, m, k, k2) {
          if (k2 === void 0)
            k2 = k;
          o[k2] = m[k];
        };
        __values2 = function(o) {
          var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
          if (m)
            return m.call(o);
          if (o && typeof o.length === "number")
            return {
              next: function() {
                if (o && i >= o.length)
                  o = void 0;
                return { value: o && o[i++], done: !o };
              }
            };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        __read2 = function(o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m)
            return o;
          var i = m.call(o), r, ar = [], e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
              ar.push(r.value);
          } catch (error) {
            e = { error };
          } finally {
            try {
              if (r && !r.done && (m = i["return"]))
                m.call(i);
            } finally {
              if (e)
                throw e.error;
            }
          }
          return ar;
        };
        __spread2 = function() {
          for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read2(arguments[i]));
          return ar;
        };
        __spreadArrays3 = function() {
          for (var s = 0, i = 0, il = arguments.length; i < il; i++)
            s += arguments[i].length;
          for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
          return r;
        };
        __spreadArray2 = function(to, from, pack) {
          if (pack || arguments.length === 2)
            for (var i = 0, l = from.length, ar; i < l; i++) {
              if (ar || !(i in from)) {
                if (!ar)
                  ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
              }
            }
          return to.concat(ar || Array.prototype.slice.call(from));
        };
        __await2 = function(v) {
          return this instanceof __await2 ? (this.v = v, this) : new __await2(v);
        };
        __asyncGenerator2 = function(thisArg, _arguments, generator) {
          if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
          var g = generator.apply(thisArg, _arguments || []), i, q = [];
          return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
            return this;
          }, i;
          function verb(n) {
            if (g[n])
              i[n] = function(v) {
                return new Promise(function(a, b) {
                  q.push([n, v, a, b]) > 1 || resume(n, v);
                });
              };
          }
          function resume(n, v) {
            try {
              step(g[n](v));
            } catch (e) {
              settle(q[0][3], e);
            }
          }
          function step(r) {
            r.value instanceof __await2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
          }
          function fulfill(value) {
            resume("next", value);
          }
          function reject(value) {
            resume("throw", value);
          }
          function settle(f, v) {
            if (f(v), q.shift(), q.length)
              resume(q[0][0], q[0][1]);
          }
        };
        __asyncDelegator2 = function(o) {
          var i, p;
          return i = {}, verb("next"), verb("throw", function(e) {
            throw e;
          }), verb("return"), i[Symbol.iterator] = function() {
            return this;
          }, i;
          function verb(n, f) {
            i[n] = o[n] ? function(v) {
              return (p = !p) ? { value: __await2(o[n](v)), done: n === "return" } : f ? f(v) : v;
            } : f;
          }
        };
        __asyncValues2 = function(o) {
          if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
          var m = o[Symbol.asyncIterator], i;
          return m ? m.call(o) : (o = typeof __values2 === "function" ? __values2(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
            return this;
          }, i);
          function verb(n) {
            i[n] = o[n] && function(v) {
              return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
              });
            };
          }
          function settle(resolve, reject, d, v) {
            Promise.resolve(v).then(function(v2) {
              resolve({ value: v2, done: d });
            }, reject);
          }
        };
        __makeTemplateObject2 = function(cooked, raw) {
          if (Object.defineProperty) {
            Object.defineProperty(cooked, "raw", { value: raw });
          } else {
            cooked.raw = raw;
          }
          return cooked;
        };
        var __setModuleDefault = Object.create ? function(o, v) {
          Object.defineProperty(o, "default", { enumerable: true, value: v });
        } : function(o, v) {
          o["default"] = v;
        };
        __importStar2 = function(mod) {
          if (mod && mod.__esModule)
            return mod;
          var result = {};
          if (mod != null) {
            for (var k in mod)
              if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
                __createBinding2(result, mod, k);
          }
          __setModuleDefault(result, mod);
          return result;
        };
        __importDefault2 = function(mod) {
          return mod && mod.__esModule ? mod : { "default": mod };
        };
        __classPrivateFieldGet2 = function(receiver, state, kind, f) {
          if (kind === "a" && !f)
            throw new TypeError("Private accessor was defined without a getter");
          if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
            throw new TypeError("Cannot read private member from an object whose class did not declare it");
          return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
        };
        __classPrivateFieldSet2 = function(receiver, state, value, kind, f) {
          if (kind === "m")
            throw new TypeError("Private method is not writable");
          if (kind === "a" && !f)
            throw new TypeError("Private accessor was defined without a setter");
          if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
            throw new TypeError("Cannot write private member to an object whose class did not declare it");
          return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
        };
        __classPrivateFieldIn2 = function(state, receiver) {
          if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function")
            throw new TypeError("Cannot use 'in' operator on non-object");
          return typeof state === "function" ? receiver === state : state.has(receiver);
        };
        exporter("__extends", __extends2);
        exporter("__assign", __assign3);
        exporter("__rest", __rest2);
        exporter("__decorate", __decorate2);
        exporter("__param", __param2);
        exporter("__metadata", __metadata2);
        exporter("__awaiter", __awaiter2);
        exporter("__generator", __generator2);
        exporter("__exportStar", __exportStar2);
        exporter("__createBinding", __createBinding2);
        exporter("__values", __values2);
        exporter("__read", __read2);
        exporter("__spread", __spread2);
        exporter("__spreadArrays", __spreadArrays3);
        exporter("__spreadArray", __spreadArray2);
        exporter("__await", __await2);
        exporter("__asyncGenerator", __asyncGenerator2);
        exporter("__asyncDelegator", __asyncDelegator2);
        exporter("__asyncValues", __asyncValues2);
        exporter("__makeTemplateObject", __makeTemplateObject2);
        exporter("__importStar", __importStar2);
        exporter("__importDefault", __importDefault2);
        exporter("__classPrivateFieldGet", __classPrivateFieldGet2);
        exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
        exporter("__classPrivateFieldIn", __classPrivateFieldIn2);
      });
    }
  });

  // node_modules/flatpickr/dist/l10n/it.js
  var require_it = __commonJS({
    "node_modules/flatpickr/dist/l10n/it.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory(global2.it = {}));
      })(exports, function(exports2) {
        "use strict";
        var fp = typeof window !== "undefined" && window.flatpickr !== void 0 ? window.flatpickr : {
          l10ns: {}
        };
        var Italian2 = {
          weekdays: {
            shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
            longhand: [
              "Domenica",
              "Luned\xEC",
              "Marted\xEC",
              "Mercoled\xEC",
              "Gioved\xEC",
              "Venerd\xEC",
              "Sabato"
            ]
          },
          months: {
            shorthand: [
              "Gen",
              "Feb",
              "Mar",
              "Apr",
              "Mag",
              "Giu",
              "Lug",
              "Ago",
              "Set",
              "Ott",
              "Nov",
              "Dic"
            ],
            longhand: [
              "Gennaio",
              "Febbraio",
              "Marzo",
              "Aprile",
              "Maggio",
              "Giugno",
              "Luglio",
              "Agosto",
              "Settembre",
              "Ottobre",
              "Novembre",
              "Dicembre"
            ]
          },
          firstDayOfWeek: 1,
          ordinal: function() {
            return "\xB0";
          },
          rangeSeparator: " al ",
          weekAbbreviation: "Se",
          scrollTitle: "Scrolla per aumentare",
          toggleTitle: "Clicca per cambiare",
          time_24hr: true
        };
        fp.l10ns.it = Italian2;
        var it = fp.l10ns;
        exports2.Italian = Italian2;
        exports2.default = it;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/flatpickr/dist/l10n/fr.js
  var require_fr = __commonJS({
    "node_modules/flatpickr/dist/l10n/fr.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory(global2.fr = {}));
      })(exports, function(exports2) {
        "use strict";
        var fp = typeof window !== "undefined" && window.flatpickr !== void 0 ? window.flatpickr : {
          l10ns: {}
        };
        var French2 = {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
            longhand: [
              "dimanche",
              "lundi",
              "mardi",
              "mercredi",
              "jeudi",
              "vendredi",
              "samedi"
            ]
          },
          months: {
            shorthand: [
              "janv",
              "f\xE9vr",
              "mars",
              "avr",
              "mai",
              "juin",
              "juil",
              "ao\xFBt",
              "sept",
              "oct",
              "nov",
              "d\xE9c"
            ],
            longhand: [
              "janvier",
              "f\xE9vrier",
              "mars",
              "avril",
              "mai",
              "juin",
              "juillet",
              "ao\xFBt",
              "septembre",
              "octobre",
              "novembre",
              "d\xE9cembre"
            ]
          },
          ordinal: function(nth) {
            if (nth > 1)
              return "";
            return "er";
          },
          rangeSeparator: " au ",
          weekAbbreviation: "Sem",
          scrollTitle: "D\xE9filer pour augmenter la valeur",
          toggleTitle: "Cliquer pour basculer",
          time_24hr: true
        };
        fp.l10ns.fr = French2;
        var fr = fp.l10ns;
        exports2.French = French2;
        exports2.default = fr;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/flatpickr/dist/l10n/de.js
  var require_de = __commonJS({
    "node_modules/flatpickr/dist/l10n/de.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory(global2.de = {}));
      })(exports, function(exports2) {
        "use strict";
        var fp = typeof window !== "undefined" && window.flatpickr !== void 0 ? window.flatpickr : {
          l10ns: {}
        };
        var German2 = {
          weekdays: {
            shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            longhand: [
              "Sonntag",
              "Montag",
              "Dienstag",
              "Mittwoch",
              "Donnerstag",
              "Freitag",
              "Samstag"
            ]
          },
          months: {
            shorthand: [
              "Jan",
              "Feb",
              "M\xE4r",
              "Apr",
              "Mai",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Okt",
              "Nov",
              "Dez"
            ],
            longhand: [
              "Januar",
              "Februar",
              "M\xE4rz",
              "April",
              "Mai",
              "Juni",
              "Juli",
              "August",
              "September",
              "Oktober",
              "November",
              "Dezember"
            ]
          },
          firstDayOfWeek: 1,
          weekAbbreviation: "KW",
          rangeSeparator: " bis ",
          scrollTitle: "Zum \xC4ndern scrollen",
          toggleTitle: "Zum Umschalten klicken",
          time_24hr: true
        };
        fp.l10ns.de = German2;
        var de = fp.l10ns;
        exports2.German = German2;
        exports2.default = de;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/body-scroll-lock/lib/bodyScrollLock.min.js
  var require_bodyScrollLock_min = __commonJS({
    "node_modules/body-scroll-lock/lib/bodyScrollLock.min.js"(exports) {
      !function(e, t) {
        if ("function" == typeof define && define.amd)
          define(["exports"], t);
        else if ("undefined" != typeof exports)
          t(exports);
        else {
          var o = {};
          t(o), e.bodyScrollLock = o;
        }
      }(exports, function(exports2) {
        "use strict";
        function r(e2) {
          if (Array.isArray(e2)) {
            for (var t = 0, o2 = Array(e2.length); t < e2.length; t++)
              o2[t] = e2[t];
            return o2;
          }
          return Array.from(e2);
        }
        Object.defineProperty(exports2, "__esModule", { value: true });
        var l = false;
        if ("undefined" != typeof window) {
          var e = { get passive() {
            l = true;
          } };
          window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
        }
        var d = "undefined" != typeof window && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform), c = [], u = false, a = -1, s = void 0, v = void 0, f = function(t) {
          return c.some(function(e2) {
            return !(!e2.options.allowTouchMove || !e2.options.allowTouchMove(t));
          });
        }, m = function(e2) {
          var t = e2 || window.event;
          return !!f(t.target) || (1 < t.touches.length || (t.preventDefault && t.preventDefault(), false));
        }, o = function() {
          setTimeout(function() {
            void 0 !== v && (document.body.style.paddingRight = v, v = void 0), void 0 !== s && (document.body.style.overflow = s, s = void 0);
          });
        };
        exports2.disableBodyScroll = function(i, e2) {
          if (d) {
            if (!i)
              return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
            if (i && !c.some(function(e3) {
              return e3.targetElement === i;
            })) {
              var t = { targetElement: i, options: e2 || {} };
              c = [].concat(r(c), [t]), i.ontouchstart = function(e3) {
                1 === e3.targetTouches.length && (a = e3.targetTouches[0].clientY);
              }, i.ontouchmove = function(e3) {
                var t2, o3, n2, r2;
                1 === e3.targetTouches.length && (o3 = i, r2 = (t2 = e3).targetTouches[0].clientY - a, !f(t2.target) && (o3 && 0 === o3.scrollTop && 0 < r2 ? m(t2) : (n2 = o3) && n2.scrollHeight - n2.scrollTop <= n2.clientHeight && r2 < 0 ? m(t2) : t2.stopPropagation()));
              }, u || (document.addEventListener("touchmove", m, l ? { passive: false } : void 0), u = true);
            }
          } else {
            n = e2, setTimeout(function() {
              if (void 0 === v) {
                var e3 = !!n && true === n.reserveScrollBarGap, t2 = window.innerWidth - document.documentElement.clientWidth;
                e3 && 0 < t2 && (v = document.body.style.paddingRight, document.body.style.paddingRight = t2 + "px");
              }
              void 0 === s && (s = document.body.style.overflow, document.body.style.overflow = "hidden");
            });
            var o2 = { targetElement: i, options: e2 || {} };
            c = [].concat(r(c), [o2]);
          }
          var n;
        }, exports2.clearAllBodyScrollLocks = function() {
          d ? (c.forEach(function(e2) {
            e2.targetElement.ontouchstart = null, e2.targetElement.ontouchmove = null;
          }), u && (document.removeEventListener("touchmove", m, l ? { passive: false } : void 0), u = false), c = [], a = -1) : (o(), c = []);
        }, exports2.enableBodyScroll = function(t) {
          if (d) {
            if (!t)
              return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
            t.ontouchstart = null, t.ontouchmove = null, c = c.filter(function(e2) {
              return e2.targetElement !== t;
            }), u && 0 === c.length && (document.removeEventListener("touchmove", m, l ? { passive: false } : void 0), u = false);
          } else
            (c = c.filter(function(e2) {
              return e2.targetElement !== t;
            })).length || o();
        };
      });
    }
  });

  // node_modules/tslib/modules/index.js
  var import_tslib = __toESM(require_tslib(), 1);
  var {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __exportStar,
    __createBinding,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn
  } = import_tslib.default;

  // build/ts/main/src/sdx.js
  var sdx_exports = {};
  __export(sdx_exports, {
    Accordion: () => Accordion_default,
    Autocomplete: () => Autocomplete_default,
    BarChartHorizontal: () => BarChartHorizontal_default,
    BarChartVertical: () => BarChartVertical_default,
    Carousel: () => Carousel_default,
    Collapse: () => Collapse_default,
    EmptyState: () => EmptyState_default,
    InputField: () => InputField_default,
    LoaderBar: () => LoaderBar_default,
    MenuFlyout: () => MenuFlyout_default,
    Modal: () => Modal_default,
    Navigation: () => Navigation_default,
    NavigationSide: () => NavigationSide_default,
    Notification: () => Notification_exports,
    PieChart: () => PieChart_default,
    ProgressFull: () => ProgressFull_default,
    ProgressLight: () => ProgressLight_default,
    Range: () => Range_default,
    SearchInput: () => SearchInput_default,
    Select: () => Select_default,
    Table: () => Table_default,
    Textarea: () => Textarea_default,
    Toolbar: () => Toolbar_default,
    initAccordion: () => init11,
    initAutocomplete: () => init6,
    initBarChartHorizontal: () => init20,
    initBarChartVertical: () => init21,
    initCarousel: () => init17,
    initCollapse: () => init10,
    initEmptyState: () => init16,
    initInputField: () => init2,
    initLoaderBar: () => init,
    initMenuFlyout: () => init12,
    initModal: () => init9,
    initNavigation: () => init14,
    initNavigationSide: () => init15,
    initPieChart: () => init19,
    initProgressFull: () => init8,
    initProgressLight: () => init7,
    initRange: () => init5,
    initSearchInput: () => init13,
    initSelect: () => init4,
    initTable: () => init18,
    initTextarea: () => init3,
    utils: () => Utils_exports
  });

  // build/ts/main/src/Utils.js
  var Utils_exports = {};
  __export(Utils_exports, {
    animation: () => animation,
    clamp: () => clamp,
    find: () => find,
    internetExplorerOrEdgeVersion: () => internetExplorerOrEdgeVersion,
    onDocumentReady: () => onDocumentReady,
    preventDefault: () => preventDefault,
    remove: () => remove,
    scrollIntoView: () => scrollIntoView,
    searchAndInitialize: () => searchAndInitialize
  });
  function onDocumentReady(callback) {
    function completed() {
      document.removeEventListener("DOMContentLoaded", completed, false);
      window.removeEventListener("load", completed, false);
      callback();
    }
    if (document.readyState === "complete") {
      setTimeout(callback);
    } else {
      document.addEventListener("DOMContentLoaded", completed, false);
      window.addEventListener("load", completed, false);
    }
  }
  function searchAndInitialize(selector, callback, initSelector) {
    var e_1, _a;
    if (!callback) {
      throw new Error("The callback cannot be undefined");
    }
    var elements = document.querySelectorAll(selector);
    try {
      for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
        var e = elements_1_1.value;
        var initElement = e;
        if (initSelector) {
          initElement = initSelector(e);
        }
        if (initElement.getAttribute("data-init") === "auto") {
          callback(e);
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return))
          _a.call(elements_1);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  }
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
  function preventDefault(event) {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
  }
  function remove(node) {
    if (!node || !node.parentNode) {
      return;
    }
    node.parentNode.removeChild(node);
  }
  function find(array, expression) {
    for (var i = 0; i < array.length; i++) {
      var item = array[i];
      if (expression(item) === true) {
        return item;
      }
    }
    return void 0;
  }
  function internetExplorerOrEdgeVersion(userAgent) {
    if (userAgent === void 0) {
      userAgent = navigator.userAgent;
    }
    var ieOrEdge = userAgent.search(/MSIE |Edge[/]/);
    if (ieOrEdge > 0) {
      return parseInt(userAgent.substring(ieOrEdge + 5, userAgent.indexOf(".", ieOrEdge)), 10);
    }
    if (userAgent.indexOf("Trident/") > 0) {
      var rv = userAgent.indexOf("rv:");
      return parseInt(userAgent.substring(rv + 3, userAgent.indexOf(".", rv)), 10);
    }
    return 0;
  }
  function scrollIntoView(child) {
    var parent = child.parentNode;
    var parentRect = parent.getBoundingClientRect();
    var childRect = child.getBoundingClientRect();
    var isFullyVisible = childRect.top >= parentRect.top && childRect.bottom <= parentRect.top + parent.clientHeight;
    if (!isFullyVisible) {
      parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top;
    }
  }
  var animation = {
    set: function(el, properties) {
      var targetProperties = Array.isArray(properties) ? properties[properties.length - 1] : properties;
      for (var key in targetProperties) {
        var value = targetProperties[key];
        if (typeof value === "string") {
          el.style[key] = value;
        }
      }
    },
    start: function(el, properties, duration2, _a) {
      var _b = _a === void 0 ? {} : _a, _c = _b.delay, delay = _c === void 0 ? 0 : _c, _d = _b.finished, finished = _d === void 0 ? function() {
        return void 0;
      } : _d;
      el.getAnimations().forEach(function(animation2) {
        animation2.commitStyles();
        animation2.cancel();
      });
      if (duration2 === 0) {
        animation.set(el, properties);
        finished();
        return;
      }
      el.animate(properties, {
        duration: duration2,
        fill: "forwards",
        easing: "cubic-bezier(0.550, 0.085, 0.320, 1)",
        delay
      }).finished.then(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args[0].cancel();
        animation.set(el, properties);
        finished();
      }).catch(function() {
        return void 0;
      });
    }
  };

  // build/ts/main/src/DomFunctions.js
  function addClass(element, name) {
    if (typeof name !== "string") {
      throw new Error("Expected string class name");
    }
    element.classList.add(name);
  }
  function removeClass(element, name) {
    if (typeof name !== "string") {
      throw new Error("Expected string class name");
    }
    element.classList.remove(name);
  }
  function hasClass(element, name) {
    if (typeof name !== "string") {
      throw new Error("Expected string class name");
    }
    return element.classList.contains(name);
  }
  function toggleClass(element, name) {
    if (typeof name !== "string") {
      throw new Error("Expected string class name");
    }
    element.classList.toggle(name);
  }
  function isHidden(element, includeParents) {
    if (includeParents === void 0) {
      includeParents = false;
    }
    if (includeParents === false) {
      var style = window.getComputedStyle(element);
      return style.display === "none" || element.offsetLeft < 0;
    }
    var result;
    while ((result = isHidden(element, false)) === false && element.parentElement) {
      element = element.parentElement;
    }
    return result;
  }
  function text(element) {
    return element.textContent || element.innerText;
  }
  function parentWithClass(element, className) {
    var current = element;
    while (!hasClass(current, className) && current.parentElement) {
      current = current.parentElement;
    }
    if (hasClass(current, className)) {
      return current;
    }
    return void 0;
  }
  function textWidth(text2, font) {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text2);
    return Math.round(metrics.width);
  }
  function css(element, property) {
    return window.getComputedStyle(element).getPropertyValue(property);
  }
  function getAttributeReference(element, attribute) {
    var attrValue = element.getAttribute(attribute);
    if (!attrValue || attrValue === "") {
      return void 0;
    }
    return document.querySelector(attrValue);
  }
  function getRootElement() {
    var element = document.querySelector(".sdx-container");
    if (!element) {
      element = document.body;
    }
    return element;
  }
  function empty(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  // build/ts/main/src/DomElement.js
  var htmlEvents;
  var DomElement = function() {
    function DomElement2(element) {
      if (typeof element === "string") {
        this.element = document.createElement(element);
      } else {
        this.element = element;
      }
    }
    DomElement2.prototype.addClass = function(name) {
      addClass(this.element, name);
      return this;
    };
    DomElement2.prototype.removeClass = function(name) {
      removeClass(this.element, name);
      return this;
    };
    DomElement2.prototype.hasClass = function(name) {
      return hasClass(this.element, name);
    };
    DomElement2.prototype.toggleClass = function(name) {
      toggleClass(this.element, name);
      return this;
    };
    Object.defineProperty(DomElement2.prototype, "classes", {
      get: function() {
        return this.element.classList;
      },
      enumerable: false,
      configurable: true
    });
    DomElement2.prototype.setId = function(id) {
      this.element.setAttribute("id", id);
      return this;
    };
    Object.defineProperty(DomElement2.prototype, "innerText", {
      get: function() {
        return text(this.element);
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(DomElement2.prototype, "innerHtml", {
      get: function() {
        return this.element.innerHTML;
      },
      enumerable: false,
      configurable: true
    });
    DomElement2.prototype.setHtml = function(value, allowStrongTag) {
      if (allowStrongTag === void 0) {
        allowStrongTag = false;
      }
      function sanitize(dangerousHtmlString) {
        var map = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&grave;",
          "/": "&#x2F;"
        };
        var reg = /[&<>"'`\/]/gi;
        return dangerousHtmlString.replace(reg, function(match) {
          return map[match];
        });
      }
      if (typeof value !== "string") {
        throw new Error("Expected HTML string");
      }
      if (allowStrongTag) {
        var sanitizedValue = sanitize(value);
        sanitizedValue = sanitizedValue.replace("&lt;strong&gt;", "<strong>");
        sanitizedValue = sanitizedValue.replace("&lt;&#x2F;strong&gt;", "</strong>");
        this.element.innerHTML = sanitizedValue;
      } else {
        this.element.textContent = value;
      }
      return this;
    };
    DomElement2.prototype.getAttribute = function(name) {
      return this.element.getAttribute(name);
    };
    DomElement2.prototype.setAttribute = function(name, value) {
      this.element.setAttribute(name, value);
      return this;
    };
    DomElement2.prototype.addEventListener = function(type, listener) {
      this.element.addEventListener(type, listener);
    };
    DomElement2.prototype.removeEventListener = function(type, listener) {
      this.element.removeEventListener(type, listener);
    };
    DomElement2.prototype.appendChild = function(newChild) {
      if (!(newChild instanceof DomElement2)) {
        throw new Error("Only other DomElements can be added as children");
      }
      this.element.appendChild(newChild.element);
      return this;
    };
    DomElement2.prototype.prependChild = function(newChild) {
      if (!(newChild instanceof DomElement2)) {
        throw new Error("Only other DomElements can be added as children");
      }
      this.element.insertBefore(newChild.element, this.element.firstChild);
      return this;
    };
    DomElement2.prototype.insertBefore = function(newChild) {
      if (!(newChild instanceof DomElement2)) {
        throw new Error("Only other DomElements can be added as children");
      }
      if (!this.element.parentNode) {
        throw new Error("Element is not attached");
      }
      this.element.parentNode.insertBefore(newChild.element, this.element);
      return this;
    };
    DomElement2.prototype.insertAfter = function(newChild) {
      if (!(newChild instanceof DomElement2)) {
        throw new Error("Only other DomElements can be added as children");
      }
      if (!this.element.parentNode) {
        throw new Error("Element is not attached");
      }
      this.element.parentNode.insertBefore(newChild.element, this.element.nextSibling);
      return this;
    };
    DomElement2.prototype.removeChild = function(oldChild) {
      if (!(oldChild instanceof DomElement2)) {
        throw new Error("Only a DomElements child can be removed");
      }
      this.element.removeChild(oldChild.element);
    };
    DomElement2.prototype.find = function(selectors) {
      var e = this.element.querySelector(selectors);
      if (e) {
        return new DomElement2(e);
      }
      return void 0;
    };
    DomElement2.prototype.wrapWithElement = function(wrapperElement) {
      if (!this.element.parentNode) {
        throw new Error("Element is not attached");
      }
      this.element.parentNode.replaceChild(wrapperElement.element, this.element);
      wrapperElement.element.appendChild(this.element);
      return this;
    };
    DomElement2.prototype.dispatchEvent = function(eventName) {
      var event;
      var el = this.element;
      if (document.createEvent) {
        event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, true, true);
      } else if (document.createEventObject) {
        event = document.createEventObject();
        event.eventType = eventName;
      }
      event.eventName = eventName;
      if (el.dispatchEvent) {
        el.dispatchEvent(event);
      } else if (el.fireEvent && htmlEvents["on".concat(eventName)]) {
        ;
        el.fireEvent("on".concat(event.eventType), event);
      } else if (el[eventName]) {
        ;
        el[eventName]();
      } else if (el["on".concat(eventName)]) {
        ;
        el["on".concat(eventName)]();
      }
    };
    DomElement2.prototype.css = function(property) {
      return css(this.element, property);
    };
    DomElement2.prototype.empty = function() {
      empty(this.element);
    };
    return DomElement2;
  }();
  var DomElement_default = DomElement;

  // build/ts/main/src/loader/LoaderBar.js
  var LoaderBar = function(_super) {
    __extends(LoaderBar2, _super);
    function LoaderBar2(element) {
      var _this = _super.call(this, element) || this;
      _this._initialize();
      return _this;
    }
    LoaderBar2.prototype._initialize = function() {
      this.progressElement = this.find(".indicator") || this;
      this.fileNameElement = this.find(".detail > .name");
      this.progressLabelElement = this.find(".progress");
      this.totalProgressElement = this.find(".progress > .file-size");
    };
    Object.defineProperty(LoaderBar2.prototype, "progress", {
      get: function() {
        return this.value;
      },
      set: function(val) {
        var percentage = (val * 100).toFixed(0);
        this.value = val;
        this.element.value = String(val);
        this.progressElement.setAttribute("style", "width: ".concat(val * 100, "%"));
        if (this.progressLabelElement) {
          this.progressLabelElement.element.textContent = "".concat(percentage, "%");
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(LoaderBar2.prototype, "filename", {
      get: function() {
        if (!this.fileNameElement) {
          return void 0;
        }
        return this.fileNameElement.element.textContent || void 0;
      },
      set: function(val) {
        if (!this.fileNameElement) {
          throw new Error("Cannot set the filename, missing detail element");
        }
        this.fileNameElement.setHtml(val || "");
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(LoaderBar2.prototype, "fileSize", {
      set: function(val) {
        if (!this.totalProgressElement) {
          throw new Error("Cannot set the fileSize, missing detail element");
        }
        this.totalProgressElement.setHtml(val);
      },
      enumerable: false,
      configurable: true
    });
    return LoaderBar2;
  }(DomElement_default);
  function init() {
    searchAndInitialize(".loader-bar", function(e) {
      new LoaderBar(e);
    });
  }
  var LoaderBar_default = LoaderBar;

  // node_modules/flatpickr/dist/esm/types/options.js
  var HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
  ];
  var defaults = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
      return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
      var date = new Date(givenDate.getTime());
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
      var week1 = new Date(date.getFullYear(), 0, 4);
      return 1 + Math.round(((date.getTime() - week1.getTime()) / 864e5 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: void 0,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
  };

  // node_modules/flatpickr/dist/esm/l10n/default.js
  var english = {
    weekdays: {
      shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      longhand: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ]
    },
    months: {
      shorthand: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      longhand: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
      var s = nth % 100;
      if (s > 3 && s < 21)
        return "th";
      switch (s % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: ["AM", "PM"],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
  };
  var default_default = english;

  // node_modules/flatpickr/dist/esm/utils/index.js
  var pad = function(number, length) {
    if (length === void 0) {
      length = 2;
    }
    return ("000" + number).slice(length * -1);
  };
  var int = function(bool) {
    return bool === true ? 1 : 0;
  };
  function debounce(fn, wait) {
    var t;
    return function() {
      var _this = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function() {
        return fn.apply(_this, args);
      }, wait);
    };
  }
  var arrayify = function(obj) {
    return obj instanceof Array ? obj : [obj];
  };

  // node_modules/flatpickr/dist/esm/utils/dom.js
  function toggleClass2(elem, className, bool) {
    if (bool === true)
      return elem.classList.add(className);
    elem.classList.remove(className);
  }
  function createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== void 0)
      e.textContent = content;
    return e;
  }
  function clearNode(node) {
    while (node.firstChild)
      node.removeChild(node.firstChild);
  }
  function findParent(node, condition) {
    if (condition(node))
      return node;
    else if (node.parentNode)
      return findParent(node.parentNode, condition);
    return void 0;
  }
  function createNumberInput(inputClassName, opts) {
    var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
      numInput.type = "number";
    } else {
      numInput.type = "text";
      numInput.pattern = "\\d*";
    }
    if (opts !== void 0)
      for (var key in opts)
        numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
  }
  function getEventTarget(event) {
    try {
      if (typeof event.composedPath === "function") {
        var path = event.composedPath();
        return path[0];
      }
      return event.target;
    } catch (error) {
      return event.target;
    }
  }

  // node_modules/flatpickr/dist/esm/utils/formatting.js
  var doNothing = function() {
    return void 0;
  };
  var monthToStr = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
  };
  var revFormat = {
    D: doNothing,
    F: function(dateObj, monthName, locale) {
      dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
      dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
      dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
      dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
      dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
      return new Date(parseFloat(unixSeconds) * 1e3);
    },
    W: function(dateObj, weekNum, locale) {
      var weekNumber = parseInt(weekNum);
      var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
      date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
      return date;
    },
    Y: function(dateObj, year) {
      dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
      return new Date(ISODate);
    },
    d: function(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
      dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
      dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: function(dateObj, month) {
      dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
      dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
      dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
      return new Date(parseFloat(unixMillSeconds));
    },
    w: doNothing,
    y: function(dateObj, year) {
      dateObj.setFullYear(2e3 + parseFloat(year));
    }
  };
  var tokenRegex = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
  };
  var formats = {
    Z: function(date) {
      return date.toISOString();
    },
    D: function(date, locale, options) {
      return locale.weekdays.shorthand[formats.w(date, locale, options)];
    },
    F: function(date, locale, options) {
      return monthToStr(formats.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
      return pad(formats.h(date, locale, options));
    },
    H: function(date) {
      return pad(date.getHours());
    },
    J: function(date, locale) {
      return locale.ordinal !== void 0 ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
      return locale.amPM[int(date.getHours() > 11)];
    },
    M: function(date, locale) {
      return monthToStr(date.getMonth(), true, locale);
    },
    S: function(date) {
      return pad(date.getSeconds());
    },
    U: function(date) {
      return date.getTime() / 1e3;
    },
    W: function(date, _, options) {
      return options.getWeek(date);
    },
    Y: function(date) {
      return pad(date.getFullYear(), 4);
    },
    d: function(date) {
      return pad(date.getDate());
    },
    h: function(date) {
      return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
      return pad(date.getMinutes());
    },
    j: function(date) {
      return date.getDate();
    },
    l: function(date, locale) {
      return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
      return pad(date.getMonth() + 1);
    },
    n: function(date) {
      return date.getMonth() + 1;
    },
    s: function(date) {
      return date.getSeconds();
    },
    u: function(date) {
      return date.getTime();
    },
    w: function(date) {
      return date.getDay();
    },
    y: function(date) {
      return String(date.getFullYear()).substring(2);
    }
  };

  // node_modules/flatpickr/dist/esm/utils/dates.js
  var createDateFormatter = function(_a) {
    var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
      var locale = overrideLocale || l10n;
      if (config.formatDate !== void 0 && !isMobile) {
        return config.formatDate(dateObj, frmt, locale);
      }
      return frmt.split("").map(function(c, i, arr) {
        return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
      }).join("");
    };
  };
  var createDateParser = function(_a) {
    var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
    return function(date, givenFormat, timeless, customLocale) {
      if (date !== 0 && !date)
        return void 0;
      var locale = customLocale || l10n;
      var parsedDate;
      var dateOrig = date;
      if (date instanceof Date)
        parsedDate = new Date(date.getTime());
      else if (typeof date !== "string" && date.toFixed !== void 0)
        parsedDate = new Date(date);
      else if (typeof date === "string") {
        var format = givenFormat || (config || defaults).dateFormat;
        var datestr = String(date).trim();
        if (datestr === "today") {
          parsedDate = new Date();
          timeless = true;
        } else if (config && config.parseDate) {
          parsedDate = config.parseDate(date, format);
        } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) {
          parsedDate = new Date(date);
        } else {
          var matched = void 0, ops = [];
          for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
            var token = format[i];
            var isBackSlash = token === "\\";
            var escaped = format[i - 1] === "\\" || isBackSlash;
            if (tokenRegex[token] && !escaped) {
              regexStr += tokenRegex[token];
              var match = new RegExp(regexStr).exec(date);
              if (match && (matched = true)) {
                ops[token !== "Y" ? "push" : "unshift"]({
                  fn: revFormat[token],
                  val: match[++matchIndex]
                });
              }
            } else if (!isBackSlash)
              regexStr += ".";
          }
          parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
          ops.forEach(function(_a2) {
            var fn = _a2.fn, val = _a2.val;
            return parsedDate = fn(parsedDate, val, locale) || parsedDate;
          });
          parsedDate = matched ? parsedDate : void 0;
        }
      }
      if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
        config.errorHandler(new Error("Invalid date provided: " + dateOrig));
        return void 0;
      }
      if (timeless === true)
        parsedDate.setHours(0, 0, 0, 0);
      return parsedDate;
    };
  };
  function compareDates(date1, date2, timeless) {
    if (timeless === void 0) {
      timeless = true;
    }
    if (timeless !== false) {
      return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    }
    return date1.getTime() - date2.getTime();
  }
  var isBetween = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
  };
  var calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
  };
  var parseSeconds = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
  };
  var duration = {
    DAY: 864e5
  };
  function getDefaultHours(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== void 0) {
      var minHour = config.minDate.getHours();
      var minMinutes = config.minDate.getMinutes();
      var minSeconds = config.minDate.getSeconds();
      if (hours < minHour) {
        hours = minHour;
      }
      if (hours === minHour && minutes < minMinutes) {
        minutes = minMinutes;
      }
      if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
        seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== void 0) {
      var maxHr = config.maxDate.getHours();
      var maxMinutes = config.maxDate.getMinutes();
      hours = Math.min(hours, maxHr);
      if (hours === maxHr)
        minutes = Math.min(maxMinutes, minutes);
      if (hours === maxHr && minutes === maxMinutes)
        seconds = config.maxDate.getSeconds();
    }
    return { hours, minutes, seconds };
  }

  // node_modules/flatpickr/dist/esm/utils/polyfills.js
  if (typeof Object.assign !== "function") {
    Object.assign = function(target) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      if (!target) {
        throw TypeError("Cannot convert undefined or null to object");
      }
      var _loop_1 = function(source2) {
        if (source2) {
          Object.keys(source2).forEach(function(key) {
            return target[key] = source2[key];
          });
        }
      };
      for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var source = args_1[_a];
        _loop_1(source);
      }
      return target;
    };
  }

  // node_modules/flatpickr/dist/esm/index.js
  var __assign2 = function() {
    __assign2 = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    return __assign2.apply(this, arguments);
  };
  var __spreadArrays2 = function() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++)
      s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
        r[k] = a[j];
    return r;
  };
  var DEBOUNCED_CHANGE_MS = 300;
  function FlatpickrInstance(element, instanceConfig) {
    var self2 = {
      config: __assign2(__assign2({}, defaults), flatpickr.defaultConfig),
      l10n: default_default
    };
    self2.parseDate = createDateParser({ config: self2.config, l10n: self2.l10n });
    self2._handlers = [];
    self2.pluginElements = [];
    self2.loadedPlugins = [];
    self2._bind = bind;
    self2._setHoursFromDate = setHoursFromDate;
    self2._positionCalendar = positionCalendar;
    self2.changeMonth = changeMonth;
    self2.changeYear = changeYear;
    self2.clear = clear;
    self2.close = close;
    self2.onMouseOver = onMouseOver;
    self2._createElement = createElement;
    self2.createDay = createDay;
    self2.destroy = destroy;
    self2.isEnabled = isEnabled;
    self2.jumpToDate = jumpToDate;
    self2.updateValue = updateValue;
    self2.open = open;
    self2.redraw = redraw;
    self2.set = set;
    self2.setDate = setDate;
    self2.toggle = toggle;
    function setupHelperFunctions() {
      self2.utils = {
        getDaysInMonth: function(month, yr) {
          if (month === void 0) {
            month = self2.currentMonth;
          }
          if (yr === void 0) {
            yr = self2.currentYear;
          }
          if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0))
            return 29;
          return self2.l10n.daysInMonth[month];
        }
      };
    }
    function init22() {
      self2.element = self2.input = element;
      self2.isOpen = false;
      parseConfig();
      setupLocale();
      setupInputs();
      setupDates();
      setupHelperFunctions();
      if (!self2.isMobile)
        build();
      bindEvents();
      if (self2.selectedDates.length || self2.config.noCalendar) {
        if (self2.config.enableTime) {
          setHoursFromDate(self2.config.noCalendar ? self2.latestSelectedDateObj : void 0);
        }
        updateValue(false);
      }
      setCalendarWidth();
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (!self2.isMobile && isSafari) {
        positionCalendar();
      }
      triggerEvent("onReady");
    }
    function getClosestActiveElement() {
      var _a;
      return ((_a = self2.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
      return fn.bind(self2);
    }
    function setCalendarWidth() {
      var config = self2.config;
      if (config.weekNumbers === false && config.showMonths === 1) {
        return;
      } else if (config.noCalendar !== true) {
        window.requestAnimationFrame(function() {
          if (self2.calendarContainer !== void 0) {
            self2.calendarContainer.style.visibility = "hidden";
            self2.calendarContainer.style.display = "block";
          }
          if (self2.daysContainer !== void 0) {
            var daysWidth = (self2.days.offsetWidth + 1) * config.showMonths;
            self2.daysContainer.style.width = daysWidth + "px";
            self2.calendarContainer.style.width = daysWidth + (self2.weekWrapper !== void 0 ? self2.weekWrapper.offsetWidth : 0) + "px";
            self2.calendarContainer.style.removeProperty("visibility");
            self2.calendarContainer.style.removeProperty("display");
          }
        });
      }
    }
    function updateTime(e) {
      if (self2.selectedDates.length === 0) {
        var defaultDate = self2.config.minDate === void 0 || compareDates(new Date(), self2.config.minDate) >= 0 ? new Date() : new Date(self2.config.minDate.getTime());
        var defaults2 = getDefaultHours(self2.config);
        defaultDate.setHours(defaults2.hours, defaults2.minutes, defaults2.seconds, defaultDate.getMilliseconds());
        self2.selectedDates = [defaultDate];
        self2.latestSelectedDateObj = defaultDate;
      }
      if (e !== void 0 && e.type !== "blur") {
        timeWrapper(e);
      }
      var prevValue = self2._input.value;
      setHoursFromInputs();
      updateValue();
      if (self2._input.value !== prevValue) {
        self2._debouncedChange();
      }
    }
    function ampm2military(hour, amPM) {
      return hour % 12 + 12 * int(amPM === self2.l10n.amPM[1]);
    }
    function military2ampm(hour) {
      switch (hour % 24) {
        case 0:
        case 12:
          return 12;
        default:
          return hour % 12;
      }
    }
    function setHoursFromInputs() {
      if (self2.hourElement === void 0 || self2.minuteElement === void 0)
        return;
      var hours = (parseInt(self2.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self2.minuteElement.value, 10) || 0) % 60, seconds = self2.secondElement !== void 0 ? (parseInt(self2.secondElement.value, 10) || 0) % 60 : 0;
      if (self2.amPM !== void 0) {
        hours = ampm2military(hours, self2.amPM.textContent);
      }
      var limitMinHours = self2.config.minTime !== void 0 || self2.config.minDate && self2.minDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.minDate, true) === 0;
      var limitMaxHours = self2.config.maxTime !== void 0 || self2.config.maxDate && self2.maxDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.maxDate, true) === 0;
      if (self2.config.maxTime !== void 0 && self2.config.minTime !== void 0 && self2.config.minTime > self2.config.maxTime) {
        var minBound = calculateSecondsSinceMidnight(self2.config.minTime.getHours(), self2.config.minTime.getMinutes(), self2.config.minTime.getSeconds());
        var maxBound = calculateSecondsSinceMidnight(self2.config.maxTime.getHours(), self2.config.maxTime.getMinutes(), self2.config.maxTime.getSeconds());
        var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);
        if (currentTime > maxBound && currentTime < minBound) {
          var result = parseSeconds(minBound);
          hours = result[0];
          minutes = result[1];
          seconds = result[2];
        }
      } else {
        if (limitMaxHours) {
          var maxTime = self2.config.maxTime !== void 0 ? self2.config.maxTime : self2.config.maxDate;
          hours = Math.min(hours, maxTime.getHours());
          if (hours === maxTime.getHours())
            minutes = Math.min(minutes, maxTime.getMinutes());
          if (minutes === maxTime.getMinutes())
            seconds = Math.min(seconds, maxTime.getSeconds());
        }
        if (limitMinHours) {
          var minTime = self2.config.minTime !== void 0 ? self2.config.minTime : self2.config.minDate;
          hours = Math.max(hours, minTime.getHours());
          if (hours === minTime.getHours() && minutes < minTime.getMinutes())
            minutes = minTime.getMinutes();
          if (minutes === minTime.getMinutes())
            seconds = Math.max(seconds, minTime.getSeconds());
        }
      }
      setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
      var date = dateObj || self2.latestSelectedDateObj;
      if (date && date instanceof Date) {
        setHours(date.getHours(), date.getMinutes(), date.getSeconds());
      }
    }
    function setHours(hours, minutes, seconds) {
      if (self2.latestSelectedDateObj !== void 0) {
        self2.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
      }
      if (!self2.hourElement || !self2.minuteElement || self2.isMobile)
        return;
      self2.hourElement.value = pad(!self2.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
      self2.minuteElement.value = pad(minutes);
      if (self2.amPM !== void 0)
        self2.amPM.textContent = self2.l10n.amPM[int(hours >= 12)];
      if (self2.secondElement !== void 0)
        self2.secondElement.value = pad(seconds);
    }
    function onYearInput(event) {
      var eventTarget = getEventTarget(event);
      var year = parseInt(eventTarget.value) + (event.delta || 0);
      if (year / 1e3 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
        changeYear(year);
      }
    }
    function bind(element2, event, handler, options) {
      if (event instanceof Array)
        return event.forEach(function(ev) {
          return bind(element2, ev, handler, options);
        });
      if (element2 instanceof Array)
        return element2.forEach(function(el) {
          return bind(el, event, handler, options);
        });
      element2.addEventListener(event, handler, options);
      self2._handlers.push({
        remove: function() {
          return element2.removeEventListener(event, handler, options);
        }
      });
    }
    function triggerChange() {
      triggerEvent("onChange");
    }
    function bindEvents() {
      if (self2.config.wrap) {
        ["open", "close", "toggle", "clear"].forEach(function(evt) {
          Array.prototype.forEach.call(self2.element.querySelectorAll("[data-" + evt + "]"), function(el) {
            return bind(el, "click", self2[evt]);
          });
        });
      }
      if (self2.isMobile) {
        setupMobile();
        return;
      }
      var debouncedResize = debounce(onResize, 50);
      self2._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
      if (self2.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
        bind(self2.daysContainer, "mouseover", function(e) {
          if (self2.config.mode === "range")
            onMouseOver(getEventTarget(e));
        });
      bind(self2._input, "keydown", onKeyDown);
      if (self2.calendarContainer !== void 0) {
        bind(self2.calendarContainer, "keydown", onKeyDown);
      }
      if (!self2.config.inline && !self2.config.static)
        bind(window, "resize", debouncedResize);
      if (window.ontouchstart !== void 0)
        bind(window.document, "touchstart", documentClick);
      else
        bind(window.document, "mousedown", documentClick);
      bind(window.document, "focus", documentClick, { capture: true });
      if (self2.config.clickOpens === true) {
        bind(self2._input, "focus", self2.open);
        bind(self2._input, "click", self2.open);
      }
      if (self2.daysContainer !== void 0) {
        bind(self2.monthNav, "click", onMonthNavClick);
        bind(self2.monthNav, ["keyup", "increment"], onYearInput);
        bind(self2.daysContainer, "click", selectDate);
      }
      if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0) {
        var selText = function(e) {
          return getEventTarget(e).select();
        };
        bind(self2.timeContainer, ["increment"], updateTime);
        bind(self2.timeContainer, "blur", updateTime, { capture: true });
        bind(self2.timeContainer, "click", timeIncrement);
        bind([self2.hourElement, self2.minuteElement], ["focus", "click"], selText);
        if (self2.secondElement !== void 0)
          bind(self2.secondElement, "focus", function() {
            return self2.secondElement && self2.secondElement.select();
          });
        if (self2.amPM !== void 0) {
          bind(self2.amPM, "click", function(e) {
            updateTime(e);
          });
        }
      }
      if (self2.config.allowInput) {
        bind(self2._input, "blur", onBlur);
      }
    }
    function jumpToDate(jumpDate, triggerChange2) {
      var jumpTo = jumpDate !== void 0 ? self2.parseDate(jumpDate) : self2.latestSelectedDateObj || (self2.config.minDate && self2.config.minDate > self2.now ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate < self2.now ? self2.config.maxDate : self2.now);
      var oldYear = self2.currentYear;
      var oldMonth = self2.currentMonth;
      try {
        if (jumpTo !== void 0) {
          self2.currentYear = jumpTo.getFullYear();
          self2.currentMonth = jumpTo.getMonth();
        }
      } catch (e) {
        e.message = "Invalid date supplied: " + jumpTo;
        self2.config.errorHandler(e);
      }
      if (triggerChange2 && self2.currentYear !== oldYear) {
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }
      if (triggerChange2 && (self2.currentYear !== oldYear || self2.currentMonth !== oldMonth)) {
        triggerEvent("onMonthChange");
      }
      self2.redraw();
    }
    function timeIncrement(e) {
      var eventTarget = getEventTarget(e);
      if (~eventTarget.className.indexOf("arrow"))
        incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
      var target = e && getEventTarget(e);
      var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
      var event = createEvent("increment");
      event.delta = delta;
      input && input.dispatchEvent(event);
    }
    function build() {
      var fragment = window.document.createDocumentFragment();
      self2.calendarContainer = createElement("div", "flatpickr-calendar");
      self2.calendarContainer.tabIndex = -1;
      if (!self2.config.noCalendar) {
        fragment.appendChild(buildMonthNav());
        self2.innerContainer = createElement("div", "flatpickr-innerContainer");
        if (self2.config.weekNumbers) {
          var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
          self2.innerContainer.appendChild(weekWrapper);
          self2.weekNumbers = weekNumbers;
          self2.weekWrapper = weekWrapper;
        }
        self2.rContainer = createElement("div", "flatpickr-rContainer");
        self2.rContainer.appendChild(buildWeekdays());
        if (!self2.daysContainer) {
          self2.daysContainer = createElement("div", "flatpickr-days");
          self2.daysContainer.tabIndex = -1;
        }
        buildDays();
        self2.rContainer.appendChild(self2.daysContainer);
        self2.innerContainer.appendChild(self2.rContainer);
        fragment.appendChild(self2.innerContainer);
      }
      if (self2.config.enableTime) {
        fragment.appendChild(buildTime());
      }
      toggleClass2(self2.calendarContainer, "rangeMode", self2.config.mode === "range");
      toggleClass2(self2.calendarContainer, "animate", self2.config.animate === true);
      toggleClass2(self2.calendarContainer, "multiMonth", self2.config.showMonths > 1);
      self2.calendarContainer.appendChild(fragment);
      var customAppend = self2.config.appendTo !== void 0 && self2.config.appendTo.nodeType !== void 0;
      if (self2.config.inline || self2.config.static) {
        self2.calendarContainer.classList.add(self2.config.inline ? "inline" : "static");
        if (self2.config.inline) {
          if (!customAppend && self2.element.parentNode)
            self2.element.parentNode.insertBefore(self2.calendarContainer, self2._input.nextSibling);
          else if (self2.config.appendTo !== void 0)
            self2.config.appendTo.appendChild(self2.calendarContainer);
        }
        if (self2.config.static) {
          var wrapper = createElement("div", "flatpickr-wrapper");
          if (self2.element.parentNode)
            self2.element.parentNode.insertBefore(wrapper, self2.element);
          wrapper.appendChild(self2.element);
          if (self2.altInput)
            wrapper.appendChild(self2.altInput);
          wrapper.appendChild(self2.calendarContainer);
        }
      }
      if (!self2.config.static && !self2.config.inline)
        (self2.config.appendTo !== void 0 ? self2.config.appendTo : window.document.body).appendChild(self2.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
      var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", className, date.getDate().toString());
      dayElement.dateObj = date;
      dayElement.$i = i;
      dayElement.setAttribute("aria-label", self2.formatDate(date, self2.config.ariaDateFormat));
      if (className.indexOf("hidden") === -1 && compareDates(date, self2.now) === 0) {
        self2.todayDateElem = dayElement;
        dayElement.classList.add("today");
        dayElement.setAttribute("aria-current", "date");
      }
      if (dateIsEnabled) {
        dayElement.tabIndex = -1;
        if (isDateSelected(date)) {
          dayElement.classList.add("selected");
          self2.selectedDateElem = dayElement;
          if (self2.config.mode === "range") {
            toggleClass2(dayElement, "startRange", self2.selectedDates[0] && compareDates(date, self2.selectedDates[0], true) === 0);
            toggleClass2(dayElement, "endRange", self2.selectedDates[1] && compareDates(date, self2.selectedDates[1], true) === 0);
            if (className === "nextMonthDay")
              dayElement.classList.add("inRange");
          }
        }
      } else {
        dayElement.classList.add("flatpickr-disabled");
      }
      if (self2.config.mode === "range") {
        if (isDateInRange(date) && !isDateSelected(date))
          dayElement.classList.add("inRange");
      }
      if (self2.weekNumbers && self2.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) {
        self2.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self2.config.getWeek(date) + "</span>");
      }
      triggerEvent("onDayCreate", dayElement);
      return dayElement;
    }
    function focusOnDayElem(targetNode) {
      targetNode.focus();
      if (self2.config.mode === "range")
        onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
      var startMonth = delta > 0 ? 0 : self2.config.showMonths - 1;
      var endMonth = delta > 0 ? self2.config.showMonths : -1;
      for (var m = startMonth; m != endMonth; m += delta) {
        var month = self2.daysContainer.children[m];
        var startIndex = delta > 0 ? 0 : month.children.length - 1;
        var endIndex = delta > 0 ? month.children.length : -1;
        for (var i = startIndex; i != endIndex; i += delta) {
          var c = month.children[i];
          if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
            return c;
        }
      }
      return void 0;
    }
    function getNextAvailableDay(current, delta) {
      var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self2.currentMonth;
      var endMonth = delta > 0 ? self2.config.showMonths : -1;
      var loopDelta = delta > 0 ? 1 : -1;
      for (var m = givenMonth - self2.currentMonth; m != endMonth; m += loopDelta) {
        var month = self2.daysContainer.children[m];
        var startIndex = givenMonth - self2.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
        var numMonthDays = month.children.length;
        for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
          var c = month.children[i];
          if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta))
            return focusOnDayElem(c);
        }
      }
      self2.changeMonth(loopDelta);
      focusOnDay(getFirstAvailableDay(loopDelta), 0);
      return void 0;
    }
    function focusOnDay(current, offset) {
      var activeElement = getClosestActiveElement();
      var dayFocused = isInView(activeElement || document.body);
      var startElem = current !== void 0 ? current : dayFocused ? activeElement : self2.selectedDateElem !== void 0 && isInView(self2.selectedDateElem) ? self2.selectedDateElem : self2.todayDateElem !== void 0 && isInView(self2.todayDateElem) ? self2.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
      if (startElem === void 0) {
        self2._input.focus();
      } else if (!dayFocused) {
        focusOnDayElem(startElem);
      } else {
        getNextAvailableDay(startElem, offset);
      }
    }
    function buildMonthDays(year, month) {
      var firstOfMonth = (new Date(year, month, 1).getDay() - self2.l10n.firstDayOfWeek + 7) % 7;
      var prevMonthDays = self2.utils.getDaysInMonth((month - 1 + 12) % 12, year);
      var daysInMonth = self2.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self2.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
      var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
      for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
        days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
      }
      for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
        days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
      }
      for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self2.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
        days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
      }
      var dayContainer = createElement("div", "dayContainer");
      dayContainer.appendChild(days);
      return dayContainer;
    }
    function buildDays() {
      if (self2.daysContainer === void 0) {
        return;
      }
      clearNode(self2.daysContainer);
      if (self2.weekNumbers)
        clearNode(self2.weekNumbers);
      var frag = document.createDocumentFragment();
      for (var i = 0; i < self2.config.showMonths; i++) {
        var d = new Date(self2.currentYear, self2.currentMonth, 1);
        d.setMonth(self2.currentMonth + i);
        frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
      }
      self2.daysContainer.appendChild(frag);
      self2.days = self2.daysContainer.firstChild;
      if (self2.config.mode === "range" && self2.selectedDates.length === 1) {
        onMouseOver();
      }
    }
    function buildMonthSwitch() {
      if (self2.config.showMonths > 1 || self2.config.monthSelectorType !== "dropdown")
        return;
      var shouldBuildMonth = function(month2) {
        if (self2.config.minDate !== void 0 && self2.currentYear === self2.config.minDate.getFullYear() && month2 < self2.config.minDate.getMonth()) {
          return false;
        }
        return !(self2.config.maxDate !== void 0 && self2.currentYear === self2.config.maxDate.getFullYear() && month2 > self2.config.maxDate.getMonth());
      };
      self2.monthsDropdownContainer.tabIndex = -1;
      self2.monthsDropdownContainer.innerHTML = "";
      for (var i = 0; i < 12; i++) {
        if (!shouldBuildMonth(i))
          continue;
        var month = createElement("option", "flatpickr-monthDropdown-month");
        month.value = new Date(self2.currentYear, i).getMonth().toString();
        month.textContent = monthToStr(i, self2.config.shorthandCurrentMonth, self2.l10n);
        month.tabIndex = -1;
        if (self2.currentMonth === i) {
          month.selected = true;
        }
        self2.monthsDropdownContainer.appendChild(month);
      }
    }
    function buildMonth() {
      var container = createElement("div", "flatpickr-month");
      var monthNavFragment = window.document.createDocumentFragment();
      var monthElement;
      if (self2.config.showMonths > 1 || self2.config.monthSelectorType === "static") {
        monthElement = createElement("span", "cur-month");
      } else {
        self2.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
        self2.monthsDropdownContainer.setAttribute("aria-label", self2.l10n.monthAriaLabel);
        bind(self2.monthsDropdownContainer, "change", function(e) {
          var target = getEventTarget(e);
          var selectedMonth = parseInt(target.value, 10);
          self2.changeMonth(selectedMonth - self2.currentMonth);
          triggerEvent("onMonthChange");
        });
        buildMonthSwitch();
        monthElement = self2.monthsDropdownContainer;
      }
      var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
      var yearElement = yearInput.getElementsByTagName("input")[0];
      yearElement.setAttribute("aria-label", self2.l10n.yearAriaLabel);
      if (self2.config.minDate) {
        yearElement.setAttribute("min", self2.config.minDate.getFullYear().toString());
      }
      if (self2.config.maxDate) {
        yearElement.setAttribute("max", self2.config.maxDate.getFullYear().toString());
        yearElement.disabled = !!self2.config.minDate && self2.config.minDate.getFullYear() === self2.config.maxDate.getFullYear();
      }
      var currentMonth = createElement("div", "flatpickr-current-month");
      currentMonth.appendChild(monthElement);
      currentMonth.appendChild(yearInput);
      monthNavFragment.appendChild(currentMonth);
      container.appendChild(monthNavFragment);
      return {
        container,
        yearElement,
        monthElement
      };
    }
    function buildMonths() {
      clearNode(self2.monthNav);
      self2.monthNav.appendChild(self2.prevMonthNav);
      if (self2.config.showMonths) {
        self2.yearElements = [];
        self2.monthElements = [];
      }
      for (var m = self2.config.showMonths; m--; ) {
        var month = buildMonth();
        self2.yearElements.push(month.yearElement);
        self2.monthElements.push(month.monthElement);
        self2.monthNav.appendChild(month.container);
      }
      self2.monthNav.appendChild(self2.nextMonthNav);
    }
    function buildMonthNav() {
      self2.monthNav = createElement("div", "flatpickr-months");
      self2.yearElements = [];
      self2.monthElements = [];
      self2.prevMonthNav = createElement("span", "flatpickr-prev-month");
      self2.prevMonthNav.innerHTML = self2.config.prevArrow;
      self2.nextMonthNav = createElement("span", "flatpickr-next-month");
      self2.nextMonthNav.innerHTML = self2.config.nextArrow;
      buildMonths();
      Object.defineProperty(self2, "_hidePrevMonthArrow", {
        get: function() {
          return self2.__hidePrevMonthArrow;
        },
        set: function(bool) {
          if (self2.__hidePrevMonthArrow !== bool) {
            toggleClass2(self2.prevMonthNav, "flatpickr-disabled", bool);
            self2.__hidePrevMonthArrow = bool;
          }
        }
      });
      Object.defineProperty(self2, "_hideNextMonthArrow", {
        get: function() {
          return self2.__hideNextMonthArrow;
        },
        set: function(bool) {
          if (self2.__hideNextMonthArrow !== bool) {
            toggleClass2(self2.nextMonthNav, "flatpickr-disabled", bool);
            self2.__hideNextMonthArrow = bool;
          }
        }
      });
      self2.currentYearElement = self2.yearElements[0];
      updateNavigationCurrentMonth();
      return self2.monthNav;
    }
    function buildTime() {
      self2.calendarContainer.classList.add("hasTime");
      if (self2.config.noCalendar)
        self2.calendarContainer.classList.add("noCalendar");
      var defaults2 = getDefaultHours(self2.config);
      self2.timeContainer = createElement("div", "flatpickr-time");
      self2.timeContainer.tabIndex = -1;
      var separator = createElement("span", "flatpickr-time-separator", ":");
      var hourInput = createNumberInput("flatpickr-hour", {
        "aria-label": self2.l10n.hourAriaLabel
      });
      self2.hourElement = hourInput.getElementsByTagName("input")[0];
      var minuteInput = createNumberInput("flatpickr-minute", {
        "aria-label": self2.l10n.minuteAriaLabel
      });
      self2.minuteElement = minuteInput.getElementsByTagName("input")[0];
      self2.hourElement.tabIndex = self2.minuteElement.tabIndex = -1;
      self2.hourElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getHours() : self2.config.time_24hr ? defaults2.hours : military2ampm(defaults2.hours));
      self2.minuteElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getMinutes() : defaults2.minutes);
      self2.hourElement.setAttribute("step", self2.config.hourIncrement.toString());
      self2.minuteElement.setAttribute("step", self2.config.minuteIncrement.toString());
      self2.hourElement.setAttribute("min", self2.config.time_24hr ? "0" : "1");
      self2.hourElement.setAttribute("max", self2.config.time_24hr ? "23" : "12");
      self2.hourElement.setAttribute("maxlength", "2");
      self2.minuteElement.setAttribute("min", "0");
      self2.minuteElement.setAttribute("max", "59");
      self2.minuteElement.setAttribute("maxlength", "2");
      self2.timeContainer.appendChild(hourInput);
      self2.timeContainer.appendChild(separator);
      self2.timeContainer.appendChild(minuteInput);
      if (self2.config.time_24hr)
        self2.timeContainer.classList.add("time24hr");
      if (self2.config.enableSeconds) {
        self2.timeContainer.classList.add("hasSeconds");
        var secondInput = createNumberInput("flatpickr-second");
        self2.secondElement = secondInput.getElementsByTagName("input")[0];
        self2.secondElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getSeconds() : defaults2.seconds);
        self2.secondElement.setAttribute("step", self2.minuteElement.getAttribute("step"));
        self2.secondElement.setAttribute("min", "0");
        self2.secondElement.setAttribute("max", "59");
        self2.secondElement.setAttribute("maxlength", "2");
        self2.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
        self2.timeContainer.appendChild(secondInput);
      }
      if (!self2.config.time_24hr) {
        self2.amPM = createElement("span", "flatpickr-am-pm", self2.l10n.amPM[int((self2.latestSelectedDateObj ? self2.hourElement.value : self2.config.defaultHour) > 11)]);
        self2.amPM.title = self2.l10n.toggleTitle;
        self2.amPM.tabIndex = -1;
        self2.timeContainer.appendChild(self2.amPM);
      }
      return self2.timeContainer;
    }
    function buildWeekdays() {
      if (!self2.weekdayContainer)
        self2.weekdayContainer = createElement("div", "flatpickr-weekdays");
      else
        clearNode(self2.weekdayContainer);
      for (var i = self2.config.showMonths; i--; ) {
        var container = createElement("div", "flatpickr-weekdaycontainer");
        self2.weekdayContainer.appendChild(container);
      }
      updateWeekdays();
      return self2.weekdayContainer;
    }
    function updateWeekdays() {
      if (!self2.weekdayContainer) {
        return;
      }
      var firstDayOfWeek = self2.l10n.firstDayOfWeek;
      var weekdays = __spreadArrays2(self2.l10n.weekdays.shorthand);
      if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
        weekdays = __spreadArrays2(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
      }
      for (var i = self2.config.showMonths; i--; ) {
        self2.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
      }
    }
    function buildWeeks() {
      self2.calendarContainer.classList.add("hasWeeks");
      var weekWrapper = createElement("div", "flatpickr-weekwrapper");
      weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self2.l10n.weekAbbreviation));
      var weekNumbers = createElement("div", "flatpickr-weeks");
      weekWrapper.appendChild(weekNumbers);
      return {
        weekWrapper,
        weekNumbers
      };
    }
    function changeMonth(value, isOffset) {
      if (isOffset === void 0) {
        isOffset = true;
      }
      var delta = isOffset ? value : value - self2.currentMonth;
      if (delta < 0 && self2._hidePrevMonthArrow === true || delta > 0 && self2._hideNextMonthArrow === true)
        return;
      self2.currentMonth += delta;
      if (self2.currentMonth < 0 || self2.currentMonth > 11) {
        self2.currentYear += self2.currentMonth > 11 ? 1 : -1;
        self2.currentMonth = (self2.currentMonth + 12) % 12;
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }
      buildDays();
      triggerEvent("onMonthChange");
      updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
      if (triggerChangeEvent === void 0) {
        triggerChangeEvent = true;
      }
      if (toInitial === void 0) {
        toInitial = true;
      }
      self2.input.value = "";
      if (self2.altInput !== void 0)
        self2.altInput.value = "";
      if (self2.mobileInput !== void 0)
        self2.mobileInput.value = "";
      self2.selectedDates = [];
      self2.latestSelectedDateObj = void 0;
      if (toInitial === true) {
        self2.currentYear = self2._initialDate.getFullYear();
        self2.currentMonth = self2._initialDate.getMonth();
      }
      if (self2.config.enableTime === true) {
        var _a = getDefaultHours(self2.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
        setHours(hours, minutes, seconds);
      }
      self2.redraw();
      if (triggerChangeEvent)
        triggerEvent("onChange");
    }
    function close() {
      self2.isOpen = false;
      if (!self2.isMobile) {
        if (self2.calendarContainer !== void 0) {
          self2.calendarContainer.classList.remove("open");
        }
        if (self2._input !== void 0) {
          self2._input.classList.remove("active");
        }
      }
      triggerEvent("onClose");
    }
    function destroy() {
      if (self2.config !== void 0)
        triggerEvent("onDestroy");
      for (var i = self2._handlers.length; i--; ) {
        self2._handlers[i].remove();
      }
      self2._handlers = [];
      if (self2.mobileInput) {
        if (self2.mobileInput.parentNode)
          self2.mobileInput.parentNode.removeChild(self2.mobileInput);
        self2.mobileInput = void 0;
      } else if (self2.calendarContainer && self2.calendarContainer.parentNode) {
        if (self2.config.static && self2.calendarContainer.parentNode) {
          var wrapper = self2.calendarContainer.parentNode;
          wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
          if (wrapper.parentNode) {
            while (wrapper.firstChild)
              wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
            wrapper.parentNode.removeChild(wrapper);
          }
        } else
          self2.calendarContainer.parentNode.removeChild(self2.calendarContainer);
      }
      if (self2.altInput) {
        self2.input.type = "text";
        if (self2.altInput.parentNode)
          self2.altInput.parentNode.removeChild(self2.altInput);
        delete self2.altInput;
      }
      if (self2.input) {
        self2.input.type = self2.input._type;
        self2.input.classList.remove("flatpickr-input");
        self2.input.removeAttribute("readonly");
      }
      [
        "_showTimeInput",
        "latestSelectedDateObj",
        "_hideNextMonthArrow",
        "_hidePrevMonthArrow",
        "__hideNextMonthArrow",
        "__hidePrevMonthArrow",
        "isMobile",
        "isOpen",
        "selectedDateElem",
        "minDateHasTime",
        "maxDateHasTime",
        "days",
        "daysContainer",
        "_input",
        "_positionElement",
        "innerContainer",
        "rContainer",
        "monthNav",
        "todayDateElem",
        "calendarContainer",
        "weekdayContainer",
        "prevMonthNav",
        "nextMonthNav",
        "monthsDropdownContainer",
        "currentMonthElement",
        "currentYearElement",
        "navigationCurrentMonth",
        "selectedDateElem",
        "config"
      ].forEach(function(k) {
        try {
          delete self2[k];
        } catch (_) {
        }
      });
    }
    function isCalendarElem(elem) {
      return self2.calendarContainer.contains(elem);
    }
    function documentClick(e) {
      if (self2.isOpen && !self2.config.inline) {
        var eventTarget_1 = getEventTarget(e);
        var isCalendarElement = isCalendarElem(eventTarget_1);
        var isInput = eventTarget_1 === self2.input || eventTarget_1 === self2.altInput || self2.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self2.input) || ~e.path.indexOf(self2.altInput));
        var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
        var isIgnored = !self2.config.ignoredFocusElements.some(function(elem) {
          return elem.contains(eventTarget_1);
        });
        if (lostFocus && isIgnored) {
          if (self2.config.allowInput) {
            self2.setDate(self2._input.value, false, self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
          }
          if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0 && self2.input.value !== "" && self2.input.value !== void 0) {
            updateTime();
          }
          self2.close();
          if (self2.config && self2.config.mode === "range" && self2.selectedDates.length === 1)
            self2.clear(false);
        }
      }
    }
    function changeYear(newYear) {
      if (!newYear || self2.config.minDate && newYear < self2.config.minDate.getFullYear() || self2.config.maxDate && newYear > self2.config.maxDate.getFullYear())
        return;
      var newYearNum = newYear, isNewYear = self2.currentYear !== newYearNum;
      self2.currentYear = newYearNum || self2.currentYear;
      if (self2.config.maxDate && self2.currentYear === self2.config.maxDate.getFullYear()) {
        self2.currentMonth = Math.min(self2.config.maxDate.getMonth(), self2.currentMonth);
      } else if (self2.config.minDate && self2.currentYear === self2.config.minDate.getFullYear()) {
        self2.currentMonth = Math.max(self2.config.minDate.getMonth(), self2.currentMonth);
      }
      if (isNewYear) {
        self2.redraw();
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }
    }
    function isEnabled(date, timeless) {
      var _a;
      if (timeless === void 0) {
        timeless = true;
      }
      var dateToCheck = self2.parseDate(date, void 0, timeless);
      if (self2.config.minDate && dateToCheck && compareDates(dateToCheck, self2.config.minDate, timeless !== void 0 ? timeless : !self2.minDateHasTime) < 0 || self2.config.maxDate && dateToCheck && compareDates(dateToCheck, self2.config.maxDate, timeless !== void 0 ? timeless : !self2.maxDateHasTime) > 0)
        return false;
      if (!self2.config.enable && self2.config.disable.length === 0)
        return true;
      if (dateToCheck === void 0)
        return false;
      var bool = !!self2.config.enable, array = (_a = self2.config.enable) !== null && _a !== void 0 ? _a : self2.config.disable;
      for (var i = 0, d = void 0; i < array.length; i++) {
        d = array[i];
        if (typeof d === "function" && d(dateToCheck))
          return bool;
        else if (d instanceof Date && dateToCheck !== void 0 && d.getTime() === dateToCheck.getTime())
          return bool;
        else if (typeof d === "string") {
          var parsed = self2.parseDate(d, void 0, true);
          return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
        } else if (typeof d === "object" && dateToCheck !== void 0 && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime())
          return bool;
      }
      return !bool;
    }
    function isInView(elem) {
      if (self2.daysContainer !== void 0)
        return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self2.daysContainer.contains(elem);
      return false;
    }
    function onBlur(e) {
      var isInput = e.target === self2._input;
      var valueChanged = self2._input.value.trimEnd() !== getDateStr();
      if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
        self2.setDate(self2._input.value, true, e.target === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
      }
    }
    function onKeyDown(e) {
      var eventTarget = getEventTarget(e);
      var isInput = self2.config.wrap ? element.contains(eventTarget) : eventTarget === self2._input;
      var allowInput = self2.config.allowInput;
      var allowKeydown = self2.isOpen && (!allowInput || !isInput);
      var allowInlineKeydown = self2.config.inline && isInput && !allowInput;
      if (e.keyCode === 13 && isInput) {
        if (allowInput) {
          self2.setDate(self2._input.value, true, eventTarget === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
          self2.close();
          return eventTarget.blur();
        } else {
          self2.open();
        }
      } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
        var isTimeObj = !!self2.timeContainer && self2.timeContainer.contains(eventTarget);
        switch (e.keyCode) {
          case 13:
            if (isTimeObj) {
              e.preventDefault();
              updateTime();
              focusAndClose();
            } else
              selectDate(e);
            break;
          case 27:
            e.preventDefault();
            focusAndClose();
            break;
          case 8:
          case 46:
            if (isInput && !self2.config.allowInput) {
              e.preventDefault();
              self2.clear();
            }
            break;
          case 37:
          case 39:
            if (!isTimeObj && !isInput) {
              e.preventDefault();
              var activeElement = getClosestActiveElement();
              if (self2.daysContainer !== void 0 && (allowInput === false || activeElement && isInView(activeElement))) {
                var delta_1 = e.keyCode === 39 ? 1 : -1;
                if (!e.ctrlKey)
                  focusOnDay(void 0, delta_1);
                else {
                  e.stopPropagation();
                  changeMonth(delta_1);
                  focusOnDay(getFirstAvailableDay(1), 0);
                }
              }
            } else if (self2.hourElement)
              self2.hourElement.focus();
            break;
          case 38:
          case 40:
            e.preventDefault();
            var delta = e.keyCode === 40 ? 1 : -1;
            if (self2.daysContainer && eventTarget.$i !== void 0 || eventTarget === self2.input || eventTarget === self2.altInput) {
              if (e.ctrlKey) {
                e.stopPropagation();
                changeYear(self2.currentYear - delta);
                focusOnDay(getFirstAvailableDay(1), 0);
              } else if (!isTimeObj)
                focusOnDay(void 0, delta * 7);
            } else if (eventTarget === self2.currentYearElement) {
              changeYear(self2.currentYear - delta);
            } else if (self2.config.enableTime) {
              if (!isTimeObj && self2.hourElement)
                self2.hourElement.focus();
              updateTime(e);
              self2._debouncedChange();
            }
            break;
          case 9:
            if (isTimeObj) {
              var elems = [
                self2.hourElement,
                self2.minuteElement,
                self2.secondElement,
                self2.amPM
              ].concat(self2.pluginElements).filter(function(x) {
                return x;
              });
              var i = elems.indexOf(eventTarget);
              if (i !== -1) {
                var target = elems[i + (e.shiftKey ? -1 : 1)];
                e.preventDefault();
                (target || self2._input).focus();
              }
            } else if (!self2.config.noCalendar && self2.daysContainer && self2.daysContainer.contains(eventTarget) && e.shiftKey) {
              e.preventDefault();
              self2._input.focus();
            }
            break;
          default:
            break;
        }
      }
      if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
        switch (e.key) {
          case self2.l10n.amPM[0].charAt(0):
          case self2.l10n.amPM[0].charAt(0).toLowerCase():
            self2.amPM.textContent = self2.l10n.amPM[0];
            setHoursFromInputs();
            updateValue();
            break;
          case self2.l10n.amPM[1].charAt(0):
          case self2.l10n.amPM[1].charAt(0).toLowerCase():
            self2.amPM.textContent = self2.l10n.amPM[1];
            setHoursFromInputs();
            updateValue();
            break;
        }
      }
      if (isInput || isCalendarElem(eventTarget)) {
        triggerEvent("onKeyDown", e);
      }
    }
    function onMouseOver(elem, cellClass) {
      if (cellClass === void 0) {
        cellClass = "flatpickr-day";
      }
      if (self2.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled")))
        return;
      var hoverDate = elem ? elem.dateObj.getTime() : self2.days.firstElementChild.dateObj.getTime(), initialDate = self2.parseDate(self2.selectedDates[0], void 0, true).getTime(), rangeStartDate = Math.min(hoverDate, self2.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self2.selectedDates[0].getTime());
      var containsDisabled = false;
      var minRange = 0, maxRange = 0;
      for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
        if (!isEnabled(new Date(t), true)) {
          containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
          if (t < initialDate && (!minRange || t > minRange))
            minRange = t;
          else if (t > initialDate && (!maxRange || t < maxRange))
            maxRange = t;
        }
      }
      var hoverableCells = Array.from(self2.rContainer.querySelectorAll("*:nth-child(-n+" + self2.config.showMonths + ") > ." + cellClass));
      hoverableCells.forEach(function(dayElem) {
        var date = dayElem.dateObj;
        var timestamp = date.getTime();
        var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
        if (outOfRange) {
          dayElem.classList.add("notAllowed");
          ["inRange", "startRange", "endRange"].forEach(function(c) {
            dayElem.classList.remove(c);
          });
          return;
        } else if (containsDisabled && !outOfRange)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(c) {
          dayElem.classList.remove(c);
        });
        if (elem !== void 0) {
          elem.classList.add(hoverDate <= self2.selectedDates[0].getTime() ? "startRange" : "endRange");
          if (initialDate < hoverDate && timestamp === initialDate)
            dayElem.classList.add("startRange");
          else if (initialDate > hoverDate && timestamp === initialDate)
            dayElem.classList.add("endRange");
          if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate))
            dayElem.classList.add("inRange");
        }
      });
    }
    function onResize() {
      if (self2.isOpen && !self2.config.static && !self2.config.inline)
        positionCalendar();
    }
    function open(e, positionElement) {
      if (positionElement === void 0) {
        positionElement = self2._positionElement;
      }
      if (self2.isMobile === true) {
        if (e) {
          e.preventDefault();
          var eventTarget = getEventTarget(e);
          if (eventTarget) {
            eventTarget.blur();
          }
        }
        if (self2.mobileInput !== void 0) {
          self2.mobileInput.focus();
          self2.mobileInput.click();
        }
        triggerEvent("onOpen");
        return;
      } else if (self2._input.disabled || self2.config.inline) {
        return;
      }
      var wasOpen = self2.isOpen;
      self2.isOpen = true;
      if (!wasOpen) {
        self2.calendarContainer.classList.add("open");
        self2._input.classList.add("active");
        triggerEvent("onOpen");
        positionCalendar(positionElement);
      }
      if (self2.config.enableTime === true && self2.config.noCalendar === true) {
        if (self2.config.allowInput === false && (e === void 0 || !self2.timeContainer.contains(e.relatedTarget))) {
          setTimeout(function() {
            return self2.hourElement.select();
          }, 50);
        }
      }
    }
    function minMaxDateSetter(type) {
      return function(date) {
        var dateObj = self2.config["_" + type + "Date"] = self2.parseDate(date, self2.config.dateFormat);
        var inverseDateObj = self2.config["_" + (type === "min" ? "max" : "min") + "Date"];
        if (dateObj !== void 0) {
          self2[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
        }
        if (self2.selectedDates) {
          self2.selectedDates = self2.selectedDates.filter(function(d) {
            return isEnabled(d);
          });
          if (!self2.selectedDates.length && type === "min")
            setHoursFromDate(dateObj);
          updateValue();
        }
        if (self2.daysContainer) {
          redraw();
          if (dateObj !== void 0)
            self2.currentYearElement[type] = dateObj.getFullYear().toString();
          else
            self2.currentYearElement.removeAttribute(type);
          self2.currentYearElement.disabled = !!inverseDateObj && dateObj !== void 0 && inverseDateObj.getFullYear() === dateObj.getFullYear();
        }
      };
    }
    function parseConfig() {
      var boolOpts = [
        "wrap",
        "weekNumbers",
        "allowInput",
        "allowInvalidPreload",
        "clickOpens",
        "time_24hr",
        "enableTime",
        "noCalendar",
        "altInput",
        "shorthandCurrentMonth",
        "inline",
        "static",
        "enableSeconds",
        "disableMobile"
      ];
      var userConfig = __assign2(__assign2({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
      var formats2 = {};
      self2.config.parseDate = userConfig.parseDate;
      self2.config.formatDate = userConfig.formatDate;
      Object.defineProperty(self2.config, "enable", {
        get: function() {
          return self2.config._enable;
        },
        set: function(dates) {
          self2.config._enable = parseDateRules(dates);
        }
      });
      Object.defineProperty(self2.config, "disable", {
        get: function() {
          return self2.config._disable;
        },
        set: function(dates) {
          self2.config._disable = parseDateRules(dates);
        }
      });
      var timeMode = userConfig.mode === "time";
      if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
        var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
        formats2.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
      }
      if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
        var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
        formats2.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
      }
      Object.defineProperty(self2.config, "minDate", {
        get: function() {
          return self2.config._minDate;
        },
        set: minMaxDateSetter("min")
      });
      Object.defineProperty(self2.config, "maxDate", {
        get: function() {
          return self2.config._maxDate;
        },
        set: minMaxDateSetter("max")
      });
      var minMaxTimeSetter = function(type) {
        return function(val) {
          self2.config[type === "min" ? "_minTime" : "_maxTime"] = self2.parseDate(val, "H:i:S");
        };
      };
      Object.defineProperty(self2.config, "minTime", {
        get: function() {
          return self2.config._minTime;
        },
        set: minMaxTimeSetter("min")
      });
      Object.defineProperty(self2.config, "maxTime", {
        get: function() {
          return self2.config._maxTime;
        },
        set: minMaxTimeSetter("max")
      });
      if (userConfig.mode === "time") {
        self2.config.noCalendar = true;
        self2.config.enableTime = true;
      }
      Object.assign(self2.config, formats2, userConfig);
      for (var i = 0; i < boolOpts.length; i++)
        self2.config[boolOpts[i]] = self2.config[boolOpts[i]] === true || self2.config[boolOpts[i]] === "true";
      HOOKS.filter(function(hook) {
        return self2.config[hook] !== void 0;
      }).forEach(function(hook) {
        self2.config[hook] = arrayify(self2.config[hook] || []).map(bindToInstance);
      });
      self2.isMobile = !self2.config.disableMobile && !self2.config.inline && self2.config.mode === "single" && !self2.config.disable.length && !self2.config.enable && !self2.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      for (var i = 0; i < self2.config.plugins.length; i++) {
        var pluginConf = self2.config.plugins[i](self2) || {};
        for (var key in pluginConf) {
          if (HOOKS.indexOf(key) > -1) {
            self2.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self2.config[key]);
          } else if (typeof userConfig[key] === "undefined")
            self2.config[key] = pluginConf[key];
        }
      }
      if (!userConfig.altInputClass) {
        self2.config.altInputClass = getInputElem().className + " " + self2.config.altInputClass;
      }
      triggerEvent("onParseConfig");
    }
    function getInputElem() {
      return self2.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
      if (typeof self2.config.locale !== "object" && typeof flatpickr.l10ns[self2.config.locale] === "undefined")
        self2.config.errorHandler(new Error("flatpickr: invalid locale " + self2.config.locale));
      self2.l10n = __assign2(__assign2({}, flatpickr.l10ns.default), typeof self2.config.locale === "object" ? self2.config.locale : self2.config.locale !== "default" ? flatpickr.l10ns[self2.config.locale] : void 0);
      tokenRegex.D = "(" + self2.l10n.weekdays.shorthand.join("|") + ")";
      tokenRegex.l = "(" + self2.l10n.weekdays.longhand.join("|") + ")";
      tokenRegex.M = "(" + self2.l10n.months.shorthand.join("|") + ")";
      tokenRegex.F = "(" + self2.l10n.months.longhand.join("|") + ")";
      tokenRegex.K = "(" + self2.l10n.amPM[0] + "|" + self2.l10n.amPM[1] + "|" + self2.l10n.amPM[0].toLowerCase() + "|" + self2.l10n.amPM[1].toLowerCase() + ")";
      var userConfig = __assign2(__assign2({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
      if (userConfig.time_24hr === void 0 && flatpickr.defaultConfig.time_24hr === void 0) {
        self2.config.time_24hr = self2.l10n.time_24hr;
      }
      self2.formatDate = createDateFormatter(self2);
      self2.parseDate = createDateParser({ config: self2.config, l10n: self2.l10n });
    }
    function positionCalendar(customPositionElement) {
      if (typeof self2.config.position === "function") {
        return void self2.config.position(self2, customPositionElement);
      }
      if (self2.calendarContainer === void 0)
        return;
      triggerEvent("onPreCalendarPosition");
      var positionElement = customPositionElement || self2._positionElement;
      var calendarHeight = Array.prototype.reduce.call(self2.calendarContainer.children, function(acc, child) {
        return acc + child.offsetHeight;
      }, 0), calendarWidth = self2.calendarContainer.offsetWidth, configPos = self2.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
      var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
      toggleClass2(self2.calendarContainer, "arrowTop", !showOnTop);
      toggleClass2(self2.calendarContainer, "arrowBottom", showOnTop);
      if (self2.config.inline)
        return;
      var left = window.pageXOffset + inputBounds.left;
      var isCenter = false;
      var isRight = false;
      if (configPosHorizontal === "center") {
        left -= (calendarWidth - inputBounds.width) / 2;
        isCenter = true;
      } else if (configPosHorizontal === "right") {
        left -= calendarWidth - inputBounds.width;
        isRight = true;
      }
      toggleClass2(self2.calendarContainer, "arrowLeft", !isCenter && !isRight);
      toggleClass2(self2.calendarContainer, "arrowCenter", isCenter);
      toggleClass2(self2.calendarContainer, "arrowRight", isRight);
      var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
      var rightMost = left + calendarWidth > window.document.body.offsetWidth;
      var centerMost = right + calendarWidth > window.document.body.offsetWidth;
      toggleClass2(self2.calendarContainer, "rightMost", rightMost);
      if (self2.config.static)
        return;
      self2.calendarContainer.style.top = top + "px";
      if (!rightMost) {
        self2.calendarContainer.style.left = left + "px";
        self2.calendarContainer.style.right = "auto";
      } else if (!centerMost) {
        self2.calendarContainer.style.left = "auto";
        self2.calendarContainer.style.right = right + "px";
      } else {
        var doc = getDocumentStyleSheet();
        if (doc === void 0)
          return;
        var bodyWidth = window.document.body.offsetWidth;
        var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
        var centerBefore = ".flatpickr-calendar.centerMost:before";
        var centerAfter = ".flatpickr-calendar.centerMost:after";
        var centerIndex = doc.cssRules.length;
        var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
        toggleClass2(self2.calendarContainer, "rightMost", false);
        toggleClass2(self2.calendarContainer, "centerMost", true);
        doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
        self2.calendarContainer.style.left = centerLeft + "px";
        self2.calendarContainer.style.right = "auto";
      }
    }
    function getDocumentStyleSheet() {
      var editableSheet = null;
      for (var i = 0; i < document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i];
        if (!sheet.cssRules)
          continue;
        try {
          sheet.cssRules;
        } catch (err) {
          continue;
        }
        editableSheet = sheet;
        break;
      }
      return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return style.sheet;
    }
    function redraw() {
      if (self2.config.noCalendar || self2.isMobile)
        return;
      buildMonthSwitch();
      updateNavigationCurrentMonth();
      buildDays();
    }
    function focusAndClose() {
      self2._input.focus();
      if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0) {
        setTimeout(self2.close, 0);
      } else {
        self2.close();
      }
    }
    function selectDate(e) {
      e.preventDefault();
      e.stopPropagation();
      var isSelectable = function(day) {
        return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
      };
      var t = findParent(getEventTarget(e), isSelectable);
      if (t === void 0)
        return;
      var target = t;
      var selectedDate = self2.latestSelectedDateObj = new Date(target.dateObj.getTime());
      var shouldChangeMonth = (selectedDate.getMonth() < self2.currentMonth || selectedDate.getMonth() > self2.currentMonth + self2.config.showMonths - 1) && self2.config.mode !== "range";
      self2.selectedDateElem = target;
      if (self2.config.mode === "single")
        self2.selectedDates = [selectedDate];
      else if (self2.config.mode === "multiple") {
        var selectedIndex = isDateSelected(selectedDate);
        if (selectedIndex)
          self2.selectedDates.splice(parseInt(selectedIndex), 1);
        else
          self2.selectedDates.push(selectedDate);
      } else if (self2.config.mode === "range") {
        if (self2.selectedDates.length === 2) {
          self2.clear(false, false);
        }
        self2.latestSelectedDateObj = selectedDate;
        self2.selectedDates.push(selectedDate);
        if (compareDates(selectedDate, self2.selectedDates[0], true) !== 0)
          self2.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
          });
      }
      setHoursFromInputs();
      if (shouldChangeMonth) {
        var isNewYear = self2.currentYear !== selectedDate.getFullYear();
        self2.currentYear = selectedDate.getFullYear();
        self2.currentMonth = selectedDate.getMonth();
        if (isNewYear) {
          triggerEvent("onYearChange");
          buildMonthSwitch();
        }
        triggerEvent("onMonthChange");
      }
      updateNavigationCurrentMonth();
      buildDays();
      updateValue();
      if (!shouldChangeMonth && self2.config.mode !== "range" && self2.config.showMonths === 1)
        focusOnDayElem(target);
      else if (self2.selectedDateElem !== void 0 && self2.hourElement === void 0) {
        self2.selectedDateElem && self2.selectedDateElem.focus();
      }
      if (self2.hourElement !== void 0)
        self2.hourElement !== void 0 && self2.hourElement.focus();
      if (self2.config.closeOnSelect) {
        var single = self2.config.mode === "single" && !self2.config.enableTime;
        var range = self2.config.mode === "range" && self2.selectedDates.length === 2 && !self2.config.enableTime;
        if (single || range) {
          focusAndClose();
        }
      }
      triggerChange();
    }
    var CALLBACKS = {
      locale: [setupLocale, updateWeekdays],
      showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
      minDate: [jumpToDate],
      maxDate: [jumpToDate],
      positionElement: [updatePositionElement],
      clickOpens: [
        function() {
          if (self2.config.clickOpens === true) {
            bind(self2._input, "focus", self2.open);
            bind(self2._input, "click", self2.open);
          } else {
            self2._input.removeEventListener("focus", self2.open);
            self2._input.removeEventListener("click", self2.open);
          }
        }
      ]
    };
    function set(option, value) {
      if (option !== null && typeof option === "object") {
        Object.assign(self2.config, option);
        for (var key in option) {
          if (CALLBACKS[key] !== void 0)
            CALLBACKS[key].forEach(function(x) {
              return x();
            });
        }
      } else {
        self2.config[option] = value;
        if (CALLBACKS[option] !== void 0)
          CALLBACKS[option].forEach(function(x) {
            return x();
          });
        else if (HOOKS.indexOf(option) > -1)
          self2.config[option] = arrayify(value);
      }
      self2.redraw();
      updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
      var dates = [];
      if (inputDate instanceof Array)
        dates = inputDate.map(function(d) {
          return self2.parseDate(d, format);
        });
      else if (inputDate instanceof Date || typeof inputDate === "number")
        dates = [self2.parseDate(inputDate, format)];
      else if (typeof inputDate === "string") {
        switch (self2.config.mode) {
          case "single":
          case "time":
            dates = [self2.parseDate(inputDate, format)];
            break;
          case "multiple":
            dates = inputDate.split(self2.config.conjunction).map(function(date) {
              return self2.parseDate(date, format);
            });
            break;
          case "range":
            dates = inputDate.split(self2.l10n.rangeSeparator).map(function(date) {
              return self2.parseDate(date, format);
            });
            break;
          default:
            break;
        }
      } else
        self2.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
      self2.selectedDates = self2.config.allowInvalidPreload ? dates : dates.filter(function(d) {
        return d instanceof Date && isEnabled(d, false);
      });
      if (self2.config.mode === "range")
        self2.selectedDates.sort(function(a, b) {
          return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange2, format) {
      if (triggerChange2 === void 0) {
        triggerChange2 = false;
      }
      if (format === void 0) {
        format = self2.config.dateFormat;
      }
      if (date !== 0 && !date || date instanceof Array && date.length === 0)
        return self2.clear(triggerChange2);
      setSelectedDate(date, format);
      self2.latestSelectedDateObj = self2.selectedDates[self2.selectedDates.length - 1];
      self2.redraw();
      jumpToDate(void 0, triggerChange2);
      setHoursFromDate();
      if (self2.selectedDates.length === 0) {
        self2.clear(false);
      }
      updateValue(triggerChange2);
      if (triggerChange2)
        triggerEvent("onChange");
    }
    function parseDateRules(arr) {
      return arr.slice().map(function(rule) {
        if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
          return self2.parseDate(rule, void 0, true);
        } else if (rule && typeof rule === "object" && rule.from && rule.to)
          return {
            from: self2.parseDate(rule.from, void 0),
            to: self2.parseDate(rule.to, void 0)
          };
        return rule;
      }).filter(function(x) {
        return x;
      });
    }
    function setupDates() {
      self2.selectedDates = [];
      self2.now = self2.parseDate(self2.config.now) || new Date();
      var preloadedDate = self2.config.defaultDate || ((self2.input.nodeName === "INPUT" || self2.input.nodeName === "TEXTAREA") && self2.input.placeholder && self2.input.value === self2.input.placeholder ? null : self2.input.value);
      if (preloadedDate)
        setSelectedDate(preloadedDate, self2.config.dateFormat);
      self2._initialDate = self2.selectedDates.length > 0 ? self2.selectedDates[0] : self2.config.minDate && self2.config.minDate.getTime() > self2.now.getTime() ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate.getTime() < self2.now.getTime() ? self2.config.maxDate : self2.now;
      self2.currentYear = self2._initialDate.getFullYear();
      self2.currentMonth = self2._initialDate.getMonth();
      if (self2.selectedDates.length > 0)
        self2.latestSelectedDateObj = self2.selectedDates[0];
      if (self2.config.minTime !== void 0)
        self2.config.minTime = self2.parseDate(self2.config.minTime, "H:i");
      if (self2.config.maxTime !== void 0)
        self2.config.maxTime = self2.parseDate(self2.config.maxTime, "H:i");
      self2.minDateHasTime = !!self2.config.minDate && (self2.config.minDate.getHours() > 0 || self2.config.minDate.getMinutes() > 0 || self2.config.minDate.getSeconds() > 0);
      self2.maxDateHasTime = !!self2.config.maxDate && (self2.config.maxDate.getHours() > 0 || self2.config.maxDate.getMinutes() > 0 || self2.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
      self2.input = getInputElem();
      if (!self2.input) {
        self2.config.errorHandler(new Error("Invalid input element specified"));
        return;
      }
      self2.input._type = self2.input.type;
      self2.input.type = "text";
      self2.input.classList.add("flatpickr-input");
      self2._input = self2.input;
      if (self2.config.altInput) {
        self2.altInput = createElement(self2.input.nodeName, self2.config.altInputClass);
        self2._input = self2.altInput;
        self2.altInput.placeholder = self2.input.placeholder;
        self2.altInput.disabled = self2.input.disabled;
        self2.altInput.required = self2.input.required;
        self2.altInput.tabIndex = self2.input.tabIndex;
        self2.altInput.type = "text";
        self2.input.setAttribute("type", "hidden");
        if (!self2.config.static && self2.input.parentNode)
          self2.input.parentNode.insertBefore(self2.altInput, self2.input.nextSibling);
      }
      if (!self2.config.allowInput)
        self2._input.setAttribute("readonly", "readonly");
      updatePositionElement();
    }
    function updatePositionElement() {
      self2._positionElement = self2.config.positionElement || self2._input;
    }
    function setupMobile() {
      var inputType = self2.config.enableTime ? self2.config.noCalendar ? "time" : "datetime-local" : "date";
      self2.mobileInput = createElement("input", self2.input.className + " flatpickr-mobile");
      self2.mobileInput.tabIndex = 1;
      self2.mobileInput.type = inputType;
      self2.mobileInput.disabled = self2.input.disabled;
      self2.mobileInput.required = self2.input.required;
      self2.mobileInput.placeholder = self2.input.placeholder;
      self2.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
      if (self2.selectedDates.length > 0) {
        self2.mobileInput.defaultValue = self2.mobileInput.value = self2.formatDate(self2.selectedDates[0], self2.mobileFormatStr);
      }
      if (self2.config.minDate)
        self2.mobileInput.min = self2.formatDate(self2.config.minDate, "Y-m-d");
      if (self2.config.maxDate)
        self2.mobileInput.max = self2.formatDate(self2.config.maxDate, "Y-m-d");
      if (self2.input.getAttribute("step"))
        self2.mobileInput.step = String(self2.input.getAttribute("step"));
      self2.input.type = "hidden";
      if (self2.altInput !== void 0)
        self2.altInput.type = "hidden";
      try {
        if (self2.input.parentNode)
          self2.input.parentNode.insertBefore(self2.mobileInput, self2.input.nextSibling);
      } catch (_a) {
      }
      bind(self2.mobileInput, "change", function(e) {
        self2.setDate(getEventTarget(e).value, false, self2.mobileFormatStr);
        triggerEvent("onChange");
        triggerEvent("onClose");
      });
    }
    function toggle(e) {
      if (self2.isOpen === true)
        return self2.close();
      self2.open(e);
    }
    function triggerEvent(event, data) {
      if (self2.config === void 0)
        return;
      var hooks = self2.config[event];
      if (hooks !== void 0 && hooks.length > 0) {
        for (var i = 0; hooks[i] && i < hooks.length; i++)
          hooks[i](self2.selectedDates, self2.input.value, self2, data);
      }
      if (event === "onChange") {
        self2.input.dispatchEvent(createEvent("change"));
        self2.input.dispatchEvent(createEvent("input"));
      }
    }
    function createEvent(name) {
      var e = document.createEvent("Event");
      e.initEvent(name, true, true);
      return e;
    }
    function isDateSelected(date) {
      for (var i = 0; i < self2.selectedDates.length; i++) {
        var selectedDate = self2.selectedDates[i];
        if (selectedDate instanceof Date && compareDates(selectedDate, date) === 0)
          return "" + i;
      }
      return false;
    }
    function isDateInRange(date) {
      if (self2.config.mode !== "range" || self2.selectedDates.length < 2)
        return false;
      return compareDates(date, self2.selectedDates[0]) >= 0 && compareDates(date, self2.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
      if (self2.config.noCalendar || self2.isMobile || !self2.monthNav)
        return;
      self2.yearElements.forEach(function(yearElement, i) {
        var d = new Date(self2.currentYear, self2.currentMonth, 1);
        d.setMonth(self2.currentMonth + i);
        if (self2.config.showMonths > 1 || self2.config.monthSelectorType === "static") {
          self2.monthElements[i].textContent = monthToStr(d.getMonth(), self2.config.shorthandCurrentMonth, self2.l10n) + " ";
        } else {
          self2.monthsDropdownContainer.value = d.getMonth().toString();
        }
        yearElement.value = d.getFullYear().toString();
      });
      self2._hidePrevMonthArrow = self2.config.minDate !== void 0 && (self2.currentYear === self2.config.minDate.getFullYear() ? self2.currentMonth <= self2.config.minDate.getMonth() : self2.currentYear < self2.config.minDate.getFullYear());
      self2._hideNextMonthArrow = self2.config.maxDate !== void 0 && (self2.currentYear === self2.config.maxDate.getFullYear() ? self2.currentMonth + 1 > self2.config.maxDate.getMonth() : self2.currentYear > self2.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
      var format = specificFormat || (self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
      return self2.selectedDates.map(function(dObj) {
        return self2.formatDate(dObj, format);
      }).filter(function(d, i, arr) {
        return self2.config.mode !== "range" || self2.config.enableTime || arr.indexOf(d) === i;
      }).join(self2.config.mode !== "range" ? self2.config.conjunction : self2.l10n.rangeSeparator);
    }
    function updateValue(triggerChange2) {
      if (triggerChange2 === void 0) {
        triggerChange2 = true;
      }
      if (self2.mobileInput !== void 0 && self2.mobileFormatStr) {
        self2.mobileInput.value = self2.latestSelectedDateObj !== void 0 ? self2.formatDate(self2.latestSelectedDateObj, self2.mobileFormatStr) : "";
      }
      self2.input.value = getDateStr(self2.config.dateFormat);
      if (self2.altInput !== void 0) {
        self2.altInput.value = getDateStr(self2.config.altFormat);
      }
      if (triggerChange2 !== false)
        triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
      var eventTarget = getEventTarget(e);
      var isPrevMonth = self2.prevMonthNav.contains(eventTarget);
      var isNextMonth = self2.nextMonthNav.contains(eventTarget);
      if (isPrevMonth || isNextMonth) {
        changeMonth(isPrevMonth ? -1 : 1);
      } else if (self2.yearElements.indexOf(eventTarget) >= 0) {
        eventTarget.select();
      } else if (eventTarget.classList.contains("arrowUp")) {
        self2.changeYear(self2.currentYear + 1);
      } else if (eventTarget.classList.contains("arrowDown")) {
        self2.changeYear(self2.currentYear - 1);
      }
    }
    function timeWrapper(e) {
      e.preventDefault();
      var isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
      if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
        self2.amPM.textContent = self2.l10n.amPM[int(self2.amPM.textContent === self2.l10n.amPM[0])];
      }
      var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
      var newValue = curValue + step * delta;
      if (typeof input.value !== "undefined" && input.value.length === 2) {
        var isHourElem = input === self2.hourElement, isMinuteElem = input === self2.minuteElement;
        if (newValue < min) {
          newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self2.amPM));
          if (isMinuteElem)
            incrementNumInput(void 0, -1, self2.hourElement);
        } else if (newValue > max) {
          newValue = input === self2.hourElement ? newValue - max - int(!self2.amPM) : min;
          if (isMinuteElem)
            incrementNumInput(void 0, 1, self2.hourElement);
        }
        if (self2.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
          self2.amPM.textContent = self2.l10n.amPM[int(self2.amPM.textContent === self2.l10n.amPM[0])];
        }
        input.value = pad(newValue);
      }
    }
    init22();
    return self2;
  }
  function _flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
      return x instanceof HTMLElement;
    });
    var instances = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      try {
        if (node.getAttribute("data-fp-omit") !== null)
          continue;
        if (node._flatpickr !== void 0) {
          node._flatpickr.destroy();
          node._flatpickr = void 0;
        }
        node._flatpickr = FlatpickrInstance(node, config || {});
        instances.push(node._flatpickr);
      } catch (e) {
        console.error(e);
      }
    }
    return instances.length === 1 ? instances[0] : instances;
  }
  if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
      return _flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
      return _flatpickr([this], config);
    };
  }
  var flatpickr = function(selector, config) {
    if (typeof selector === "string") {
      return _flatpickr(window.document.querySelectorAll(selector), config);
    } else if (selector instanceof Node) {
      return _flatpickr([selector], config);
    } else {
      return _flatpickr(selector, config);
    }
  };
  flatpickr.defaultConfig = {};
  flatpickr.l10ns = {
    en: __assign2({}, default_default),
    default: __assign2({}, default_default)
  };
  flatpickr.localize = function(l10n) {
    flatpickr.l10ns.default = __assign2(__assign2({}, flatpickr.l10ns.default), l10n);
  };
  flatpickr.setDefaults = function(config) {
    flatpickr.defaultConfig = __assign2(__assign2({}, flatpickr.defaultConfig), config);
  };
  flatpickr.parseDate = createDateParser({});
  flatpickr.formatDate = createDateFormatter({});
  flatpickr.compareDates = compareDates;
  if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
    jQuery.fn.flatpickr = function(config) {
      return _flatpickr(this, config);
    };
  }
  Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
  };
  if (typeof window !== "undefined") {
    window.flatpickr = flatpickr;
  }
  var esm_default = flatpickr;

  // build/ts/main/src/form/InputField.js
  var import_it = __toESM(require_it());
  var import_fr = __toESM(require_fr());
  var import_de = __toESM(require_de());
  var INFO_ICON = "icon-026-exclamation-mark-circle";
  esm_default.localize(import_it.Italian);
  esm_default.localize(import_fr.French);
  esm_default.localize(import_de.German);
  var DEFAULTS_FLATPICKR = {
    wrap: true,
    allowInput: true,
    locale: "de",
    dateFormat: "d.m.Y",
    time_24hr: true
  };
  var CLASS_HAS_VALUE = "is-fixed";
  var CLASS_MESSAGE = ".message";
  var InputField = function(_super) {
    __extends(InputField2, _super);
    function InputField2(element, datePickerOptions) {
      var _this = _super.call(this, element) || this;
      _this._changedHandler = _this.onValueChanged.bind(_this);
      _this._animationStartHandler = _this._onAnimationStart.bind(_this);
      _this._datePickerOptions = datePickerOptions;
      _this._initialize();
      return _this;
    }
    InputField2.prototype._initialize = function() {
      this.element.spellcheck = false;
      this.element.addEventListener("input", this._changedHandler);
      if (this.element.getAttribute("type") === "password") {
        this.element.addEventListener("animationstart", this._animationStartHandler);
      }
      this._initializeDatePicker();
      this.onValueChanged();
    };
    InputField2.prototype._initializeDatePicker = function() {
      var picker = this.element.parentElement;
      if (!picker || !picker.classList.contains("flatpickr")) {
        return;
      }
      if (!this._datePickerOptions) {
        try {
          this._datePickerOptions = JSON.parse(picker.dataset.options || "{}");
        } catch (e) {
          this._datePickerOptions = {};
          console.warn("_initializeDatePicker JSON.parse failed", picker.dataset.options, e);
        }
      }
      this._flatpickrInstance = esm_default(picker, Object.assign({}, DEFAULTS_FLATPICKR, this._datePickerOptions));
    };
    InputField2.prototype._destroyDatePicker = function() {
      if (this._flatpickrInstance) {
        this._flatpickrInstance.destroy();
      }
    };
    InputField2.prototype._onAnimationStart = function(e) {
      if (e.animationName === "onAutoFillStart") {
        this.onValueChanged(true);
      }
    };
    InputField2.prototype.onValueChanged = function(force) {
      if (force === void 0) {
        force = false;
      }
      if (this.element.value && this.element.value !== "" || force === true) {
        this.addClass(CLASS_HAS_VALUE);
      } else {
        this.removeClass(CLASS_HAS_VALUE);
        this.element.value = "";
      }
    };
    InputField2.prototype.destroy = function() {
      this.element.removeEventListener("input", this._changedHandler);
      if (this.element.getAttribute("type") === "password") {
        this.element.removeEventListener("animationstart", this._animationStartHandler);
      }
      ;
      this._changedHandler = void 0;
      this._animationStartHandler = void 0;
      this._destroyDatePicker();
    };
    InputField2.prototype.showError = function(text2) {
      var message;
      if (this.element.parentElement) {
        var msg_1 = this.element.parentElement.querySelector(CLASS_MESSAGE);
        if (msg_1) {
          message = new DomElement_default(msg_1);
        }
      }
      if (!text2 || text2 === "") {
        if (message) {
          remove(message.element);
        }
        this.removeClass("invalid");
        return;
      }
      this.addClass("invalid");
      if (!message) {
        message = new DomElement_default("div").addClass("message");
        this.element.parentElement.appendChild(message.element);
      } else {
        message.empty();
      }
      var icon = new DomElement_default("i").addClass("icon").addClass(INFO_ICON).setAttribute("aria-hidden", "true");
      var msg = new DomElement_default("span").setHtml(text2);
      message.appendChild(icon);
      message.appendChild(msg);
    };
    return InputField2;
  }(DomElement_default);
  function init2() {
    searchAndInitialize(".input-field input", function(e) {
      new InputField(e);
    }, function(e) {
      return e.parentElement;
    });
  }
  var InputField_default = InputField;

  // build/ts/main/src/form/Textarea.js
  var QUERY_TEXTAREA = "textarea";
  var CLASS_HAS_VALUE2 = "is-fixed";
  var Textarea = function(_super) {
    __extends(Textarea2, _super);
    function Textarea2(element) {
      var _this = _super.call(this, element) || this;
      _this._area = _this.element.querySelector(QUERY_TEXTAREA);
      _this._focusChangedHandler = _this._focusChanged.bind(_this);
      _this._valueChangedHandler = _this._onValueChanged.bind(_this);
      _this._resizeHandler = _this._updateHeight.bind(_this);
      _this._initialize();
      return _this;
    }
    Textarea2.prototype._initialize = function() {
      this._area.spellcheck = false;
      this._minRows = parseInt(this._area.getAttribute("data-min-rows") || "4", 10);
      this._maxRows = parseInt(this._area.getAttribute("data-max-rows") || "10", 10);
      this._minRows = Math.min(this._minRows, this._maxRows);
      this._maxRows = Math.max(this._minRows, this._maxRows);
      this._lineHeight = parseInt(css(this._area, "line-height"), 10);
      this._updateBaseHeight = isHidden(this._area, true);
      this._calculateBaseHeight();
      this._area.addEventListener("focus", this._focusChangedHandler);
      this._area.addEventListener("blur", this._focusChangedHandler);
      this._area.addEventListener("input", this._valueChangedHandler);
      window.addEventListener("resize", this._resizeHandler);
      window.addEventListener("orientationchange", this._resizeHandler);
      this._onValueChanged();
    };
    Textarea2.prototype._calculateBaseHeight = function() {
      var value = this._area.value;
      this._area.value = "";
      this._baseHeight = this._area.offsetHeight - this._lineHeight;
      this._baseScrollHeight = this._area.scrollHeight - this._lineHeight;
      this._area.value = value;
    };
    Textarea2.prototype._focusChanged = function() {
      this._updateHeight();
    };
    Textarea2.prototype._updateHeight = function() {
      var hasFocus = this._area === document.activeElement;
      var maxRows, rows = 0;
      if (this._updateBaseHeight === true && isHidden(this._area, true) === false) {
        this._calculateBaseHeight();
        this._updateBaseHeight = false;
      }
      if (!this._hasValue()) {
        rows = hasFocus === true ? this._minRows : 1;
        maxRows = rows;
      } else {
        this._area.style.height = "auto";
        rows = Math.ceil((this._area.scrollHeight - this._baseScrollHeight) / this._lineHeight) + 1;
        maxRows = Math.max(Math.min(this._maxRows, rows), this._minRows);
      }
      if (rows > this._maxRows) {
        this._area.style.overflow = "auto";
      } else {
        this._area.style.overflow = "hidden";
      }
      var height = (maxRows - 1) * this._lineHeight + this._baseHeight;
      this._area.style.height = "".concat(height, "px");
    };
    Textarea2.prototype._hasValue = function() {
      return this._area.value && this._area.value.length > 0;
    };
    Textarea2.prototype._onValueChanged = function() {
      if (this._hasValue()) {
        addClass(this._area, CLASS_HAS_VALUE2);
      } else {
        removeClass(this._area, CLASS_HAS_VALUE2);
        this._area.value = "";
      }
      this._updateHeight();
    };
    Textarea2.prototype.destroy = function() {
      window.removeEventListener("resize", this._resizeHandler);
      window.removeEventListener("orientationchange", this._resizeHandler);
      this._area.removeEventListener("focus", this._focusChangedHandler);
      this._area.removeEventListener("blur", this._focusChangedHandler);
      this._area.removeEventListener("input", this._valueChangedHandler);
      this._focusChangedHandler = null;
      this._valueChangedHander = null;
      this._area = null;
      this._minRows = null;
      this._maxRows = null;
      this._lineHeight = null;
      this._baseHeight = null;
      this._baseScrollHeight = null;
      this.element = null;
    };
    return Textarea2;
  }(DomElement_default);
  function init3() {
    searchAndInitialize(".input-multiline, .input-field--multiline", function(e) {
      new Textarea(e);
    });
  }
  var Textarea_default = Textarea;

  // build/ts/main/src/Inputs.js
  var KEY_TAB = 9;
  var KEY_ENTER = 13;
  var KEY_ESCAPE = 27;
  var KEY_ARROW_UP = 38;
  var KEY_ARROW_DOWN = 40;
  var KEY_ARROW_LEFT = 37;
  var KEY_ARROW_RIGHT = 39;
  var KEY_PAGE_UP = 33;
  var KEY_PAGE_DOWN = 34;
  var KEY_NR_0 = 48;
  var KEY_NR_9 = 57;
  var containsKey = function(keycode, inputsKeys) {
    var hasKey = false;
    if (inputsKeys && inputsKeys.length > 0) {
      ;
      [].forEach.call(inputsKeys, function(inputsKey) {
        if (keycode === inputsKey) {
          hasKey = true;
        }
      });
    }
    return hasKey;
  };
  var getKeyValue = function(keycode) {
    if (keycode < 48 || keycode > 105) {
      return "";
    }
    return String.fromCharCode(96 <= keycode && keycode <= 105 ? keycode - 48 : keycode).toLowerCase();
  };

  // build/ts/main/src/form/Select.js
  var CLASS_PLACEHOLDER = "select__placeholder";
  var CLASS_THUMB = "select__thumb";
  var CLASS_BUTTON = "select__button";
  var CLASS_DROPDOWN = "select__dropdown";
  var CLASS_OPEN = "select--open";
  var CLASS_CLOSED = "select--closed";
  var CLASS_DISABLED = "select--disabled";
  var CLASS_FILTERABLE = "select--filterable";
  var CLASS_ITEM = "dropdown-item";
  var CLASS_ITEM_SELECTED = "dropdown-item--selected";
  var CLASS_ITEM_FOCUSED = "dropdown-item--focused";
  var CLASS_ITEM_DISABLED = "dropdown-item--disabled";
  var CLASS_GROUP_ITEM = "dropdown-group";
  var CLASS_GROUP_HEADER = "dropdown-group__item";
  var QUERY_MESSAGE = ".message";
  var TIMEOUT_CLOSE = 150;
  var TIMEOUT_BLUR = 400;
  var Select = function(_super) {
    __extends(Select2, _super);
    function Select2(element) {
      var _this = _super.call(this, element) || this;
      _this._minFilterLength = 2;
      _this._initialOptions = Array.prototype.slice.call(_this.element.children);
      _this._openByFocus = false;
      _this._multiselection = _this.element.hasAttribute("multiple") === true;
      _this._clickHandler = _this._handleClick.bind(_this);
      _this._handleDropdownClick = _this._handleClick.bind(_this);
      _this._keydownHandler = _this._handleKeydown.bind(_this);
      _this._focusHandler = _this._handleFocus.bind(_this);
      _this._blurHandler = _this._handleBlur.bind(_this);
      _this._windowClickHandler = _this._handleWindowClick.bind(_this);
      _this._filterKeydownHandler = _this._handleFilterKeydown.bind(_this);
      _this._filterKeyupHandler = _this._handleFilterKeyup.bind(_this);
      _this._filterFocusHandler = _this._handleFilterFocus.bind(_this);
      _this._initialize();
      return _this;
    }
    Select2.prototype._initialize = function() {
      var e_1, _a;
      var selectedOption = this.element.querySelector("option[selected]");
      var firstOption = this.element.querySelector("option");
      this._lastSelectedOption = selectedOption || firstOption;
      this._wrapperElement = new DomElement_default(this.element.parentElement).addClass(CLASS_CLOSED);
      try {
        for (var _b = __values(this.classes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var cls = _c.value;
          this._wrapperElement.addClass(cls);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      this._dropdownElement = new DomElement_default("div").addClass(CLASS_DROPDOWN);
      if (internetExplorerOrEdgeVersion() > 0 && internetExplorerOrEdgeVersion() < 12) {
        this._dropdownElement.element.addEventListener("mousedown", function(event) {
          return event.preventDefault();
        });
      }
      this._setupTarget();
      this._setupPlaceholder();
      this._wrapperElement.appendChild(this._dropdownElement);
      this._createOptions(this.element);
      this._updateSize();
      this._updateMessage();
      if (this.element.disabled) {
        this.disable();
      } else {
        this.enable();
      }
    };
    Select2.prototype._setupTarget = function() {
      var id = this.element.getAttribute("id");
      if (id) {
        this.element.removeAttribute("id");
        this._wrapperElement.setAttribute("id", id);
      }
      var tabIndex = this.element.getAttribute("tabindex");
      if (tabIndex) {
        this._wrapperElement.setAttribute("tabIndex", tabIndex);
      }
    };
    Select2.prototype._setupPlaceholder = function() {
      var _this = this;
      if (!this._selectButtonElement) {
        this._selectButtonElement = new DomElement_default("div").addClass(CLASS_BUTTON);
        this._wrapperElement.appendChild(this._selectButtonElement);
      }
      if (!this._thumbElement) {
        this._thumbElement = new DomElement_default("div").addClass(CLASS_THUMB);
        var thumbIcon = new DomElement_default("div").addClass("thumb-icon");
        var loader = new DomElement_default("div").addClass("loader-spinner").addClass("loader-spinner--small");
        this._thumbElement.appendChild(loader);
        this._thumbElement.appendChild(thumbIcon);
        this._selectButtonElement.appendChild(this._thumbElement);
      }
      var placeholderText = "";
      this._placeholderOption = this.element.querySelector("option[selected][disabled]") || void 0;
      if (this._placeholderOption) {
        placeholderText = text(this._placeholderOption);
        if (this._multiselection === true) {
          this._placeholderOption.selected = false;
        }
      }
      var selectedOption = this.element.querySelector("option[selected]:not([disabled])");
      if (selectedOption) {
        placeholderText = text(selectedOption);
      }
      if (!this._placeholderElement) {
        if (this._isFilterable()) {
          this._placeholderElement = new DomElement_default("input");
          this._placeholderElement.addEventListener("keyup", function(e) {
            return _this._handleFilterKeyup(e);
          });
          this._placeholderElement.addEventListener("keydown", function(e) {
            return _this._handleFilterKeydown(e);
          });
          this._placeholderElement.addEventListener("focus", function(e) {
            return _this._handleFilterFocus(e);
          });
        } else {
          this._placeholderElement = new DomElement_default("span");
        }
        this._placeholderElement.addClass(CLASS_PLACEHOLDER);
        this._selectButtonElement.appendChild(this._placeholderElement);
      }
      this._setPlaceholder(placeholderText);
      this._placeholderText = placeholderText;
      if (selectedOption && selectedOption !== this._placeholderOption) {
        this._updatePlaceholder(true);
      }
    };
    Select2.prototype._updateMessage = function() {
      var messageNode = this._wrapperElement.element.querySelector(QUERY_MESSAGE);
      if (messageNode !== null) {
        this._wrapperElement.appendChild(new DomElement_default(messageNode));
      }
    };
    Select2.prototype._isOptGroup = function(element) {
      return element.tagName.toUpperCase() === "OPTGROUP";
    };
    Select2.prototype._isOption = function(element) {
      return element.tagName.toUpperCase() === "OPTION";
    };
    Select2.prototype._createOptions = function(element) {
      for (var i = 0; i < element.children.length; i++) {
        var child = element.children[i];
        if (this._isOptGroup(child)) {
          this._appendGroup(child);
        }
        if (this._isOption(child)) {
          var option = this._createOption(child);
          if (option) {
            this._dropdownElement.appendChild(option);
          }
        }
      }
    };
    Select2.prototype._createOption = function(option) {
      var html = option.innerHTML;
      if (this._activeFilter) {
        var escapedActiveFilter = this._activeFilter.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
        html = html.replace(new RegExp("(".concat(escapedActiveFilter, ")"), "gi"), "<strong>$1</strong>");
      }
      var opt = new DomElement_default("div").addClass(CLASS_ITEM).setHtml(html, true);
      if (option.selected) {
        opt.addClass(CLASS_ITEM_SELECTED);
      }
      if (option.disabled) {
        opt.addClass(CLASS_ITEM_DISABLED);
      }
      if (!this._isPlaceholder(option)) {
        opt.setAttribute("data-value", option.value);
        return opt;
      }
      return void 0;
    };
    Select2.prototype._appendGroup = function(optgroup) {
      var e_2, _a;
      var label = optgroup.getAttribute("label");
      var group = new DomElement_default("div").addClass(CLASS_GROUP_ITEM);
      var groupHeader = new DomElement_default("div").addClass(CLASS_GROUP_HEADER).setHtml(label);
      group.appendChild(groupHeader);
      var options = optgroup.querySelectorAll("option");
      try {
        for (var options_1 = __values(options), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
          var entry = options_1_1.value;
          var option = this._createOption(entry);
          if (option) {
            group.appendChild(option);
          }
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (options_1_1 && !options_1_1.done && (_a = options_1.return))
            _a.call(options_1);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      this._dropdownElement.appendChild(group);
      return group;
    };
    Select2.prototype._updateSize = function() {
      var e_3, _a;
      var placeholderStyle = window.getComputedStyle(this._placeholderElement.element);
      var paddingRight = parseFloat(placeholderStyle.paddingRight);
      var paddingLeft = parseFloat(placeholderStyle.paddingLeft);
      var font = this._placeholderElement.css("font");
      var textWidth2 = textWidth(this._placeholderText, font);
      var maxWidth = paddingLeft + paddingRight + textWidth2;
      var options = this._wrapperElement.element.querySelectorAll(".".concat(CLASS_ITEM));
      try {
        for (var options_2 = __values(options), options_2_1 = options_2.next(); !options_2_1.done; options_2_1 = options_2.next()) {
          var entry = options_2_1.value;
          var width = textWidth(text(entry), font) + paddingLeft + paddingRight;
          if (width > maxWidth) {
            maxWidth = width;
          }
        }
      } catch (e_3_1) {
        e_3 = { error: e_3_1 };
      } finally {
        try {
          if (options_2_1 && !options_2_1.done && (_a = options_2.return))
            _a.call(options_2);
        } finally {
          if (e_3)
            throw e_3.error;
        }
      }
    };
    Select2.prototype._isButtonTarget = function(target) {
      return target === this._wrapperElement.element || target === this._placeholderElement.element || target === this._selectButtonElement.element || target === this._thumbElement.element;
    };
    Select2.prototype._isDropdownTarget = function(target) {
      var current = target;
      while (current !== this._dropdownElement.element && current.parentElement) {
        current = current.parentElement;
      }
      return current === this._dropdownElement.element;
    };
    Select2.prototype._selectedItemChanged = function(newItem, autoClose, multiselect) {
      var _this = this;
      if (autoClose === void 0) {
        autoClose = true;
      }
      if (multiselect === void 0) {
        multiselect = false;
      }
      var oldItems = this._dropdownElement.element.querySelectorAll(".".concat(CLASS_ITEM_SELECTED));
      if (!newItem) {
        setTimeout(function() {
          return _this.close();
        }, TIMEOUT_CLOSE);
        return;
      }
      if (hasClass(newItem, CLASS_ITEM_DISABLED)) {
        return;
      }
      if (oldItems.length === 0 && !newItem) {
        throw new Error("Can not select undefined elements");
      }
      var oldItem = oldItems[0];
      if (multiselect === true) {
        oldItem = find(oldItems, function(x) {
          return x.getAttribute("data-value") === newItem.getAttribute("data-value");
        });
      }
      var isDeselect = false;
      if (newItem && oldItem && oldItem === newItem) {
        isDeselect = true;
        if (!this._placeholderOption && !multiselect) {
          return;
        }
        delete this._lastSelectedOption;
      }
      if (oldItem) {
        var oldValue_1 = oldItem.getAttribute("data-value");
        var optElement = find(this.element.options, function(x) {
          return !x.disabled && x.value === oldValue_1;
        });
        if (!optElement) {
          throw new Error("The option with value ".concat(oldValue_1, " does not exist"));
        }
        optElement.selected = false;
        removeClass(oldItem, CLASS_ITEM_SELECTED);
      }
      if (!isDeselect) {
        var newValue_1 = newItem.getAttribute("data-value");
        var optElement = find(this.element.options, function(x) {
          return !x.disabled && x.value === newValue_1;
        });
        if (!optElement) {
          throw new Error("The option with value ".concat(newValue_1, " does not exist"));
        }
        optElement.selected = true;
        addClass(newItem, CLASS_ITEM_SELECTED);
        this._lastSelectedOption = optElement;
      } else {
        if (this._placeholderOption) {
          this._lastSelectedOption = this._placeholderOption;
        }
      }
      var hasSelectedItems = true;
      if (this._multiselection === false && isDeselect) {
        this._placeholderOption.selected = true;
        hasSelectedItems = false;
      }
      if (this._multiselection === true && this._getSelectedOptions().length === 0) {
        hasSelectedItems = false;
      }
      if (this._activeFilter) {
        this._clearFilter();
      }
      this._updatePlaceholder(hasSelectedItems);
      this.dispatchEvent("change");
      if (autoClose && !multiselect) {
        setTimeout(function() {
          _this.close();
        }, TIMEOUT_CLOSE);
      }
    };
    Select2.prototype._updatePlaceholder = function(hasSelectedItems) {
      var e_4, _a;
      var text2 = this._placeholderOption ? text(this._placeholderOption) : " ";
      if (hasSelectedItems === true) {
        var selectedItems = this._getSelectedOptions();
        if (selectedItems.length > 0) {
          text2 = "";
          try {
            for (var selectedItems_1 = __values(selectedItems), selectedItems_1_1 = selectedItems_1.next(); !selectedItems_1_1.done; selectedItems_1_1 = selectedItems_1.next()) {
              var item = selectedItems_1_1.value;
              text2 += "".concat(text(item), ", ");
            }
          } catch (e_4_1) {
            e_4 = { error: e_4_1 };
          } finally {
            try {
              if (selectedItems_1_1 && !selectedItems_1_1.done && (_a = selectedItems_1.return))
                _a.call(selectedItems_1);
            } finally {
              if (e_4)
                throw e_4.error;
            }
          }
          text2 = text2.substring(0, text2.length - 2);
        }
      }
      this._setPlaceholder(text2);
    };
    Select2.prototype._getSelectedOptions = function() {
      var selectedOptions = [];
      if (this.element.options) {
        ;
        [].forEach.call(this.element.options, function(option) {
          if (option.selected && !option.disabled) {
            selectedOptions.push(option);
          }
        });
      }
      return selectedOptions;
    };
    Select2.prototype.getInitialOptions = function() {
      var filter = this._activeFilter || "";
      var filtered = [];
      var initialOptions = this._initialOptions;
      for (var i = 0; i < initialOptions.length; i++) {
        var child = initialOptions[i];
        if (this._isOptGroup(child)) {
          var optGroupClone = child.cloneNode(false);
          var found = false;
          for (var j = 0; j < child.children.length; j++) {
            var optionClone = child.children[j].cloneNode(true);
            if (this._containsWord(optionClone.innerHTML, filter)) {
              optGroupClone.appendChild(optionClone);
              found = true;
            }
          }
          if (found) {
            filtered.push(optGroupClone);
          }
        } else if (this._isOption(child)) {
          var optionClone = child.cloneNode(true);
          if (this._containsWord(optionClone.innerHTML, filter)) {
            filtered.push(optionClone);
          }
        }
      }
      return filtered;
    };
    Select2.prototype._containsWord = function(text2, keyword) {
      return text2.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
    };
    Select2.prototype._handleFocus = function() {
      var _this = this;
      this.open();
      this._openByFocus = true;
      setTimeout(function() {
        _this._openByFocus = false;
      }, TIMEOUT_BLUR);
    };
    Select2.prototype._handleBlur = function() {
      this.close();
    };
    Select2.prototype._handleClick = function(event) {
      var handled = false;
      if (this._lastHandledEvent === event) {
        this._lastHandledEvent = void 0;
        return;
      }
      if (this._isButtonTarget(event.target) && this._openByFocus === false) {
        this.toggle();
        handled = true;
      }
      var newItem = event.target;
      if (!handled && hasClass(newItem, CLASS_ITEM)) {
        this._selectedItemChanged(newItem, true, this._multiselection);
        handled = true;
      }
      if (handled) {
        this._lastHandledEvent = event;
        preventDefault(event);
      }
    };
    Select2.prototype._handleWindowClick = function(event) {
      if (this._isDropdownTarget(event.target) || this._isButtonTarget(event.target)) {
        return;
      }
      this.close();
    };
    Select2.prototype._focusOptionStartingWith = function(keycode, startIndex, options) {
      for (var index = startIndex; index < options.length; index++) {
        var item = new DomElement_default(options[index]);
        var value = item.innerText.toLowerCase();
        if (index > options.length) {
          index = 0;
        }
        if (value.startsWith(getKeyValue(keycode))) {
          var newOption = new DomElement_default(options[index]);
          if (!newOption.hasClass(CLASS_ITEM_DISABLED)) {
            scrollIntoView(options[index]);
            newOption.addClass(CLASS_ITEM_FOCUSED);
            return newOption;
          }
        }
      }
      return void 0;
    };
    Select2.prototype._handleKeydown = function(event) {
      var keyboardEvent = event;
      var evt = keyboardEvent || window.event;
      var keycode = keyboardEvent.which || keyboardEvent.keyCode;
      if (keycode === KEY_ESCAPE) {
        if (this.isOpen()) {
          this.close();
        }
        evt.preventDefault();
        return;
      }
      if (keycode === KEY_ARROW_UP || keycode === KEY_ARROW_DOWN) {
        var options = this._wrapperElement.element.querySelectorAll(".".concat(CLASS_ITEM));
        if (options.length > 0) {
          var newIndex = 0;
          var oldOption = void 0;
          var focusedElement = this._wrapperElement.find(".".concat(CLASS_ITEM_FOCUSED));
          var searchFor = focusedElement ? CLASS_ITEM_FOCUSED : CLASS_ITEM_SELECTED;
          var newElement = void 0;
          for (var index = 0; index < options.length; index++) {
            var direction = keycode === KEY_ARROW_DOWN ? 1 : -1;
            var item = new DomElement_default(options[index]);
            if (item.hasClass(searchFor)) {
              oldOption = item;
              newIndex = index;
              for (var count = 0; count < options.length; count++) {
                newIndex += direction;
                newIndex %= options.length;
                if (newIndex < 0) {
                  newIndex = options.length - 1;
                }
                newElement = new DomElement_default(options[newIndex]);
                if (!newElement.hasClass(CLASS_ITEM_DISABLED)) {
                  break;
                }
              }
            }
          }
          scrollIntoView(options[newIndex]);
          var newOption = new DomElement_default(options[newIndex]);
          newOption.addClass(CLASS_ITEM_FOCUSED);
          if (oldOption) {
            oldOption.removeClass(CLASS_ITEM_FOCUSED);
          }
        }
        evt.preventDefault();
        return;
      }
      if (getKeyValue(keycode) && !this._isFilterable()) {
        var options = this._wrapperElement.element.querySelectorAll(".".concat(CLASS_ITEM));
        if (options.length > 0) {
          var oldFocusIndex = 0;
          var hasFocusedOption = false;
          for (var index = 0; index < options.length; index++) {
            var item = new DomElement_default(options[index]);
            if (item.hasClass(CLASS_ITEM_FOCUSED)) {
              item.removeClass(CLASS_ITEM_FOCUSED);
              var value = item.innerText.toLowerCase();
              if (value.startsWith(getKeyValue(keycode))) {
                hasFocusedOption = true;
                oldFocusIndex = index;
              }
            }
          }
          var newOption = this._focusOptionStartingWith(keycode, hasFocusedOption ? oldFocusIndex + 1 : 0, options);
          if (newOption === void 0) {
            this._focusOptionStartingWith(keycode, 0, options);
          }
        }
        evt.preventDefault();
        return;
      }
      if (keycode === KEY_ENTER || keycode === KEY_TAB) {
        var newItem = this._dropdownElement.element.querySelector(".".concat(CLASS_ITEM_FOCUSED));
        this._selectedItemChanged(newItem, true, this._multiselection);
      }
    };
    Select2.prototype._handleFilterKeydown = function(e) {
      var keyboardEvent = e;
      var keycode = keyboardEvent.which || keyboardEvent.keyCode;
      if (keycode === KEY_ENTER) {
        var dropdownElements = this._dropdownElement.element.querySelectorAll(".".concat(CLASS_ITEM));
        if (dropdownElements.length === 1) {
          this._selectedItemChanged(dropdownElements[0], true, this._multiselection);
          e.stopPropagation();
        }
      }
    };
    Select2.prototype._handleFilterKeyup = function(e) {
      var target = e.target;
      if (target.value !== this._activeFilter && target.value !== this._placeholderText && target.value !== this._lastSelectedOption.innerHTML) {
        this._setFilter(target.value);
      }
    };
    Select2.prototype._handleFilterFocus = function(e) {
      var target = e.target;
      setTimeout(function() {
        target.select();
      });
    };
    Select2.prototype._setFilter = function(filter) {
      if (filter === void 0) {
        filter = "";
      }
      this._activeFilter = filter.length >= this._minFilterLength ? filter : "";
      this.setOptions(this.getInitialOptions());
    };
    Select2.prototype._clearFilter = function() {
      delete this._activeFilter;
      this.setOptions(this.getInitialOptions());
    };
    Select2.prototype.setOptions = function(options) {
      var _this = this;
      this._emptyNode(this.element);
      options.forEach(function(option) {
        _this.element.appendChild(option);
      });
      this.element.value = this._lastSelectedOption.value;
      this.reload();
    };
    Select2.prototype._emptyNode = function(node) {
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
    };
    Select2.prototype._isPlaceholder = function(option) {
      return option.hasAttribute("disabled") && option.hasAttribute("selected");
    };
    Select2.prototype._setPlaceholder = function(text2) {
      if (this._placeholderElement && text2) {
        if (this._isFilterable()) {
          ;
          this._placeholderElement.element.value = text2;
        } else {
          this._placeholderElement.setHtml(text2);
        }
      }
    };
    Object.defineProperty(Select2.prototype, "value", {
      get: function() {
        if (this._multiselection) {
          return this._getSelectedOptions().map(function(x) {
            return x.value;
          });
        }
        if (this.element.value === "") {
          return null;
        }
        return this.element.value;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Select2.prototype, "disabled", {
      set: function(value) {
        if (value) {
          this.disable();
        } else {
          this.enable();
        }
      },
      enumerable: false,
      configurable: true
    });
    Select2.prototype.reload = function() {
      this._emptyNode(this._dropdownElement.element);
      if (this._activeFilter === void 0) {
        this._setupPlaceholder();
      }
      this._createOptions(this.element);
      this._updateSize();
      this._updateMessage();
      if (!this._isFilterable()) {
        this._updatePlaceholder(!!this.value);
      }
    };
    Select2.prototype.enable = function() {
      this.element.removeAttribute("disabled");
      this._wrapperElement.removeClass(CLASS_DISABLED);
      window.addEventListener("click", this._windowClickHandler);
      this._wrapperElement.element.addEventListener("click", this._clickHandler);
      this._wrapperElement.element.addEventListener("keydown", this._keydownHandler);
      this._wrapperElement.element.addEventListener("focus", this._focusHandler);
      this._wrapperElement.element.addEventListener("blur", this._blurHandler);
    };
    Select2.prototype.disable = function() {
      this.element.setAttribute("disabled", "");
      this._wrapperElement.addClass(CLASS_DISABLED);
      window.removeEventListener("click", this._windowClickHandler);
      this._wrapperElement.element.removeEventListener("click", this._clickHandler);
      this._wrapperElement.element.removeEventListener("keydown", this._keydownHandler);
      this._wrapperElement.element.removeEventListener("focus", this._focusHandler);
      this._wrapperElement.element.removeEventListener("blur", this._blurHandler);
      this.close();
    };
    Select2.prototype.toggle = function() {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    };
    Select2.prototype.isOpen = function() {
      return this._wrapperElement.hasClass(CLASS_OPEN);
    };
    Select2.prototype.open = function() {
      if (!this.isOpen()) {
        this._openByFocus = false;
        this._wrapperElement.removeClass(CLASS_CLOSED);
        this._wrapperElement.addClass(CLASS_OPEN);
        this._dropdownElement.element.addEventListener("click", this._handleDropdownClick);
        this._dropdownElement.element.addEventListener("tap", this._handleDropdownClick);
      }
    };
    Select2.prototype.close = function() {
      if (this.isOpen()) {
        this._openByFocus = false;
        this._wrapperElement.removeClass(CLASS_OPEN);
        this._wrapperElement.addClass(CLASS_CLOSED);
        if (this._isFilterable()) {
          ;
          this._placeholderElement.element.blur();
          if (!this._activeFilter || this._activeFilter === this._lastSelectedOption.innerHTML) {
            this._setPlaceholder(this._lastSelectedOption.textContent || "");
          }
        }
        this._dropdownElement.element.removeEventListener("click", this._handleDropdownClick);
        this._dropdownElement.element.removeEventListener("tap", this._handleDropdownClick);
        var focusedItem = this._wrapperElement.find(".".concat(CLASS_ITEM_FOCUSED));
        if (focusedItem) {
          focusedItem.removeClass(CLASS_ITEM_FOCUSED);
        }
      }
    };
    Select2.prototype._isFilterable = function() {
      return this._wrapperElement.hasClass(CLASS_FILTERABLE);
    };
    Select2.prototype.destroy = function() {
      window.removeEventListener("click", this._windowClickHandler);
      if (this._dropdownElement) {
        this._dropdownElement.element.removeEventListener("click", this._handleDropdownClick);
        this._dropdownElement.element.removeEventListener("tap", this._handleDropdownClick);
        remove(this._dropdownElement.element);
        this._dropdownElement = void 0;
      }
      if (this._placeholderElement) {
        this._placeholderElement.removeEventListener("keydown", this._filterKeydownHandler);
        this._placeholderElement.removeEventListener("keyup", this._filterKeyupHandler);
        this._placeholderElement.removeEventListener("focus", this._filterFocusHandler);
      }
      if (this._wrapperElement) {
        this._wrapperElement.element.removeEventListener("click", this._clickHandler);
        this._wrapperElement.element.removeEventListener("keydown", this._keydownHandler);
        this._wrapperElement.element.removeEventListener("focus", this._focusHandler);
        this._wrapperElement.element.removeEventListener("blur", this._blurHandler);
        this._wrapperElement = void 0;
      }
      if (this._selectButtonElement) {
        remove(this._selectButtonElement.element);
        this._selectButtonElement = void 0;
      }
      this.removeClass(CLASS_CLOSED);
    };
    return Select2;
  }(DomElement_default);
  function init4() {
    searchAndInitialize("select", function(e) {
      new Select(e);
    });
  }
  var Select_default = Select;

  // build/ts/main/src/form/Range.js
  var MARGIN_TICK = 32;
  var CLASS_HTML5 = "html5";
  var RANGE_LIGHT = "range--light";
  var CLASS_CONTAINER = "range-container";
  var CLASS_SLIDER = "range-slider";
  var CLASS_ACTIVE = "range--active";
  var CLASS_TRACK = "range-track";
  var CLASS_TRACK_PROGRESS = "range-track__progress";
  var CLASS_TICK = "range-tick";
  var CLASS_TICK_LABEL = "range-tick__label";
  var CLASS_TICK_ACTIVE = "range-tick--active";
  var CLASS_THUMB2 = "range-thumb";
  var CLASS_THUMB_VALUE = "range-thumb__value";
  var CLASS_DISABLED2 = "range--disabled";
  var CLASS_DRAGGING = "range--dragging";
  var Range = function(_super) {
    __extends(Range2, _super);
    function Range2(element) {
      var _this = _super.call(this, element) || this;
      _this._downHandler = _this._handleDown.bind(_this);
      _this._moveHandler = _this._handleMove.bind(_this);
      _this._endHandler = _this._handleEnd.bind(_this);
      _this._keydownHandler = _this._handleKeydown.bind(_this);
      _this._focusHandler = _this._handleFocus.bind(_this);
      _this._blurHandler = _this._handleBlur.bind(_this);
      _this._resizeHandler = _this.layout.bind(_this);
      _this._initialize();
      if (_this.element.disabled) {
        _this.disable();
      } else {
        _this.enable();
      }
      return _this;
    }
    Range2.prototype._initialize = function() {
      if (this.hasClass(CLASS_HTML5)) {
        return;
      }
      this._wrapperElement = new DomElement_default(this.element.parentElement);
      this._rangeContainer = new DomElement_default("div").addClass(CLASS_CONTAINER);
      this._rangeTrack = new DomElement_default("div").addClass(CLASS_TRACK);
      if (this._wrapperElement.hasClass(RANGE_LIGHT)) {
        this._rangeProgress = new DomElement_default("div").addClass(CLASS_TRACK_PROGRESS);
        this._rangeTrack.appendChild(this._rangeProgress);
      }
      this._rangeThumb = new DomElement_default("div").addClass(CLASS_THUMB2);
      this._ticksWrapper = new DomElement_default("div").addClass(CLASS_SLIDER);
      this._rangeContainer.appendChild(this._rangeTrack);
      this._rangeContainer.appendChild(this._ticksWrapper);
      this._rangeContainer.appendChild(this._rangeThumb);
      this._wrapperElement.appendChild(this._rangeContainer);
      this._minValue = parseFloat(this.element.min) || 0;
      this._maxValue = parseFloat(this.element.max) || 1;
      this._formatter = window[this.getAttribute("formatter")];
      if (this.element.id) {
        this._outputLabel = this._wrapperElement.find("output[for='".concat(this.element.id, "']"));
        if (this._outputLabel) {
          this._wrapperElement.appendChild(this._outputLabel);
        }
      }
      if (!this.element.step) {
        this.element.step = "any";
      }
      var options = this._getOptionsList();
      if (options && options.length) {
        this._addTicks(options);
      }
      if (this._rangeContainer.element.querySelectorAll(".".concat(CLASS_TICK_LABEL)).length <= 1) {
        this._thumbValue = new DomElement_default("div").addClass(CLASS_THUMB_VALUE);
        this._rangeThumb.appendChild(this._thumbValue);
      }
      this._trackValueTotal = this._maxValue - this._minValue;
      this.layout();
      this._updateTickState();
      var tabIndex = this.element.getAttribute("tabindex");
      if (tabIndex) {
        this._rangeContainer.setAttribute("tabindex", tabIndex);
      }
      window.addEventListener("resize", this._resizeHandler);
      window.addEventListener("orientationchange", this._resizeHandler);
    };
    Range2.prototype._getOptionsList = function() {
      var e_1, _a;
      var options = [];
      var listId = this.getAttribute("list");
      if (listId) {
        var dataList = document.querySelector("#".concat(listId));
        if (dataList) {
          try {
            for (var _b = __values(dataList.querySelectorAll("option")), _c = _b.next(); !_c.done; _c = _b.next()) {
              var entry = _c.value;
              var value = parseFloat(entry.innerText);
              var label = entry.getAttribute("label") || parseFloat(value.toFixed(2));
              options.push({
                value,
                label
              });
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return))
                _a.call(_b);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
        }
      }
      options = options.sort(function(a, b) {
        return a.value - b.value;
      });
      if (options.length > 1) {
        this._minValue = Number.MAX_VALUE;
        this._maxValue = Number.MIN_VALUE;
        for (var i = 0; i < options.length; i++) {
          this._minValue = Math.min(this._minValue, options[i].value);
          this._maxValue = Math.max(this._maxValue, options[i].value);
        }
      }
      return options;
    };
    Range2.prototype._addTicks = function(dataItems) {
      var e_2, _a;
      try {
        for (var dataItems_1 = __values(dataItems), dataItems_1_1 = dataItems_1.next(); !dataItems_1_1.done; dataItems_1_1 = dataItems_1.next()) {
          var entry = dataItems_1_1.value;
          var tickElement = new DomElement_default("div").setAttribute("data-value", String(entry.value)).addClass(CLASS_TICK);
          var tickLabel = new DomElement_default("span").addClass(CLASS_TICK_LABEL).setHtml(String(entry.label));
          tickElement.appendChild(tickLabel);
          this._ticksWrapper.appendChild(tickElement);
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (dataItems_1_1 && !dataItems_1_1.done && (_a = dataItems_1.return))
            _a.call(dataItems_1);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
    };
    Range2.prototype._isEventOnLabel = function(event) {
      var el = event.target;
      return el && el.classList.contains(CLASS_TICK_LABEL);
    };
    Range2.prototype._handleDown = function(event) {
      this._wrapperElement.addClass(CLASS_DRAGGING);
      this._rangeContainer.element.addEventListener("mouseup", this._endHandler);
      document.addEventListener("mousemove", this._moveHandler);
      document.addEventListener("mouseup", this._endHandler);
      this._rangeContainer.element.addEventListener("touchmove", this._moveHandler);
      document.addEventListener("touchend", this._endHandler);
      if (event.target !== this._rangeThumb.element && !this._isEventOnLabel(event)) {
        var pos = this._getRelativePosition(event);
        this._setPosition(pos, true, false, false);
      }
    };
    Range2.prototype._handleMove = function(event) {
      preventDefault(event);
      this._unfocus();
      if (!this._isEventOnLabel(event)) {
        var pos = this._getRelativePosition(event);
        this._setPosition(pos, true, false, false);
      }
    };
    Range2.prototype._handleEnd = function(event) {
      this._wrapperElement.removeClass(CLASS_DRAGGING);
      this._rangeContainer.element.removeEventListener("mouseup", this._endHandler);
      document.removeEventListener("mouseup", this._endHandler);
      document.removeEventListener("mousemove", this._moveHandler);
      this._rangeContainer.element.removeEventListener("touchmove", this._moveHandler);
      document.removeEventListener("touchend", this._endHandler);
      var pos = this._getRelativePosition(event);
      this._setPosition(pos, true, true, true);
      this._handleBlur();
    };
    Range2.prototype._handleKeydown = function(event) {
      var keycode = event.which || event.keyCode;
      if (keycode === KEY_ESCAPE) {
        this._rangeContainer.element.blur();
        return;
      }
      var isUp = keycode === KEY_ARROW_UP || keycode === KEY_ARROW_RIGHT || keycode === KEY_PAGE_UP;
      var isDown = keycode === KEY_ARROW_DOWN || keycode === KEY_ARROW_LEFT || keycode === KEY_PAGE_DOWN;
      if (isUp || isDown) {
        event.preventDefault();
        var direction = isDown ? -1 : 1;
        if (keycode === KEY_ARROW_UP || keycode === KEY_ARROW_DOWN || keycode === KEY_PAGE_UP || keycode === KEY_PAGE_DOWN) {
          direction *= 10;
        }
        var val = this.value;
        if (this._ticksWrapper.element.childNodes.length > 1) {
          val = this._getNextValue(val, direction);
        } else {
          var step = this.element.step;
          if (!step || step === "any") {
            step = "0.1";
          }
          var newVal = val + parseFloat(step) * direction;
          val = newVal;
        }
        this._setValue(val, true, true);
        return;
      }
    };
    Range2.prototype._handleFocus = function() {
      this._rangeContainer.addClass(CLASS_ACTIVE);
    };
    Range2.prototype._handleBlur = function() {
      this._rangeContainer.removeClass(CLASS_ACTIVE);
    };
    Range2.prototype._unfocus = function() {
      if (document.selection) {
        ;
        document.selection.empty();
      } else {
        window.getSelection().removeAllRanges();
      }
    };
    Range2.prototype._getRelativePosition = function(event) {
      var pageX;
      if ("pageX" in event) {
        pageX = event.pageX;
      } else {
        pageX = (event.touches[0] || event.changedTouches[0]).pageX;
      }
      return pageX - this._trackLeftPosition + this._grabPosition;
    };
    Range2.prototype._setPosition = function(position, updateValue, snap, animate) {
      if (updateValue === void 0) {
        updateValue = true;
      }
      if (snap === void 0) {
        snap = false;
      }
      if (animate === void 0) {
        animate = true;
      }
      if (position === void 0 || position === null || Number.isNaN(position)) {
        throw new Error("Position is not a number");
      }
      var newPos = clamp(position, this._trackPositionMin, this._trackPositionMax);
      if (updateValue) {
        var value = this._trackValueTotal / this._trackWidth * newPos + this._minValue;
        if (this._ticksWrapper.element.childNodes.length > 1 && snap) {
          var snapPos = this._getSnapPosition(newPos);
          newPos = snapPos.position;
          value = snapPos.value;
        } else if (this.element.step && this.element.step !== "any") {
          var step = parseFloat(this.element.step);
          value = Math.round(value / step) * step;
        }
        this._setValue(value, false, false);
      }
      if (animate && updateValue) {
        this._updateTickState();
      }
      if (animate) {
        animation.start(this._rangeThumb.element, { left: "".concat(newPos, "px") }, 200);
        if (this._rangeProgress) {
          animation.start(this._rangeProgress.element, { left: "".concat(newPos, "px") }, 200);
        }
      } else {
        this._rangeThumb.element.style.left = "".concat(newPos, "px");
        if (this._rangeProgress) {
          this._rangeProgress.element.style.width = "".concat(newPos, "px");
        }
      }
    };
    Range2.prototype._getSnapValue = function(value) {
      var ticks = this._ticksWrapper.element.children;
      var currentPosition = 0;
      for (var i = 0; i < ticks.length; i++) {
        var currentElement = new DomElement_default(ticks[i]);
        var currentValue = parseFloat(currentElement.getAttribute("data-value"));
        var currentWidth = currentElement.element.clientWidth;
        var nextElement = void 0;
        var nextValue = Number.MAX_VALUE;
        if (i < ticks.length - 1) {
          nextElement = new DomElement_default(ticks[i + 1]);
          nextValue = parseFloat(nextElement.getAttribute("data-value"));
        }
        if (i === 0 && value <= currentValue) {
          return {
            value: currentValue,
            position: MARGIN_TICK - this._grabPosition
          };
        }
        if (!nextElement && value >= currentValue) {
          return {
            value: currentValue,
            position: currentPosition + (currentWidth - MARGIN_TICK) - this._grabPosition - 1
          };
        }
        if (value >= currentValue && value < nextValue) {
          return {
            value: currentValue,
            position: currentPosition + 0.5 * currentWidth - this._grabPosition
          };
        }
        currentPosition += currentWidth;
      }
      throw new Error("Could not determine snap value");
    };
    Range2.prototype._getSnapPosition = function(position) {
      if (position === void 0 || position === null || Number.isNaN(position)) {
        throw new Error("position is not a number");
      }
      var ticks = this._ticksWrapper.element.children;
      var currentPosition = 0;
      for (var i = 0; i < ticks.length; i++) {
        var currentElement = new DomElement_default(ticks[i]);
        var currentValue = parseFloat(currentElement.getAttribute("data-value"));
        var currentWidth = currentElement.element.clientWidth;
        var nextElement = void 0;
        if (i < ticks.length - 1) {
          nextElement = new DomElement_default(ticks[i + 1]);
        }
        if (i === 0 && position <= currentPosition + currentWidth) {
          return {
            value: currentValue,
            position: MARGIN_TICK - this._grabPosition
          };
        }
        if (!nextElement && position >= currentPosition) {
          return {
            value: currentValue,
            position: currentPosition + (currentWidth - MARGIN_TICK) - this._grabPosition - 1
          };
        }
        if (position >= currentPosition && position < currentPosition + currentWidth) {
          return {
            value: currentValue,
            position: currentPosition + 0.5 * currentWidth - this._grabPosition
          };
        }
        currentPosition += currentWidth;
      }
      return {
        value: 0,
        position: 0
      };
    };
    Range2.prototype._getNextValue = function(value, direction) {
      var ticks = this._ticksWrapper.element.children;
      for (var i = 0; i < ticks.length; i++) {
        var currentElement = new DomElement_default(ticks[i]);
        var currentVal = parseFloat(currentElement.getAttribute("data-value"));
        if (value === currentVal) {
          var index = clamp(i + direction, 0, ticks.length - 1);
          value = parseFloat(ticks[index].getAttribute("data-value"));
        }
      }
      return value;
    };
    Range2.prototype._updateTickState = function() {
      if (this._ticksWrapper.element.childNodes.length > 1) {
        var activeTick = this._ticksWrapper.find(".".concat(CLASS_TICK_ACTIVE));
        if (activeTick) {
          activeTick.removeClass(CLASS_TICK_ACTIVE);
        }
        var newActiveTick = this._ticksWrapper.find(".".concat(CLASS_TICK, "[data-value='").concat(this.value, "']"));
        if (newActiveTick) {
          newActiveTick.addClass(CLASS_TICK_ACTIVE);
        }
      }
    };
    Range2.prototype._adjustTickLabelPosition = function(tickItem, left) {
      var label = new DomElement_default(tickItem.querySelector(".".concat(CLASS_TICK_LABEL)));
      var dummyElement = new DomElement_default("span").addClass(CLASS_TICK_LABEL).setAttribute("style", "visibility: hidden; display: inline-block;").setHtml(label.innerText);
      this._rangeContainer.appendChild(dummyElement);
      var width = dummyElement.element.clientWidth / 2;
      this._rangeContainer.removeChild(dummyElement);
      var floatPosition = left ? "left" : "right";
      if (width < MARGIN_TICK) {
        label.setAttribute("style", "".concat(floatPosition, ": ").concat(MARGIN_TICK - Math.floor(width), "px; text-align: ").concat(floatPosition, ";"));
      }
    };
    Range2.prototype._formatOutput = function(value, short) {
      if (this._formatter) {
        return this._formatter(value, short);
      }
      var str = parseFloat(value.toFixed(2));
      return str.toString();
    };
    Range2.prototype._setValue = function(value, update, animate) {
      if (update === void 0) {
        update = true;
      }
      if (animate === void 0) {
        animate = false;
      }
      var val = clamp(value, this._minValue, this._maxValue);
      var position;
      if (this._ticksWrapper.element.childNodes.length > 1) {
        var snapValue = this._getSnapValue(val);
        position = snapValue.position;
        val = snapValue.value;
      } else if (this._ticksWrapper.element.childNodes.length === 1) {
        position = this._getSnapPosition(val).position;
        this.disable();
      } else {
        position = this._trackWidth / this._trackValueTotal * (value - this._minValue);
      }
      this.element.value = String(val);
      if (this._thumbValue) {
        this._thumbValue.setHtml(this._formatOutput(val, true));
      }
      if (this._outputLabel) {
        this._outputLabel.setHtml(this._formatOutput(val, false));
      }
      if (update) {
        this._setPosition(position, false, false, animate);
        this._updateTickState();
      }
      this.dispatchEvent("input");
    };
    Object.defineProperty(Range2.prototype, "value", {
      get: function() {
        return parseFloat(this.element.value);
      },
      set: function(value) {
        this._setValue(value, true, true);
      },
      enumerable: false,
      configurable: true
    });
    Range2.prototype.layout = function() {
      this._grabPosition = Math.round(this._rangeThumb.element.offsetWidth / 2);
      var tickItems = this._rangeContainer.element.querySelectorAll(".".concat(CLASS_TICK));
      var ticksOffset = tickItems && tickItems.length > 0 ? 2 * MARGIN_TICK : MARGIN_TICK;
      this._trackWidth = this._rangeTrack.element.offsetWidth - ticksOffset;
      this._trackPositionMin = 0;
      this._trackPositionMax = this._rangeTrack.element.clientWidth - this._rangeThumb.element.offsetWidth + 1;
      this._trackLeftPosition = this._rangeTrack.element.getBoundingClientRect().left + MARGIN_TICK;
      var itemCount = tickItems.length - 1;
      this._itemWidth = this._trackWidth / itemCount;
      var outerItemsWidth = this._itemWidth * 0.5 + MARGIN_TICK;
      for (var i = 0; i <= itemCount; i++) {
        var width = this._itemWidth;
        if (i === 0 || i === itemCount) {
          width = outerItemsWidth;
        }
        var item = new DomElement_default(tickItems[i]);
        item.setAttribute("style", "width: ".concat(Math.floor(width), "px;"));
      }
      if (tickItems.length > 1) {
        this._adjustTickLabelPosition(tickItems[0], true);
        this._adjustTickLabelPosition(tickItems[tickItems.length - 1], false);
      }
      this._setValue(parseFloat(this.element.value), true, false);
    };
    Range2.prototype.destroy = function() {
      window.removeEventListener("resize", this._resizeHandler);
      window.removeEventListener("orientationchange", this._resizeHandler);
      this._downHandler = null;
      this._moveHandler = null;
      this._endHandler = null;
      this._focusHandler = null;
      this._blurHandler = null;
      this.element = null;
      this._rangeContainer = null;
      this._wrapperElement = null;
    };
    Range2.prototype.destoy = function() {
      this.destroy();
    };
    Range2.prototype.enable = function() {
      this.element.removeAttribute("disabled");
      this._wrapperElement.removeClass(CLASS_DISABLED2);
      this._rangeContainer.element.addEventListener("mousedown", this._downHandler);
      this._rangeContainer.element.addEventListener("touchstart", this._downHandler);
      this._rangeContainer.element.addEventListener("keydown", this._keydownHandler);
      this._rangeContainer.element.addEventListener("focus", this._focusHandler);
      this._rangeContainer.element.addEventListener("blur", this._blurHandler);
    };
    Range2.prototype.disable = function() {
      this.element.setAttribute("disabled", "");
      this._wrapperElement.addClass(CLASS_DISABLED2);
      this._rangeContainer.element.removeEventListener("mousedown", this._downHandler);
      this._rangeContainer.element.removeEventListener("mouseup", this._endHandler);
      this._rangeContainer.element.removeEventListener("mousemove", this._moveHandler);
      this._rangeContainer.element.removeEventListener("touchstart", this._downHandler);
      this._rangeContainer.element.removeEventListener("focus", this._focusHandler);
      this._rangeContainer.element.removeEventListener("blur", this._blurHandler);
    };
    return Range2;
  }(DomElement_default);
  function init5() {
    searchAndInitialize("input[type='range']", function(e) {
      new Range(e);
    });
  }
  var Range_default = Range;

  // build/ts/main/src/form/Autocomplete.js
  var QUERY_DROPDOWN = ".js-autocomplete";
  var CLASS_RESULT = "autocomplete__result";
  var CLASS_OPEN2 = "is-open";
  var CLASS_HOVER = "js-hover";
  var ATTRIBUTE_VALUE = "data-value";
  var TIMEOUT_BLUR2 = 400;
  var Autocomplete = function(_super) {
    __extends(Autocomplete2, _super);
    function Autocomplete2(element, configuration) {
      var _this = _super.call(this, element) || this;
      _this._input = _this.element.querySelector("input");
      _this._dropdown = _this.element.querySelector(QUERY_DROPDOWN);
      _this._clickHandler = _this._handleClick.bind(_this);
      _this._windowClickHandler = _this._handleWindowClick.bind(_this);
      _this._keyUpHandler = _this._handleKeyUp.bind(_this);
      _this._keyDownHandler = _this._handleKeyDown.bind(_this);
      _this._blurHandler = _this._handleBlur.bind(_this);
      if (configuration) {
        _this._minChars = configuration.minChars;
        _this._source = configuration.source;
      }
      if (!_this._minChars || _this._minChars < 0) {
        _this._minChars = 2;
      }
      _this._initialize();
      return _this;
    }
    Autocomplete2.prototype._initialize = function() {
      this._clearSuggestions();
      if (this._input.getAttribute("disabled")) {
        this.disable();
      } else {
        this.enable();
      }
      this._input.setAttribute("autocomplete", "off");
    };
    Autocomplete2.prototype.configure = function(configuration) {
      if (!configuration) {
        return;
      }
      if (configuration.minChars) {
        this._minChars = Math.min(configuration.minChars, 1);
      }
      if (configuration.source) {
        this._source = configuration.source;
      }
      this._clearSuggestions();
    };
    Autocomplete2.prototype.enable = function() {
      if (!this._input) {
        return;
      }
      this._input.removeAttribute("disabled");
      this._input.addEventListener("keyup", this._keyUpHandler);
      this._input.addEventListener("keydown", this._keyDownHandler);
      this._input.addEventListener("blur", this._blurHandler);
    };
    Autocomplete2.prototype.disable = function() {
      if (!this._input) {
        return;
      }
      this._input.setAttribute("disabled", "true");
      this._input.removeEventListener("keyup", this._keyUpHandler);
      this._input.removeEventListener("keydown", this._keyDownHandler);
      this._input.removeEventListener("blur", this._blurHandler);
      this.close();
    };
    Autocomplete2.prototype.destroy = function() {
      this.disable();
      this._keyUpHandler = void 0;
      this._keyDownHandler = void 0;
      this._windowClickHandler = void 0;
      this._blurHandler = void 0;
      this._input = void 0;
    };
    Autocomplete2.prototype.open = function() {
      this._dropdown.addEventListener("click", this._clickHandler);
      window.addEventListener("click", this._windowClickHandler);
      this.addClass(CLASS_OPEN2);
    };
    Autocomplete2.prototype.close = function() {
      this._dropdown.removeEventListener("click", this._clickHandler);
      window.removeEventListener("click", this._windowClickHandler);
      this.removeClass(CLASS_OPEN2);
    };
    Object.defineProperty(Autocomplete2.prototype, "value", {
      get: function() {
        return this._input.value;
      },
      enumerable: false,
      configurable: true
    });
    Autocomplete2.prototype._handleClick = function(event) {
      if (!this._isDropdownTarget(event.target)) {
        return;
      }
      var current = event.target;
      while (current.nodeName !== "LI" && current.parentNode) {
        current = current.parentNode;
      }
      if (current.nodeName === "LI") {
        preventDefault(event);
        this._selectItem(current);
      }
    };
    Autocomplete2.prototype._handleBlur = function() {
      var _this = this;
      setTimeout(function() {
        _this.close();
      }, TIMEOUT_BLUR2);
    };
    Autocomplete2.prototype._handleKeyUp = function(evt) {
      var keycode = evt.which || evt.keyCode;
      if (containsKey(keycode, [
        KEY_ARROW_UP,
        KEY_ARROW_DOWN,
        KEY_ENTER,
        KEY_TAB
      ])) {
        preventDefault(evt);
        return;
      }
      var target = evt.currentTarget;
      if (evt.currentTarget && target.value && target.value.length >= this._minChars) {
        this._getSuggestion(target.value);
      } else {
        this.close();
      }
    };
    Autocomplete2.prototype._handleKeyDown = function(evt) {
      var keycode = evt.which || evt.keyCode;
      var isOpen = hasClass(this.element, CLASS_OPEN2);
      if (keycode === KEY_ESCAPE && isOpen === true) {
        this.close();
        preventDefault(evt);
        return;
      }
      if (isOpen === true && containsKey(keycode, [KEY_ENTER, KEY_TAB])) {
        var focusedElement = this._suggestionList.querySelector(".".concat(CLASS_HOVER));
        preventDefault(evt);
        this._selectItem(focusedElement);
        return;
      }
      if (isOpen === true && containsKey(keycode, [KEY_ARROW_UP, KEY_ARROW_DOWN])) {
        var focusedElement = this._suggestionList.querySelector(".".concat(CLASS_HOVER));
        if (focusedElement) {
          removeClass(focusedElement, CLASS_HOVER);
          var children = Array.prototype.slice.call(this._suggestionList.childNodes);
          var totalNodes = children.length - 1;
          var direction = keycode === KEY_ARROW_UP ? -1 : 1;
          var index = children.indexOf(focusedElement);
          index = Math.max(Math.min(index + direction, totalNodes), 0);
          focusedElement = this._suggestionList.childNodes[index];
        } else {
          focusedElement = this._suggestionList.querySelector("li");
        }
        addClass(focusedElement, CLASS_HOVER);
        preventDefault(evt);
        return;
      }
    };
    Autocomplete2.prototype._handleWindowClick = function(event) {
      if (this._isDropdownTarget(event.target)) {
        return;
      }
      this.close();
    };
    Autocomplete2.prototype._selectItem = function(item) {
      if (!item) {
        return;
      }
      var text2 = item.getAttribute(ATTRIBUTE_VALUE);
      if (text2) {
        this._input.value = text2;
        this.dispatchEvent("change");
      }
      this.close();
    };
    Autocomplete2.prototype._isDropdownTarget = function(target) {
      var current = target;
      while (current !== this._dropdown && current.parentNode) {
        current = current.parentNode;
      }
      return current === this._dropdown;
    };
    Autocomplete2.prototype._clearSuggestions = function() {
      empty(this._dropdown);
      this._suggestionList = document.createElement("ul");
      this._dropdown.appendChild(this._suggestionList);
    };
    Autocomplete2.prototype._addSuggestion = function(text2, term) {
      var escapedTerm = term.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
      var html = text2.replace(new RegExp("(".concat(escapedTerm, ")"), "gi"), "<strong>$1</strong>");
      var textElement = new DomElement_default("span").setHtml(html, true);
      var innerElement = new DomElement_default("div").addClass(CLASS_RESULT).appendChild(textElement);
      var liElement = new DomElement_default("li").setAttribute(ATTRIBUTE_VALUE, text2).appendChild(innerElement);
      this._suggestionList.appendChild(liElement.element);
    };
    Autocomplete2.prototype._getSuggestion = function(term) {
      var _this = this;
      if (!this._source) {
        throw new Error("The source function is undefined, cannot load suggestions");
      }
      this._source(term, function(matches, termused) {
        _this._onMatchesReceived(matches, termused);
      });
    };
    Autocomplete2.prototype._onMatchesReceived = function(matches, term) {
      var e_1, _a;
      this._clearSuggestions();
      if (!matches || matches.length === 0) {
        this.close();
      } else {
        empty(this._suggestionList);
        try {
          for (var matches_1 = __values(matches), matches_1_1 = matches_1.next(); !matches_1_1.done; matches_1_1 = matches_1.next()) {
            var match = matches_1_1.value;
            this._addSuggestion(match, term);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (matches_1_1 && !matches_1_1.done && (_a = matches_1.return))
              _a.call(matches_1);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
        this.open();
      }
    };
    return Autocomplete2;
  }(DomElement_default);
  function init6() {
    searchAndInitialize(".input-field--autocomplete", function(e) {
      new Autocomplete(e);
    });
  }
  var Autocomplete_default = Autocomplete;

  // build/ts/main/src/progress/ProgressLight.js
  var CLASS_BAR = ".progress-light__bar";
  var CLASS_PROGRESS = ".bar__progress";
  var CLASS_PROGRESS_COMPLETED = "bar__progress--complete";
  var CLASS_TICK2 = "bar__tick";
  var CLASS_PAGE_CURRENT = ".detail__currentpage";
  var CLASS_PAGE_TOTAL = ".detail__totalpage";
  var CLASS_DISABLED3 = "arrow--disabled";
  var CLASS_BUTTON_LEFT = ".arrow--left";
  var CLASS_BUTTON_RIGHT = ".arrow--right";
  var ProgressLight = function(_super) {
    __extends(ProgressLight2, _super);
    function ProgressLight2(element) {
      var _this = _super.call(this, element) || this;
      _this._initialize();
      return _this;
    }
    ProgressLight2.prototype._initialize = function() {
      this._buttonClickHandler = this._handleButtonClick.bind(this);
      this._animationCompletedHandler = this._handleAnimationCompleted.bind(this);
      this._barElement = this.find(CLASS_BAR);
      this._progressElement = this.find(CLASS_PROGRESS);
      this._pageCurrentElement = this.find(CLASS_PAGE_CURRENT);
      this._pageTotalElement = this.find(CLASS_PAGE_TOTAL);
      this._buttonLeft = this.find(CLASS_BUTTON_LEFT);
      this._buttonRight = this.find(CLASS_BUTTON_RIGHT);
      this._minValue = 1;
      this._total = Math.max(parseInt(this.getAttribute("total") || "100", 10), this._minValue);
      this._value = clamp(parseInt(this.getAttribute("value") || "1", 10), this._minValue, this._total);
      this._layout();
      this._addTicks();
      this._update(false);
      this.enable();
    };
    ProgressLight2.prototype._addTicks = function() {
      for (var i = 1; i < this._total; i++) {
        var position = this._itemWidth * i;
        var tickElement = new DomElement_default("div").addClass(CLASS_TICK2).setAttribute("style", "left: ".concat(position, "%"));
        this._barElement.prependChild(tickElement);
      }
    };
    ProgressLight2.prototype._update = function(animate) {
      var _this = this;
      if (animate === void 0) {
        animate = true;
      }
      this._pageCurrentElement.setHtml(this._value.toString());
      this._pageTotalElement.setHtml(this._total.toString());
      var position = this._value * this._itemWidth;
      if (this._value === this._total) {
        position += 5;
      }
      if (this._value >= this._total) {
        this._buttonRight.addClass(CLASS_DISABLED3);
      } else {
        this._buttonRight.removeClass(CLASS_DISABLED3);
      }
      if (this._value <= this._minValue) {
        this._buttonLeft.addClass(CLASS_DISABLED3);
      } else {
        this._buttonLeft.removeClass(CLASS_DISABLED3);
      }
      var el = this._progressElement.element;
      if (animate) {
        animation.start(this._progressElement.element, {
          width: "".concat(this._barElement.element.clientWidth * position / 100, "px")
        }, 200, {
          finished: function() {
            animation.set(el, { width: "".concat(position, "%") });
            _this._animationCompletedHandler({});
          }
        });
      } else {
        el.style.width = "".concat(position, "%");
        this._animationCompletedHandler({});
      }
    };
    ProgressLight2.prototype._layout = function() {
      this._itemWidth = Math.floor(100 / this._total);
    };
    ProgressLight2.prototype._handleButtonClick = function(event) {
      if (event.target === this._buttonLeft.element) {
        this.value = this._value - 1;
      } else if (event.target === this._buttonRight.element) {
        this.value = this._value + 1;
      }
    };
    ProgressLight2.prototype._handleAnimationCompleted = function() {
      if (this._value === this._total) {
        this._progressElement.addClass(CLASS_PROGRESS_COMPLETED);
      } else {
        this._progressElement.removeClass(CLASS_PROGRESS_COMPLETED);
      }
    };
    Object.defineProperty(ProgressLight2.prototype, "value", {
      get: function() {
        return this._value;
      },
      set: function(val) {
        this._value = clamp(val, this._minValue, this._total);
        this._update(true);
        this.dispatchEvent("changed");
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(ProgressLight2.prototype, "total", {
      get: function() {
        return this._total;
      },
      set: function(value) {
        var e_1, _a;
        if (this._total === value) {
          return;
        }
        this._total = Math.max(value, this._minValue);
        this._value = clamp(this._value, this._minValue, this._total);
        try {
          for (var _b = __values(this.element.querySelectorAll(".".concat(CLASS_TICK2))), _c = _b.next(); !_c.done; _c = _b.next()) {
            var tick = _c.value;
            this._barElement.element.removeChild(tick);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return))
              _a.call(_b);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
        this._layout();
        this._addTicks();
        this._update(false);
        this.dispatchEvent("totalchanged");
      },
      enumerable: false,
      configurable: true
    });
    ProgressLight2.prototype.enable = function() {
      this._buttonLeft.element.addEventListener("click", this._buttonClickHandler);
      this._buttonRight.element.addEventListener("click", this._buttonClickHandler);
    };
    ProgressLight2.prototype.disable = function() {
      this._buttonLeft.element.removeEventListener("click", this._buttonClickHandler);
      this._buttonRight.element.removeEventListener("click", this._buttonClickHandler);
    };
    return ProgressLight2;
  }(DomElement_default);
  function init7() {
    searchAndInitialize(".progress-light", function(e) {
      new ProgressLight(e);
    });
  }
  var ProgressLight_default = ProgressLight;

  // build/ts/main/src/progress/ProgressFull.js
  var CLASS_HEADER = ".progress-full__bar";
  var CLASS_SECTIONS = ".progress-full__sections > span";
  var CLASS_SECTION_ACTIVE = "section--active";
  var CLASS_INDICATOR = "indicator";
  var CLASS_INDICATOR_CURRENT = "indicator--current";
  var CLASS_INDICATOR_COMPLETED = "indicator--completed";
  var ProgressFull = function(_super) {
    __extends(ProgressFull2, _super);
    function ProgressFull2(element) {
      var _this = _super.call(this, element) || this;
      _this._initialize();
      return _this;
    }
    ProgressFull2.prototype._initialize = function() {
      this._buttonClickHandler = this._handleButtonClick.bind(this);
      this._keydownHandler = this._handleKeydown.bind(this);
      this._headerElement = this.find(CLASS_HEADER);
      this._pages = this.element.querySelectorAll(CLASS_SECTIONS);
      this._minValue = 1;
      this._value = 1;
      this._total = this._pages.length;
      for (var index = 0; index < this._pages.length; index++) {
        if (this._pages[index].classList.contains(CLASS_SECTION_ACTIVE)) {
          this._value = index + 1;
        }
      }
      this._addIncicators();
      this._update(-1, this._value, false);
      var tabIndex = this.getAttribute("tabindex");
      if (tabIndex) {
        this.setAttribute("tabindex", "");
        this._headerElement.setAttribute("tabindex", tabIndex);
      }
      this._headerElement.element.addEventListener("click", this._buttonClickHandler);
      this._headerElement.element.addEventListener("keydown", this._keydownHandler);
    };
    ProgressFull2.prototype._addIncicators = function() {
      for (var i = this._pages.length - 1; i >= 0; i--) {
        var indicatorElement = new DomElement_default("button").addClass(CLASS_INDICATOR).setAttribute("data-value", "".concat(i + 1)).setHtml((i + 1).toString());
        this._headerElement.prependChild(indicatorElement);
      }
    };
    ProgressFull2.prototype._update = function(oldValue, newValue, animate) {
      if (animate === void 0) {
        animate = true;
      }
      var indicators = this._headerElement.element.childNodes;
      for (var index = 0; index < indicators.length; index++) {
        var indicatorElement = new DomElement_default(indicators[index]);
        if (index + 1 < this._value) {
          indicatorElement.removeClass(CLASS_INDICATOR_CURRENT).addClass(CLASS_INDICATOR_COMPLETED);
        }
        if (index + 1 === this._value) {
          indicatorElement.removeClass(CLASS_INDICATOR_COMPLETED).addClass(CLASS_INDICATOR_CURRENT);
        }
        if (index + 1 > this._value) {
          indicatorElement.removeClass(CLASS_INDICATOR_COMPLETED).removeClass(CLASS_INDICATOR_CURRENT);
        }
      }
      if (oldValue !== newValue) {
        var direction = Math.sign(oldValue - newValue);
        if (oldValue > 0 && oldValue !== newValue) {
          var oldSection_1 = new DomElement_default(this._pages[oldValue - 1]);
          if (animate) {
            animation.start(oldSection_1.element, { left: "".concat(100 * direction, "px"), opacity: "0" }, 300, {
              finished: function() {
                oldSection_1.removeClass(CLASS_SECTION_ACTIVE);
                oldSection_1.setAttribute("style", "");
              }
            });
          } else {
            oldSection_1.removeClass(CLASS_SECTION_ACTIVE);
            oldSection_1.setAttribute("style", "");
          }
        }
        var newSection_1 = new DomElement_default(this._pages[newValue - 1]);
        if (animate) {
          animation.set(newSection_1.element, {
            left: "".concat(-100 * direction, "px"),
            opacity: "0"
          });
          newSection_1.addClass(CLASS_SECTION_ACTIVE);
          animation.start(newSection_1.element, {
            left: "0",
            opacity: "1"
          }, 300, {
            finished: function() {
              newSection_1.setAttribute("style", "");
            }
          });
        } else {
          newSection_1.addClass(CLASS_SECTION_ACTIVE);
          newSection_1.setAttribute("style", "");
        }
      }
    };
    ProgressFull2.prototype._handleButtonClick = function(event) {
      var element = new DomElement_default(event.target);
      if (!element.hasClass(CLASS_INDICATOR)) {
        return;
      }
      var value = element.getAttribute("data-value");
      this.value = parseFloat(value);
    };
    ProgressFull2.prototype._handleKeydown = function(event) {
      var keyboardEvent = event;
      var keycode = keyboardEvent.which || keyboardEvent.keyCode;
      if (keycode === KEY_ARROW_RIGHT) {
        this.value += 1;
        preventDefault(keyboardEvent);
        return;
      }
      if (keycode === KEY_ARROW_LEFT) {
        this.value -= 1;
        preventDefault(keyboardEvent);
        return;
      }
      if (keycode >= KEY_NR_0 && keycode <= KEY_NR_9) {
        this.value = keycode - KEY_NR_0;
        preventDefault(keyboardEvent);
        return;
      }
    };
    Object.defineProperty(ProgressFull2.prototype, "value", {
      get: function() {
        return this._value;
      },
      set: function(val) {
        var oldValue = this._value;
        this._value = clamp(val, this._minValue, this._total);
        this._update(oldValue, this._value, true);
        this.dispatchEvent("changed");
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(ProgressFull2.prototype, "total", {
      get: function() {
        return this._total;
      },
      enumerable: false,
      configurable: true
    });
    return ProgressFull2;
  }(DomElement_default);
  function init8() {
    searchAndInitialize(".progress-full", function(e) {
      new ProgressFull(e);
    });
  }
  var ProgressFull_default = ProgressFull;

  // build/ts/main/src/modal/Modal.js
  var import_body_scroll_lock = __toESM(require_bodyScrollLock_min());
  var CLASS_BACKDROP = "backdrop";
  var CLASS_BACKDROP_OPEN = "backdrop--open";
  var CLASS_OPEN3 = "modal--open";
  var CLASS_TRIGGER = "modal-trigger";
  var CLASS_BODY = "modal__body";
  var CLASS_BUTTONS_OKAY = ".modal-close";
  var CLASS_BUTTONS_CLOSE = ".modal-cancel";
  var Modal = function(_super) {
    __extends(Modal2, _super);
    function Modal2(element) {
      var _this = _super.call(this, element) || this;
      _this._okayHandler = _this.close.bind(_this);
      _this._cancelHandler = _this._handleClick.bind(_this);
      _this._keydownHandler = _this._handleKeydown.bind(_this);
      _this._initialize();
      return _this;
    }
    Modal2.prototype._initialize = function() {
      this._backdrop = new DomElement_default("div").addClass(CLASS_BACKDROP);
      this._backdropParent = getRootElement();
      this._subscribeToTrigger();
    };
    Modal2.prototype._subscribeToTrigger = function() {
      var e_1, _a;
      var triggerId = this.element.id;
      if (!triggerId) {
        return;
      }
      this._triggerClickHandler = this.open.bind(this);
      var triggerElements = document.querySelectorAll(".".concat(CLASS_TRIGGER, "[href=").concat(triggerId, "]"));
      try {
        for (var triggerElements_1 = __values(triggerElements), triggerElements_1_1 = triggerElements_1.next(); !triggerElements_1_1.done; triggerElements_1_1 = triggerElements_1.next()) {
          var triggerElement = triggerElements_1_1.value;
          triggerElement.addEventListener("click", this._triggerClickHandler);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (triggerElements_1_1 && !triggerElements_1_1.done && (_a = triggerElements_1.return))
            _a.call(triggerElements_1);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    };
    Modal2.prototype._unsubscribeFromTrigger = function() {
      var e_2, _a;
      var triggerId = this.element.id;
      if (!triggerId) {
        return;
      }
      var triggerElements = document.querySelectorAll(".".concat(CLASS_TRIGGER, "[href=").concat(triggerId, "]"));
      try {
        for (var triggerElements_2 = __values(triggerElements), triggerElements_2_1 = triggerElements_2.next(); !triggerElements_2_1.done; triggerElements_2_1 = triggerElements_2.next()) {
          var triggerElement = triggerElements_2_1.value;
          triggerElement.removeEventListener("click", this._windowClickHandler);
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (triggerElements_2_1 && !triggerElements_2_1.done && (_a = triggerElements_2.return))
            _a.call(triggerElements_2);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      this._triggerClickHandler = void 0;
    };
    Modal2.prototype._handleKeydown = function(event) {
      var keyboardEvent = event;
      var keycode = keyboardEvent.which || keyboardEvent.keyCode;
      if (keycode === KEY_ESCAPE) {
        this.cancel();
        return;
      }
    };
    Modal2.prototype._handleClick = function(event) {
      preventDefault(event);
      this.cancel();
    };
    Modal2.prototype._close = function() {
      var e_3, _a, e_4, _b;
      var _this = this;
      (0, import_body_scroll_lock.enableBodyScroll)(this.element);
      document.removeEventListener("keydown", this._keydownHandler);
      this._backdrop.element.removeEventListener("click", this._cancelHandler);
      this._backdrop.removeClass(CLASS_BACKDROP_OPEN);
      this.removeClass(CLASS_OPEN3);
      try {
        for (var _c = __values(this.element.querySelectorAll(CLASS_BUTTONS_CLOSE)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var closeButton = _d.value;
          closeButton.removeEventListener("click", this._cancelHandler);
        }
      } catch (e_3_1) {
        e_3 = { error: e_3_1 };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return))
            _a.call(_c);
        } finally {
          if (e_3)
            throw e_3.error;
        }
      }
      try {
        for (var _e = __values(this.element.querySelectorAll(CLASS_BUTTONS_OKAY)), _f = _e.next(); !_f.done; _f = _e.next()) {
          var okayButton = _f.value;
          okayButton.removeEventListener("click", this._okayHandler);
        }
      } catch (e_4_1) {
        e_4 = { error: e_4_1 };
      } finally {
        try {
          if (_f && !_f.done && (_b = _e.return))
            _b.call(_e);
        } finally {
          if (e_4)
            throw e_4.error;
        }
      }
      setTimeout(function() {
        _this._backdropParent.removeChild(_this._backdrop.element);
      }, 300);
    };
    Modal2.prototype.open = function() {
      var _this = this;
      (0, import_body_scroll_lock.disableBodyScroll)(this.element, {
        allowTouchMove: function(el) {
          var currentEl = el;
          while (currentEl && currentEl !== document.body) {
            if (currentEl.classList.contains(CLASS_BODY)) {
              if (currentEl.scrollHeight > currentEl.clientHeight) {
                return true;
              }
            }
            currentEl = currentEl.parentNode;
          }
          return false;
        }
      });
      this._backdropParent.appendChild(this._backdrop.element);
      this.element.style.display = "flex";
      setTimeout(function() {
        _this.element.style.display = "";
      }, 800);
      setTimeout(function() {
        var e_5, _a, e_6, _b;
        _this.addClass(CLASS_OPEN3);
        _this._backdrop.addClass(CLASS_BACKDROP_OPEN);
        document.addEventListener("keydown", _this._keydownHandler);
        _this._backdrop.element.addEventListener("click", _this._cancelHandler);
        try {
          for (var _c = __values(_this.element.querySelectorAll(CLASS_BUTTONS_CLOSE)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var closeButton = _d.value;
            closeButton.addEventListener("click", _this._cancelHandler);
          }
        } catch (e_5_1) {
          e_5 = { error: e_5_1 };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return))
              _a.call(_c);
          } finally {
            if (e_5)
              throw e_5.error;
          }
        }
        try {
          for (var _e = __values(_this.element.querySelectorAll(CLASS_BUTTONS_OKAY)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var okayButton = _f.value;
            okayButton.addEventListener("click", _this._okayHandler);
          }
        } catch (e_6_1) {
          e_6 = { error: e_6_1 };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return))
              _b.call(_e);
          } finally {
            if (e_6)
              throw e_6.error;
          }
        }
        _this.element.addEventListener("click", function(e) {
          return e.stopPropagation();
        });
        _this.dispatchEvent("opened");
      }, 50);
    };
    Modal2.prototype.cancel = function() {
      this.dispatchEvent("cancelled");
      this._close();
    };
    Modal2.prototype.close = function() {
      this._close();
      this.dispatchEvent("closed");
    };
    Modal2.prototype.destroy = function() {
      this.cancel();
      this._unsubscribeFromTrigger();
    };
    return Modal2;
  }(DomElement_default);
  function init9() {
    searchAndInitialize(".modal", function(e) {
      new Modal(e);
    });
  }
  var Modal_default = Modal;

  // build/ts/main/src/toolbar/Toolbar.js
  var CLASS_ITEMS = ".toolbar__item";
  var CLASS_SHOW = "item--show";
  var ANIMATION_OFFSET = 50;
  var Toolbar = function(_super) {
    __extends(Toolbar2, _super);
    function Toolbar2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Toolbar2.prototype.show = function() {
      var items = this.element.querySelectorAll(CLASS_ITEMS);
      items.forEach(function(item, i) {
        return setTimeout(function() {
          return item.classList.add(CLASS_SHOW);
        }, i * ANIMATION_OFFSET);
      });
    };
    Toolbar2.prototype.hide = function() {
      var items = this.element.querySelectorAll(CLASS_ITEMS);
      items.forEach(function(item, i) {
        return setTimeout(function() {
          item.classList.remove(CLASS_SHOW);
        }, i * ANIMATION_OFFSET);
      });
    };
    Toolbar2.prototype.toggle = function() {
      if (this.element.querySelectorAll(".".concat(CLASS_SHOW)).length === 0) {
        this.show();
      } else {
        this.hide();
      }
    };
    return Toolbar2;
  }(DomElement_default);
  var Toolbar_default = Toolbar;

  // build/ts/main/src/notification/Notification.js
  var Notification_exports = {};
  __export(Notification_exports, {
    NotificationHeader: () => NotificationHeader,
    showOnHeader: () => showOnHeader
  });
  var CLASS_NOTIFICATION = "notification-header";
  var CLASS_OPEN4 = "notification--open";
  var CLASS_BUTTON_CLOSE = "notification__close";
  var CLOSE_ICON = "icon-022-close";
  function showOnHeader(containerId, message, messageClickCallback, cancelCallback, modifierClass) {
    var containerE = document.querySelector("#".concat(containerId));
    if (!containerE) {
      throw new Error("Could not find the container with id ".concat(containerId));
    }
    var notificationElement = new NotificationHeader();
    if (modifierClass) {
      notificationElement.addClass(modifierClass);
    }
    notificationElement.message = message;
    notificationElement.messageClickCallback = messageClickCallback;
    notificationElement.cancelCallback = cancelCallback;
    containerE.insertAdjacentElement("afterend", notificationElement.element);
    notificationElement._open();
    return notificationElement;
  }
  var NotificationHeader = function(_super) {
    __extends(NotificationHeader2, _super);
    function NotificationHeader2() {
      var _this = _super.call(this, "div") || this;
      _this._closeHandler = _this._handleClose.bind(_this);
      _this._clickHandler = _this._handleClick.bind(_this);
      _this._initialize();
      return _this;
    }
    NotificationHeader2.prototype._initialize = function() {
      this.addClass(CLASS_NOTIFICATION);
      this.addClass(CLASS_OPEN4);
      var notificationContent = new DomElement_default("div").addClass("notification__content");
      this.appendChild(notificationContent);
      this._notificationBody = new DomElement_default("div").addClass("notification__body");
      notificationContent.appendChild(this._notificationBody);
      this._closeButton = new DomElement_default("button").addClass(CLASS_BUTTON_CLOSE).addClass("notification-cancel").setAttribute("aria-label", "Close");
      var closeIcon = new DomElement_default("i").addClass("icon").addClass(CLOSE_ICON).setAttribute("aria-hidden", "true");
      this._closeButton.appendChild(closeIcon);
      notificationContent.appendChild(this._closeButton);
      this.element.addEventListener("click", this._clickHandler);
    };
    NotificationHeader2.prototype._handleClick = function(event) {
      preventDefault(event);
      var closeNotification = true;
      if (this._callback) {
        if (this._callback(this) === false) {
          closeNotification = false;
        }
      }
      if (closeNotification === true) {
        this.close();
      }
    };
    NotificationHeader2.prototype._handleClose = function(event) {
      preventDefault(event);
      event.stopPropagation();
      if (this._cancelCallback) {
        this._cancelCallback(this);
      }
      this.close();
    };
    NotificationHeader2.prototype._close = function() {
      this.removeClass(CLASS_OPEN4);
      this._closeButton.element.removeEventListener("click", this._closeHandler);
      var el = this.element;
      setTimeout(function() {
        if (el && el.parentElement) {
          el.parentElement.removeChild(el);
        }
      }, 300);
    };
    NotificationHeader2.prototype._open = function() {
      this.addClass(CLASS_OPEN4);
      this._closeButton.element.addEventListener("click", this._closeHandler);
      this.dispatchEvent("opened");
    };
    Object.defineProperty(NotificationHeader2.prototype, "messageClickCallback", {
      set: function(callback) {
        this._callback = callback;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NotificationHeader2.prototype, "cancelCallback", {
      set: function(callback) {
        this._cancelCallback = callback;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NotificationHeader2.prototype, "message", {
      set: function(value) {
        this._notificationBody.setHtml(value, true);
      },
      enumerable: false,
      configurable: true
    });
    NotificationHeader2.prototype.close = function() {
      this._close();
      this.dispatchEvent("closed");
    };
    return NotificationHeader2;
  }(DomElement_default);

  // build/ts/main/src/collapse/Collapse.js
  var CLASS_OPEN5 = "is-open";
  var ANIMATION_OPEN = 300;
  var Collapse = function(_super) {
    __extends(Collapse2, _super);
    function Collapse2(element) {
      var _this = _super.call(this, element) || this;
      _this._clickHandler = _this._handleClick.bind(_this);
      _this._initialize();
      return _this;
    }
    Collapse2.prototype._initialize = function() {
      var dataTarget = this.element.getAttribute("data-target");
      if (dataTarget === null || dataTarget === "") {
        console.error("A collapsible element requires a 'data-target' that specifies the element to collapse");
        console.info(this.element);
        return;
      }
      var hiddenTarget = this.element.getAttribute("data-hidden");
      if (hiddenTarget !== null && hiddenTarget !== "") {
        this._hiddenIndicator = document.querySelector(hiddenTarget);
      }
      this._collapsibleElements = document.querySelectorAll(dataTarget);
      this.element.addEventListener("click", this._clickHandler);
    };
    Collapse2.prototype._handleClick = function(event) {
      preventDefault(event);
      this.toggle();
    };
    Collapse2.prototype.toggle = function() {
      var e_1, _a, e_2, _b;
      if (this._hiddenIndicator && isHidden(this._hiddenIndicator, false) === true) {
        return;
      }
      if (hasClass(this.element, CLASS_OPEN5) === false) {
        addClass(this.element, CLASS_OPEN5);
        try {
          for (var _c = __values(this._collapsibleElements), _d = _c.next(); !_d.done; _d = _c.next()) {
            var s = _d.value;
            this._openCollapse(s);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return))
              _a.call(_c);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
      } else {
        removeClass(this.element, CLASS_OPEN5);
        try {
          for (var _e = __values(this._collapsibleElements), _f = _e.next(); !_f.done; _f = _e.next()) {
            var s = _f.value;
            this._closeCollapse(s);
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return))
              _b.call(_e);
          } finally {
            if (e_2)
              throw e_2.error;
          }
        }
      }
    };
    Collapse2.prototype._openCollapse = function(el) {
      animation.set(el, { display: "block" });
      animation.start(el, { height: "".concat(el.scrollHeight, "px") }, ANIMATION_OPEN, {
        finished: function() {
          var domEl = new DomElement_default(el);
          domEl.addClass(CLASS_OPEN5);
          domEl.setAttribute("style", "");
        }
      });
      el.setAttribute("aria-expanded", "true");
    };
    Collapse2.prototype._closeCollapse = function(el) {
      animation.start(el, { height: "0" }, ANIMATION_OPEN, {
        finished: function() {
          var domEl = new DomElement_default(el);
          domEl.removeClass(CLASS_OPEN5);
          domEl.setAttribute("style", "");
        }
      });
      el.setAttribute("aria-expanded", "false");
    };
    Collapse2.prototype.destroy = function() {
      ;
      this._collapsibleElements = null;
      if (this._clickHandler) {
        this.element.removeEventListener("click", this._clickHandler);
      }
      ;
      this.element = null;
    };
    return Collapse2;
  }(DomElement_default);
  function init10() {
    var e_3, _a;
    var elements = document.querySelectorAll("[data-toggle='collapse']");
    try {
      for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
        var e = elements_1_1.value;
        if (e.getAttribute("data-init") === "auto") {
          new Collapse(e);
        }
      }
    } catch (e_3_1) {
      e_3 = { error: e_3_1 };
    } finally {
      try {
        if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return))
          _a.call(elements_1);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
  }
  var Collapse_default = Collapse;

  // build/ts/main/src/accordion/Accordion.js
  var QUERY_TOGGLE = ".accordion__toggle";
  var QUERY_OPEN_SECTION = ".accordion__item.is-open";
  var QUERY_COLLAPSE = ".accordion__collapse";
  var CLASS_ITEM2 = "accordion__item";
  var CLASS_OPEN6 = "is-open";
  var CLASS_KEEP_OPEN = "accordion__keep-open";
  var REGEX_HIDDEN = /accordion--hidden-.*/;
  var ANIMATION_OPEN2 = 300;
  var Accordion = function(_super) {
    __extends(Accordion2, _super);
    function Accordion2(element) {
      var _this = _super.call(this, element) || this;
      _this._sectionClickHandler = _this._handleSectionClick.bind(_this);
      _this._initialize();
      return _this;
    }
    Accordion2.prototype._initialize = function() {
      var e_1, _a;
      if (this.element.className.split(" ").some(function(c) {
        return REGEX_HIDDEN.test(c);
      })) {
        var indicator = new DomElement_default("input").setAttribute("type", "hidden").addClass("js-hidden");
        this.appendChild(indicator);
        this._hiddenIndicator = indicator.element;
      }
      try {
        for (var _b = __values(this.element.querySelectorAll(QUERY_TOGGLE)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var toggle = _c.value;
          toggle.addEventListener("click", this._sectionClickHandler);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    };
    Accordion2.prototype._handleSectionClick = function(event) {
      if (this._hiddenIndicator) {
        var style = window.getComputedStyle(this._hiddenIndicator);
        if (style.visibility !== "visible") {
          return;
        }
      }
      var navSection = event.target.parentElement;
      while (!hasClass(navSection, CLASS_ITEM2) && navSection.parentElement) {
        navSection = navSection.parentElement;
      }
      var prevSection = this.element.querySelector(QUERY_OPEN_SECTION);
      if (prevSection && prevSection !== navSection) {
        if (!hasClass(this.element, CLASS_KEEP_OPEN)) {
          this._toggleSection(prevSection);
        }
      }
      this._toggleSection(navSection);
    };
    Accordion2.prototype._toggleSection = function(accSection) {
      var collapseElement = accSection.querySelector(QUERY_COLLAPSE);
      if (hasClass(accSection, CLASS_OPEN6)) {
        removeClass(accSection, CLASS_OPEN6);
        this._closeCollapseSection(collapseElement);
      } else {
        addClass(accSection, CLASS_OPEN6);
        if (collapseElement) {
          this._openCollapseSection(collapseElement);
        }
      }
    };
    Accordion2.prototype._openCollapseSection = function(el) {
      el.style.display = "block";
      animation.start(el, {
        height: "".concat(el.scrollHeight, "px"),
        opacity: "1"
      }, ANIMATION_OPEN2, {
        finished: function() {
          el.setAttribute("aria-expanded", "true");
          el.classList.add(CLASS_OPEN6);
          el.style.height = "auto";
          animation.set(el, { height: "auto" });
        }
      });
    };
    Accordion2.prototype._closeCollapseSection = function(el) {
      animation.set(el, { height: "".concat(el.scrollHeight, "px") });
      animation.start(el, {
        height: "0",
        opacity: "0"
      }, ANIMATION_OPEN2, {
        finished: function() {
          el.setAttribute("aria-expanded", "false");
          el.style.removeProperty("display");
          el.style.removeProperty("height");
          el.style.removeProperty("opacity");
          el.classList.remove(CLASS_OPEN6);
        }
      });
    };
    Accordion2.prototype.destroy = function() {
      var e_2, _a;
      try {
        for (var _b = __values(this.element.querySelectorAll(QUERY_TOGGLE)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var toggle = _c.value;
          toggle.removeEventListener("click", this._sectionClickHandler);
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      ;
      this._sectionClickHandler = null;
      this.element = null;
    };
    return Accordion2;
  }(DomElement_default);
  function init11() {
    searchAndInitialize(".accordion", function(e) {
      new Accordion(e);
    });
  }
  var Accordion_default = Accordion;

  // build/ts/main/src/menu/MenuFlyout.js
  var CLASS_OPEN7 = "is-open";
  var CLASS_MENU = "js-flyout";
  var ANIMATION_OPEN3 = 300;
  var MenuFlyout = function(_super) {
    __extends(MenuFlyout2, _super);
    function MenuFlyout2(element) {
      var _this = _super.call(this, element) || this;
      _this._animationDuration = ANIMATION_OPEN3;
      _this._clickHandler = _this._handleClick.bind(_this);
      _this._windowClickHandler = _this._handleWindowClick.bind(_this);
      _this._initialize();
      return _this;
    }
    MenuFlyout2.prototype._initialize = function() {
      var dataTarget = this.element.getAttribute("data-target");
      if (dataTarget === null || dataTarget === "") {
        console.error("A flyout menu element requires a 'data-target' that specifies the element to collapse");
        console.info(this.element);
        return;
      }
      var hiddenTarget = this.element.getAttribute("data-hidden");
      if (hiddenTarget !== null && hiddenTarget !== "") {
        this._hiddenIndicator = document.querySelector(hiddenTarget) || void 0;
      }
      this._initFlyoutElement(dataTarget);
      this.element.addEventListener("click", this._clickHandler);
    };
    MenuFlyout2.prototype._initFlyoutElement = function(dataTarget) {
      this._flyoutElement = document.querySelector(dataTarget);
      this._flyoutElement.style.opacity = "0";
      this._flyoutElement.style.transform = "translateY(-20px)";
    };
    MenuFlyout2.prototype._handleClick = function() {
      this.toggle();
    };
    MenuFlyout2.prototype._handleWindowClick = function(event) {
      var target = event.target;
      if (parentWithClass(target, CLASS_MENU) === this._flyoutElement) {
        return false;
      }
      while (target !== this.element && target.parentElement) {
        target = target.parentElement;
      }
      if (target !== this.element) {
        this.close();
        return false;
      }
      return true;
    };
    MenuFlyout2.prototype._openMenu = function(el) {
      animation.set(el, { display: "block" });
      animation.start(el, {
        opacity: "1",
        transform: "translateY(0)"
      }, this._animationDuration, {
        finished: function() {
          addClass(el, CLASS_OPEN7);
        }
      });
      el.setAttribute("aria-expanded", "true");
      this.dispatchEvent("opened");
    };
    MenuFlyout2.prototype._closeMenu = function(el) {
      animation.start(el, {
        opacity: "0",
        transform: "translateY(-20px)"
      }, this._animationDuration, {
        finished: function() {
          animation.set(el, { display: "none" });
          removeClass(el, CLASS_OPEN7);
        }
      });
      el.setAttribute("aria-expanded", "false");
      this.dispatchEvent("closed");
    };
    Object.defineProperty(MenuFlyout2.prototype, "animationDuration", {
      set: function(durationInSeconds) {
        this._animationDuration = durationInSeconds;
      },
      enumerable: false,
      configurable: true
    });
    MenuFlyout2.prototype.open = function() {
      var _this = this;
      if (this._hiddenIndicator && isHidden(this._hiddenIndicator, false) === true) {
        return;
      }
      if (hasClass(this.element, CLASS_OPEN7) === true) {
        return;
      }
      addClass(this.element, CLASS_OPEN7);
      this._openMenu(this._flyoutElement);
      setTimeout(function() {
        window.addEventListener("click", _this._windowClickHandler);
        window.addEventListener("touchend", _this._windowClickHandler);
      }, 50);
    };
    MenuFlyout2.prototype.close = function() {
      if (this._hiddenIndicator && isHidden(this._hiddenIndicator, false) === true) {
        return;
      }
      if (hasClass(this.element, CLASS_OPEN7) === false) {
        return;
      }
      removeClass(this.element, CLASS_OPEN7);
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
      this._closeMenu(this._flyoutElement);
    };
    MenuFlyout2.prototype.toggle = function() {
      if (hasClass(this.element, CLASS_OPEN7) === false) {
        this.open();
      } else {
        this.close();
      }
    };
    MenuFlyout2.prototype.destroy = function() {
      ;
      this._flyoutElement = null;
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
      if (this._clickHandler) {
        this.element.removeEventListener("click", this._clickHandler);
      }
      ;
      this._clickHandler = null;
      this._windowClickHandler = null;
      this.element = null;
    };
    return MenuFlyout2;
  }(DomElement_default);
  function init12() {
    var e_1, _a;
    var elements = document.querySelectorAll("[data-toggle='flyout']");
    try {
      for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
        var e = elements_1_1.value;
        if (e.getAttribute("data-init") === "auto") {
          new MenuFlyout(e);
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return))
          _a.call(elements_1);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  }
  var MenuFlyout_default = MenuFlyout;

  // build/ts/main/src/search/SearchInput.js
  var QUERY_SEARCH_INPUT = "input.search__field";
  var QUERY_BTN_CLOSE = ".search__icon-close";
  var QUERY_LIVE_SUGESTIONS = ".js-suggestions";
  var QUERY_LIVE_FOOTER = ".js-footer";
  var CLASS_ACTIVE2 = "is-active";
  var CLASS_OPEN8 = "is-open";
  var CLASS_SEARCH = "search";
  var ANIMATION_SUGGESTIONS_DURATION = 300;
  var ANIMATION_FOOTER_DURATION = 100;
  var SearchInput = function(_super) {
    __extends(SearchInput2, _super);
    function SearchInput2(element) {
      var _this = _super.call(this, element) || this;
      _this._isOpen = false;
      _this._input = _this.element.querySelector(QUERY_SEARCH_INPUT);
      _this._form = _this.element.querySelector("form");
      _this._btnClose = _this.element.querySelector(QUERY_BTN_CLOSE);
      var liveSearch = getAttributeReference(_this.element, "data-live");
      if (liveSearch) {
        _this._liveSuggestions = liveSearch.querySelector(QUERY_LIVE_SUGESTIONS) || void 0;
        _this._liveFooter = liveSearch.querySelector(QUERY_LIVE_FOOTER) || void 0;
        if (_this._liveSuggestions) {
          _this._liveContainer = _this._liveSuggestions.parentNode || void 0;
        }
      }
      _this._focusHandler = _this._handleInputFocus.bind(_this);
      _this._blurHandler = _this._handleInputBlur.bind(_this);
      _this._closeHandler = _this.close.bind(_this);
      _this._windowClickHandler = _this._handleWindowClick.bind(_this);
      _this._keydownHandler = _this._handleKeydown.bind(_this);
      _this._resizeHandler = _this._handleResize.bind(_this);
      _this._initialize();
      return _this;
    }
    SearchInput2.prototype._initialize = function() {
      this._input.addEventListener("focus", this._focusHandler);
      this._input.addEventListener("blur", this._blurHandler);
      if (internetExplorerOrEdgeVersion() > 0) {
        window.addEventListener("resize", this._resizeHandler);
        window.addEventListener("orientationchange", this._resizeHandler);
      }
      if (this._btnClose) {
        this._btnClose.addEventListener("click", this._closeHandler);
      }
    };
    SearchInput2.prototype._handleInputFocus = function() {
      this.addClass(CLASS_ACTIVE2);
    };
    SearchInput2.prototype._handleInputBlur = function() {
      this.removeClass(CLASS_ACTIVE2);
    };
    SearchInput2.prototype._handleWindowClick = function(event) {
      var target = event.target;
      if (!parentWithClass(target, CLASS_SEARCH)) {
        this.close();
        return false;
      }
      return true;
    };
    SearchInput2.prototype._handleKeydown = function(event) {
      var keycode = event.which || event.keyCode;
      if (keycode === KEY_ESCAPE) {
        this.close();
        preventDefault(event);
      }
    };
    SearchInput2.prototype._handleResize = function() {
      var style = window.getComputedStyle(this.element);
      if (style.display === "none") {
        this._input.blur();
      }
    };
    Object.defineProperty(SearchInput2.prototype, "value", {
      get: function() {
        return this._input.value;
      },
      enumerable: false,
      configurable: true
    });
    SearchInput2.prototype.open = function() {
      var _this = this;
      this.addClass(CLASS_OPEN8);
      this._input.focus();
      setTimeout(function() {
        window.addEventListener("click", _this._windowClickHandler);
        window.addEventListener("touchend", _this._windowClickHandler);
        window.addEventListener("keydown", _this._keydownHandler);
      }, 50);
    };
    SearchInput2.prototype.close = function() {
      this._form.reset();
      this.removeClass(CLASS_OPEN8);
      this.closeLiveSearch();
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
      window.removeEventListener("keydown", this._keydownHandler);
    };
    SearchInput2.prototype.openLiveSearch = function() {
      var _this = this;
      if (!this._liveSuggestions || this._isOpen) {
        return;
      }
      this._isOpen = true;
      addClass(this._liveContainer, CLASS_OPEN8);
      animation.set(this._liveSuggestions, { display: "block" });
      animation.start(this._liveSuggestions, { height: "".concat(this._liveSuggestions.scrollHeight, "px") }, ANIMATION_SUGGESTIONS_DURATION, { finished: function() {
        var _a;
        return (_a = _this._liveSuggestions) === null || _a === void 0 ? void 0 : _a.classList.add(CLASS_OPEN8);
      } });
      if (this._liveFooter) {
        animation.set(this._liveFooter, { display: "block" });
        animation.start(this._liveFooter, { height: "".concat(this._liveFooter.scrollHeight, "px") }, ANIMATION_FOOTER_DURATION, {
          delay: ANIMATION_SUGGESTIONS_DURATION,
          finished: function() {
            var _a;
            return (_a = _this._liveFooter) === null || _a === void 0 ? void 0 : _a.classList.add(CLASS_OPEN8);
          }
        });
      }
    };
    SearchInput2.prototype.closeLiveSearch = function() {
      var _this = this;
      if (!this._liveSuggestions || !this.isOpen) {
        return;
      }
      this._isOpen = false;
      if (this._liveFooter) {
        animation.set(this._liveFooter, { display: "block" });
        animation.start(this._liveFooter, { height: "0" }, ANIMATION_FOOTER_DURATION, { finished: function() {
          var _a;
          return (_a = _this._liveFooter) === null || _a === void 0 ? void 0 : _a.classList.remove(CLASS_OPEN8);
        } });
      }
      animation.set(this._liveSuggestions, { display: "block" });
      animation.start(this._liveSuggestions, { height: "0" }, ANIMATION_SUGGESTIONS_DURATION, { finished: function() {
        var _a;
        return (_a = _this._liveSuggestions) === null || _a === void 0 ? void 0 : _a.classList.remove(CLASS_OPEN8);
      } });
    };
    SearchInput2.prototype.destroy = function() {
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
      window.removeEventListener("keydown", this._keydownHandler);
      this._input.removeEventListener("focus", this._focusHandler);
      this._input.removeEventListener("blur", this._blurHandler);
      window.removeEventListener("resize", this._resizeHandler);
      window.removeEventListener("orientationchange", this._resizeHandler);
      if (this._btnClose) {
        this._btnClose.removeEventListener("click", this._closeHandler);
      }
      ;
      this._input = null;
      this._form = null;
      this._btnClose = null;
      this._focusHandler = null;
      this._blurHandler = null;
      this._closeHandler = null;
      this._windowClickHandler = null;
      this._keydownHandler = null;
      this._liveSuggestions = null;
      this._liveFooter = null;
    };
    SearchInput2.prototype.isOpen = function() {
      return this.hasClass(CLASS_OPEN8);
    };
    return SearchInput2;
  }(DomElement_default);
  function init13() {
    searchAndInitialize(".search.search__input", function(e) {
      new SearchInput(e);
    });
  }
  var SearchInput_default = SearchInput;

  // build/ts/main/src/navigation/Navigation.js
  var CLASS_OPEN9 = "is-open";
  var CLASS_ACTIVE3 = "is-active";
  var QUERY_NAV_HAMBURGER = ".nav-hamburger";
  var QUERY_NAV_HB_BODY = ".nav__primary";
  var CLASS_NAV_LINK = "nav-link--header";
  var QUERY_NAV_LINK_ACTIVE = ".nav-link--header.is-active";
  var QUERY_NAV_MOBILE = ".nav__level1 .nav__mainnav .nav__primary";
  var QUERY_NAV_LEVEL0 = ".nav__level0";
  var QUERY_NAV_LEVEL0_CONTAINER = ".nav__level0 .nav__subnav";
  var QUERY_SECTION_OPEN = ".nav-section.is-open";
  var QUERY_NAV_LEVEL1 = ".nav__level1 .nav__mainnav";
  var QUERY_NAV_LEVEL0_LINK = ".nav-link.nav-link--header";
  var QUERY_NAV_LEVEL1_LINK = ".nav-link--header";
  var QUERY_NAV_COLUMN = ".nav-col";
  var QUERY_NAV_COLUMN_ACTIVE = ".nav-col.is-active";
  var QUERY_NAV_BODY = ".nav-body";
  var QUERY_NAV_FOOTER = ".nav-footer";
  var QUERY_SEARCH_ICON = ".nav-search";
  var QUERY_SEARCH_FIELD = ".search__input";
  var CLASS_SEARCH_DESKTOP = "search--desktop";
  var ANIMATION_START_DELAY = 200;
  var ANIMATION_OFFSET2 = 50;
  var ANIMATION_BODY_DURATION = 300;
  var ANIMATION_FOOTER_DURATION2 = 100;
  var Navigation = function(_super) {
    __extends(Navigation2, _super);
    function Navigation2(element) {
      var _this = _super.call(this, element) || this;
      _this._navLevel0 = _this.element.querySelector(QUERY_NAV_LEVEL0) || document.createElement("div");
      _this._navLevel0Body = _this.element.querySelector(QUERY_NAV_LEVEL0_CONTAINER) || document.createElement("div");
      _this._navLevel1 = _this.element.querySelector(QUERY_NAV_LEVEL1) || document.createElement("div");
      _this._navMobile = _this.element.querySelector(QUERY_NAV_MOBILE) || document.createElement("div");
      if (!_this._navMobile.parentElement) {
        var dummyParent = document.createElement("div");
        dummyParent.appendChild(_this._navMobile);
      }
      _this._hamburgerElement = _this.element.querySelector(QUERY_NAV_HAMBURGER) || document.createElement("div");
      _this._searchComponents = [];
      _this._level0ClickHandler = _this._handleLevel0Click.bind(_this);
      _this._level1ClickHandler = _this._handleLevel1Click.bind(_this);
      _this._windowClickHandler = _this._handleWindowClick.bind(_this);
      _this._searchClickHandler = _this._handleSearchClick.bind(_this);
      _this._initialize();
      return _this;
    }
    Navigation2.prototype._isMobile = function() {
      return isHidden(this._hamburgerElement, true) === false;
    };
    Navigation2.prototype._handleLevel0Click = function(event) {
      var isDesktop = !this._isMobile();
      if (isDesktop) {
        var navItems = new NavigationItems(this).fromLevel0(event.target);
        if (!navItems.section) {
          return;
        }
        var previousNavLink = this._navLevel0.querySelector(QUERY_NAV_LINK_ACTIVE);
        var previousNavSection = this._navLevel0.querySelector(QUERY_SECTION_OPEN);
        this._toggleContainer(navItems.link, this._navLevel0Body, navItems.section, void 0, previousNavLink, this._navLevel0Body, previousNavSection, void 0, true);
      }
    };
    Navigation2.prototype._handleLevel1Click = function(event) {
      var navItems = new NavigationItems(this).fromLevel1(event.target);
      var prevItems = navItems.previousLevel1();
      this._toggleContainer(navItems.link, navItems.container, navItems.section, navItems.footer, prevItems.link, prevItems.container, prevItems.section, prevItems.footer, false);
      return false;
    };
    Navigation2.prototype._toggleContainer = function(navLink, navContainer, navSection, navFooter, previousNavLink, previousNavContainer, previousNavSection, previousNavFooter, animateContainer) {
      if (animateContainer === void 0) {
        animateContainer = false;
      }
      var isDesktop = !this._isMobile();
      if (previousNavLink && previousNavLink !== navLink && navLink !== this._hamburgerElement) {
        removeClass(previousNavLink, CLASS_ACTIVE3);
      }
      if (hasClass(navLink, CLASS_ACTIVE3)) {
        removeClass(navLink, CLASS_ACTIVE3);
        if (isDesktop) {
          this._onNavigationClosed();
          this._closeSection(navContainer, navSection, navFooter, true, animateContainer);
        } else if (navLink === this._hamburgerElement) {
          this._onNavigationClosed();
          this._closeSection(navContainer, navSection, void 0, false, false);
        } else if (!isDesktop) {
          this._closeSection(navContainer, navSection, navFooter, true, animateContainer);
        }
      } else {
        addClass(navLink, CLASS_ACTIVE3);
        if (isDesktop) {
          addClass(this._navMobile, CLASS_OPEN9);
          this._onNavigationOpened();
          if (previousNavContainer && previousNavSection) {
            previousNavLink === null || previousNavLink === void 0 ? void 0 : previousNavLink.classList.remove(CLASS_OPEN9);
            previousNavContainer.classList.remove(CLASS_OPEN9);
            previousNavSection.classList.remove(CLASS_OPEN9);
            previousNavFooter === null || previousNavFooter === void 0 ? void 0 : previousNavFooter.classList.remove(CLASS_OPEN9);
          }
          this._openSection(navContainer, navSection, navFooter, true, animateContainer);
        } else if (navLink === this._hamburgerElement) {
          this._onNavigationOpened();
          this._openSection(navContainer, navSection, void 0, false, false);
        } else if (!isDesktop) {
          if (previousNavContainer && previousNavSection) {
            previousNavLink === null || previousNavLink === void 0 ? void 0 : previousNavLink.classList.remove(CLASS_OPEN9);
            previousNavContainer.classList.remove(CLASS_OPEN9);
            previousNavSection.classList.remove(CLASS_OPEN9);
            previousNavFooter === null || previousNavFooter === void 0 ? void 0 : previousNavFooter.classList.remove(CLASS_OPEN9);
          }
          this._openSection(navContainer, navSection, navFooter, true, animateContainer);
        }
      }
    };
    Navigation2.prototype._onNavigationOpened = function() {
      addClass(this._navMobile, CLASS_OPEN9);
      addClass(this._navMobile.parentElement, CLASS_OPEN9);
      addClass(this._hamburgerElement, CLASS_ACTIVE3);
      window.addEventListener("click", this._windowClickHandler);
      window.addEventListener("touchend", this._windowClickHandler);
    };
    Navigation2.prototype._onNavigationClosed = function() {
      removeClass(this._navMobile, CLASS_OPEN9);
      removeClass(this._navMobile.parentElement, CLASS_OPEN9);
      removeClass(this._hamburgerElement, CLASS_ACTIVE3);
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
    };
    Navigation2.prototype._handleWindowClick = function(event) {
      var target = event.target;
      while (target !== this.element && target.parentElement) {
        target = target.parentElement;
      }
      if (target !== this.element) {
        this.close();
        return false;
      }
      return true;
    };
    Navigation2.prototype._openSection = function(navContainer, navSection, navFooter, animateColumns, animateContainer) {
      var e_1, _a;
      if (animateColumns === void 0) {
        animateColumns = true;
      }
      if (animateContainer === void 0) {
        animateContainer = false;
      }
      if (!navSection || !navContainer) {
        return;
      }
      var activeItems = navSection.querySelectorAll(QUERY_NAV_COLUMN);
      if (animateContainer === true) {
        var container = navContainer;
        navContainer = navSection;
        navSection = container;
      }
      addClass(navContainer, CLASS_OPEN9);
      animation.set(navSection, { display: "block" });
      animation.start(navSection, {
        height: animateContainer ? "".concat(navContainer.scrollHeight, "px") : "".concat(navSection.scrollHeight, "px")
      }, ANIMATION_BODY_DURATION, {
        finished: function() {
          animation.set(navSection, { height: "", display: "" });
          navSection.classList.add(CLASS_OPEN9);
        }
      });
      if (navFooter) {
        var navItems = navFooter.querySelectorAll(QUERY_NAV_COLUMN);
        try {
          for (var navItems_1 = __values(navItems), navItems_1_1 = navItems_1.next(); !navItems_1_1.done; navItems_1_1 = navItems_1.next()) {
            var item = navItems_1_1.value;
            addClass(item, CLASS_ACTIVE3);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (navItems_1_1 && !navItems_1_1.done && (_a = navItems_1.return))
              _a.call(navItems_1);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
        animation.set(navFooter, { display: "block" });
        animation.start(navFooter, { height: "".concat(navFooter.scrollHeight, "px") }, ANIMATION_FOOTER_DURATION2, {
          delay: ANIMATION_BODY_DURATION,
          finished: function() {
            animation.set(navFooter, { display: "" });
            navFooter.classList.add(CLASS_OPEN9);
          }
        });
      }
      if (animateColumns === true) {
        activeItems.forEach(function(item2, i) {
          return setTimeout(function() {
            return item2.classList.add(CLASS_ACTIVE3);
          }, ANIMATION_START_DELAY + i * ANIMATION_OFFSET2);
        });
      }
    };
    Navigation2.prototype._closeSection = function(navContainer, navSection, navFooter, animateColumns, animateContainer) {
      var e_2, _a, e_3, _b;
      if (animateColumns === void 0) {
        animateColumns = true;
      }
      if (animateContainer === void 0) {
        animateContainer = false;
      }
      if (!navSection || !navContainer) {
        return;
      }
      var activeItems = navSection.querySelectorAll(QUERY_NAV_COLUMN_ACTIVE);
      if (animateContainer === true) {
        var container = navContainer;
        navContainer = navSection;
        navSection = container;
      }
      if (animateColumns === true) {
        try {
          for (var activeItems_1 = __values(activeItems), activeItems_1_1 = activeItems_1.next(); !activeItems_1_1.done; activeItems_1_1 = activeItems_1.next()) {
            var active = activeItems_1_1.value;
            removeClass(active, CLASS_ACTIVE3);
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (activeItems_1_1 && !activeItems_1_1.done && (_a = activeItems_1.return))
              _a.call(activeItems_1);
          } finally {
            if (e_2)
              throw e_2.error;
          }
        }
      }
      animation.set(navSection, {
        height: animateContainer ? "".concat(navContainer.scrollHeight, "px") : "".concat(navSection.scrollHeight, "px")
      });
      animation.start(navSection, { height: "0" }, ANIMATION_BODY_DURATION, {
        finished: function() {
          animation.set(navSection, { height: "" });
          navSection.classList.remove(CLASS_OPEN9);
          navContainer.classList.remove(CLASS_OPEN9);
        }
      });
      if (navFooter) {
        try {
          for (var _c = __values(navFooter.querySelectorAll(QUERY_NAV_COLUMN_ACTIVE)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var active = _d.value;
            removeClass(active, CLASS_ACTIVE3);
          }
        } catch (e_3_1) {
          e_3 = { error: e_3_1 };
        } finally {
          try {
            if (_d && !_d.done && (_b = _c.return))
              _b.call(_c);
          } finally {
            if (e_3)
              throw e_3.error;
          }
        }
        animation.start(navFooter, { height: "0" }, ANIMATION_FOOTER_DURATION2, {
          finished: function() {
            return navFooter.classList.remove(CLASS_OPEN9);
          }
        });
      }
    };
    Navigation2.prototype._handleSearchClick = function() {
      if (this._searchDesktop) {
        this._searchDesktop.open();
      }
    };
    Navigation2.prototype._initialize = function() {
      var e_4, _a, e_5, _b, e_6, _c;
      try {
        for (var _d = __values(this._navLevel0.querySelectorAll(QUERY_NAV_LEVEL0_LINK)), _e = _d.next(); !_e.done; _e = _d.next()) {
          var navLink = _e.value;
          navLink.addEventListener("click", this._level0ClickHandler);
        }
      } catch (e_4_1) {
        e_4 = { error: e_4_1 };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d.return))
            _a.call(_d);
        } finally {
          if (e_4)
            throw e_4.error;
        }
      }
      try {
        for (var _f = __values(this._navLevel1.querySelectorAll(QUERY_NAV_LEVEL1_LINK)), _g = _f.next(); !_g.done; _g = _f.next()) {
          var navLink = _g.value;
          navLink.addEventListener("click", this._level1ClickHandler);
        }
      } catch (e_5_1) {
        e_5 = { error: e_5_1 };
      } finally {
        try {
          if (_g && !_g.done && (_b = _f.return))
            _b.call(_f);
        } finally {
          if (e_5)
            throw e_5.error;
        }
      }
      this._hamburgerElement.addEventListener("click", this._level1ClickHandler);
      var searchIcon = this.element.querySelector(QUERY_SEARCH_ICON);
      if (searchIcon) {
        searchIcon.addEventListener("click", this._searchClickHandler);
      }
      try {
        for (var _h = __values(this.element.querySelectorAll(QUERY_SEARCH_FIELD)), _j = _h.next(); !_j.done; _j = _h.next()) {
          var search = _j.value;
          var searchComponent = new SearchInput_default(search);
          if (hasClass(search, CLASS_SEARCH_DESKTOP) || hasClass(search.parentElement, CLASS_SEARCH_DESKTOP)) {
            this._searchDesktop = searchComponent;
          }
          this._searchComponents.push(searchComponent);
        }
      } catch (e_6_1) {
        e_6 = { error: e_6_1 };
      } finally {
        try {
          if (_j && !_j.done && (_c = _h.return))
            _c.call(_h);
        } finally {
          if (e_6)
            throw e_6.error;
        }
      }
    };
    Navigation2.prototype.close = function() {
      var isMoble = this._isMobile();
      var level1 = this._navLevel1.querySelector(QUERY_NAV_LINK_ACTIVE);
      var level0 = this._navLevel0.querySelector(QUERY_NAV_LINK_ACTIVE);
      if (!level1 && isMoble && hasClass(this._hamburgerElement, CLASS_ACTIVE3)) {
        level1 = this._hamburgerElement;
      }
      var navItems;
      if (level1) {
        navItems = new NavigationItems(this).fromLevel1(level1);
      } else if (level0) {
        navItems = new NavigationItems(this).fromLevel0(level0);
      }
      if (navItems) {
        removeClass(navItems.link, CLASS_ACTIVE3);
        this._onNavigationClosed();
        this._closeSection(navItems.container, navItems.section, navItems.footer, !isMoble, false);
      }
    };
    return Navigation2;
  }(DomElement_default);
  var NavigationItems = function() {
    function NavigationItems2(nav) {
      this._navigation = nav;
    }
    Object.defineProperty(NavigationItems2.prototype, "link", {
      get: function() {
        return this._link;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NavigationItems2.prototype, "container", {
      get: function() {
        return this._container;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NavigationItems2.prototype, "section", {
      get: function() {
        return this._section;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NavigationItems2.prototype, "footer", {
      get: function() {
        return this._footer;
      },
      enumerable: false,
      configurable: true
    });
    NavigationItems2.prototype.fromLevel0 = function(navLink) {
      while (!hasClass(navLink, CLASS_NAV_LINK) && navLink.parentElement) {
        navLink = navLink.parentElement;
      }
      this._link = navLink;
      var toggleId = navLink.getAttribute("data-toggle");
      this._container = this._navigation._navLevel0Body;
      this._section = this._navigation._navLevel0.querySelector("#".concat(toggleId));
      return this;
    };
    NavigationItems2.prototype.fromLevel1 = function(navLink) {
      while (navLink.parentElement) {
        if (navLink === this._navigation._hamburgerElement || hasClass(navLink, CLASS_NAV_LINK)) {
          break;
        }
        navLink = navLink.parentElement;
      }
      this._link = navLink;
      this._container = navLink.parentElement;
      this._section = this._container.querySelector(QUERY_NAV_BODY);
      this._footer = this._container.querySelector(QUERY_NAV_FOOTER);
      if (navLink === this._navigation._hamburgerElement) {
        this._container = this._navigation._navLevel1;
        this._section = this._container.querySelector(QUERY_NAV_HB_BODY);
      }
      return this;
    };
    NavigationItems2.prototype.previousLevel1 = function() {
      var prev = new NavigationItems2(this._navigation);
      prev._link = this._navigation._navLevel1.querySelector(QUERY_NAV_LINK_ACTIVE);
      prev._container = prev._link ? prev._link.parentElement : void 0;
      prev._section = prev._container ? prev._container.querySelector(QUERY_NAV_BODY) : void 0;
      prev._footer = prev._container ? prev._container.querySelector(QUERY_NAV_FOOTER) : void 0;
      return prev;
    };
    NavigationItems2.prototype.isHamburger = function() {
      return this._link === this._navigation._hamburgerElement;
    };
    return NavigationItems2;
  }();
  function init14() {
    searchAndInitialize(".nav", function(e) {
      new Navigation(e);
    });
  }
  var Navigation_default = Navigation;

  // build/ts/main/src/navigation/NavigationSide.js
  var CLASS_OPEN10 = "is-open";
  var CLASS_ACTIVE4 = "is-active";
  var QUERY_SITE_WRAPPER = ".js-site-wrapper";
  var QUERY_NAV_HAMBURGER2 = ".js-site-wrapper .js-hamburger";
  var QUERY_NAV_ITEM = ".js-nav-item";
  var NAV_LINK_INITIAL_SCALE = 0.9;
  var ANIMATION_DURATION_LINKS = 100;
  var ANIMATION_DURATION_NAV = 300;
  var ANIMATION_STAGGER_DELAY = 50;
  var NavigationSide = function(_super) {
    __extends(NavigationSide2, _super);
    function NavigationSide2(element) {
      var _this = _super.call(this, element) || this;
      _this._clickHandler = _this._handleClick.bind(_this);
      _this._windowClickHandler = _this._handleWindowClick.bind(_this);
      _this._siteWrapper = document.querySelector(QUERY_SITE_WRAPPER);
      _this._hamburgerElement = document.querySelector(QUERY_NAV_HAMBURGER2) || document.createElement("div");
      _this._navItems = _this.element.querySelectorAll(QUERY_NAV_ITEM);
      _this._initialize();
      return _this;
    }
    NavigationSide2.prototype._initialize = function() {
      this._hamburgerElement.addEventListener("click", this._clickHandler);
      this._hamburgerElement.addEventListener("touchend", this._clickHandler);
    };
    NavigationSide2.prototype._handleClick = function(event) {
      preventDefault(event);
      this.toggle();
    };
    NavigationSide2.prototype._handleWindowClick = function(event) {
      var target = event.target;
      while (target !== this.element && target.parentElement) {
        target = target.parentElement;
      }
      if (target !== this.element) {
        this.close();
        return false;
      }
      return true;
    };
    NavigationSide2.prototype.toggle = function() {
      if (hasClass(this.element, CLASS_OPEN10) === false) {
        this.open();
      } else {
        this.close();
      }
    };
    NavigationSide2.prototype.open = function() {
      var _this = this;
      setTimeout(function() {
        window.addEventListener("click", _this._windowClickHandler);
        window.addEventListener("touchend", _this._windowClickHandler);
      }, 50);
      addClass(this._hamburgerElement, CLASS_ACTIVE4);
      addClass(this.element, CLASS_OPEN10);
      addClass(this._siteWrapper, CLASS_OPEN10);
      this._navItems.forEach(function(el, i) {
        animation.set(el, {
          opacity: "0",
          transform: "scale(".concat(NAV_LINK_INITIAL_SCALE, ")")
        });
        animation.start(el, { opacity: "1", transform: "scale(1)" }, ANIMATION_DURATION_NAV, { delay: ANIMATION_DURATION_LINKS + i * ANIMATION_STAGGER_DELAY });
      });
    };
    NavigationSide2.prototype.close = function() {
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
      removeClass(this._hamburgerElement, CLASS_ACTIVE4);
      removeClass(this.element, CLASS_OPEN10);
      removeClass(this._siteWrapper, CLASS_OPEN10);
    };
    NavigationSide2.prototype.destroy = function() {
      window.removeEventListener("click", this._windowClickHandler);
      window.removeEventListener("touchend", this._windowClickHandler);
      this._windowClickHandler = null;
      this._clickHandler = null;
      this._siteWrapper = null;
      this._hamburgerElement = null;
      this._navItems = null;
    };
    return NavigationSide2;
  }(DomElement_default);
  function init15() {
    searchAndInitialize(".nav-side", function(e) {
      new NavigationSide(e);
    });
  }
  var NavigationSide_default = NavigationSide;

  // build/ts/main/src/empty-states/EmptyState.js
  var CLASS_BORDER = "empty-state__border";
  var CLASS_BORDER_MODAL = "empty-state__border--modal";
  var CLASS_ACTIVE5 = "is-active";
  var CLASS_HASFILES = "has-files";
  var CLASS_MODAL = "empty-state--modal";
  var CLASS_MODAL_CONTENT = "modal__content";
  var QUERY_MODAL_BODY = ".modal__body";
  var QUERY_FILE = "input[type='file']";
  var EmptyState = function(_super) {
    __extends(EmptyState2, _super);
    function EmptyState2(element) {
      var _this = _super.call(this, element) || this;
      _this._fileInput = _this.element.querySelector(QUERY_FILE);
      _this._button = _this.element.querySelector("label");
      _this._fileChangedHandler = _this._handleFileChanged.bind(_this);
      _this._preventEventsHandler = _this._preventDragEvents.bind(_this);
      _this._dragEnterHandler = _this._handleDragEnter.bind(_this);
      _this._dragLeaveHandler = _this._handleDragLeave.bind(_this);
      _this._dropHandler = _this._handleDrop.bind(_this);
      _this._isDragging = false;
      _this._initialize();
      return _this;
    }
    EmptyState2.prototype._initialize = function() {
      var e_1, _a;
      if (this.hasClass(CLASS_MODAL)) {
        this._dragArea = parentWithClass(this.element, CLASS_MODAL_CONTENT);
        var borderArea = this._dragArea.querySelector(QUERY_MODAL_BODY);
        borderArea.setAttribute("style", "pointer-events: none;");
        this._border = new DomElement_default("div").addClass(CLASS_BORDER).addClass(CLASS_BORDER_MODAL);
        borderArea.appendChild(this._border.element);
      } else {
        this._dragArea = this.element;
        var borderArea = getRootElement();
        this._border = new DomElement_default("div").addClass(CLASS_BORDER);
        if (!borderArea.querySelector(".".concat(CLASS_BORDER))) {
          borderArea.appendChild(this._border.element);
        }
      }
      var form = this.element.querySelector("form");
      try {
        for (var _b = __values([
          "drag",
          "dragstart",
          "dragend",
          "dragover",
          "dragenter",
          "dragleave",
          "drop"
        ]), _c = _b.next(); !_c.done; _c = _b.next()) {
          var event_1 = _c.value;
          this.element.addEventListener(event_1, this._preventEventsHandler);
          form.addEventListener(event_1, this._preventEventsHandler);
          this._dragArea.addEventListener(event_1, this._preventEventsHandler);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      this._dragArea.addEventListener("dragover", this._dragEnterHandler);
      this._dragArea.addEventListener("dragenter", this._dragEnterHandler);
      this._dragArea.addEventListener("dragleave", this._dragLeaveHandler);
      this._dragArea.addEventListener("dragend", this._dragLeaveHandler);
      this._dragArea.addEventListener("drop", this._dragLeaveHandler);
      this._dragArea.addEventListener("drop", this._dropHandler);
      this._fileInput.addEventListener("change", this._fileChangedHandler);
    };
    EmptyState2.prototype._preventDragEvents = function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };
    EmptyState2.prototype._handleDragEnter = function() {
      if (this._isDragging === true) {
        return;
      }
      this._isDragging = true;
      this._button.setAttribute("style", "pointer-events: none;");
      this.addClass(CLASS_ACTIVE5);
      this._border.addClass(CLASS_ACTIVE5);
    };
    EmptyState2.prototype._handleDragLeave = function() {
      if (this._isDragging === false) {
        return;
      }
      this._isDragging = false;
      this._button.setAttribute("style", "");
      this.removeClass(CLASS_ACTIVE5);
      this._border.removeClass(CLASS_ACTIVE5);
    };
    EmptyState2.prototype._handleDrop = function(e) {
      var dragEvent = e;
      this._fileInput.files = dragEvent.dataTransfer.files;
    };
    EmptyState2.prototype._handleFileChanged = function() {
      var files = this._fileInput.files;
      if (files && files.length > 0) {
        this.addClass(CLASS_HASFILES);
      } else {
        this.removeClass(CLASS_HASFILES);
      }
    };
    Object.defineProperty(EmptyState2.prototype, "files", {
      get: function() {
        return this._fileInput.files;
      },
      enumerable: false,
      configurable: true
    });
    return EmptyState2;
  }(DomElement_default);
  function init16() {
    searchAndInitialize(".empty-state", function(e) {
      new EmptyState(e);
    });
  }
  var EmptyState_default = EmptyState;

  // build/ts/main/src/carousel/Carousel.js
  var QUERY_SLIDER = ".carousel__container";
  var QUERY_SLIDE_AREA = ".carousel__slider";
  var QUERY_WRAPPER = ".carousel__slider-wrapper";
  var QUERY_PAGINATION = ".carousel__pagination";
  var CLASS_NOWRAP = "carousel--nowrap";
  var CLASS_ACTIVE6 = "slide--active";
  var CLASS_PREV = "slide--prev";
  var CLASS_NEXT = "slide--next";
  var CLASS_BULLET = "pagination-bullet";
  var CLASS_BULLET_ACTIVE = "pagination-bullet--active";
  var QUERY_BTN_PREV = ".carousel__button-prev";
  var QUERY_BTN_NEXT = ".carousel__button-next";
  var QUERY_BTN_WRAPPER = ".carousel__button-wrapper";
  var ATTRIBUTE_INDEX = "js-index";
  var ANIMATION_DURATION = 350;
  var ANIMATION_EASING = "ease-in-out";
  var TOUCH_DURATION = 300;
  var TOUCH_DELTA_MIN = 25;
  var Carousel = function(_super) {
    __extends(Carousel2, _super);
    function Carousel2(element, index) {
      if (index === void 0) {
        index = 0;
      }
      var _this = _super.call(this, element) || this;
      _this._nowrap = element.classList.contains(CLASS_NOWRAP);
      _this._slider = _this.element.querySelector(QUERY_SLIDER);
      _this._wrapper = _this._slider.querySelector(QUERY_WRAPPER);
      _this._pagination = _this._slider.querySelector(QUERY_PAGINATION);
      _this._slideArea = _this._slider.querySelector(QUERY_SLIDE_AREA);
      _this._btnWrapper = _this.element.querySelector(QUERY_BTN_WRAPPER);
      _this._prevCtrl = _this.element.querySelector(QUERY_BTN_PREV);
      _this._nextCtrl = _this.element.querySelector(QUERY_BTN_NEXT);
      _this._slides = [];
      _this._index = index || 0;
      _this._slidesPerGroup = 1;
      _this._sliderWrapper = new SliderWrapper(_this._wrapper, _this._slideArea, _this.element);
      _this._sliderWrapper.index = _this._index;
      _this._additionalSlideMargin = 0;
      _this._resizeHandler = _this._onresize.bind(_this);
      _this._prevHandler = _this.prev.bind(_this);
      _this._nextHandler = _this.next.bind(_this);
      _this._paginationClickHandler = _this._handlePaginationClick.bind(_this);
      _this._keydownHandler = _this._handleKeydown.bind(_this);
      _this._handleTouchstart = _this._onTouchstart.bind(_this);
      _this._handleTouchmove = _this._onTouchmove.bind(_this);
      _this._handleTouchend = _this._onTouchend.bind(_this);
      _this._initialize();
      _this.slide(_this._index, 0, false);
      _this._updateCtrlOffsets();
      return _this;
    }
    Carousel2.prototype._initialize = function() {
      this._breakpointPhone = new DomElement_default("div").addClass("js-phone").element;
      this._breakpointTablet = new DomElement_default("div").addClass("js-tablet").element;
      this._breakpointDesktop = new DomElement_default("div").addClass("js-desktop").element;
      this.element.appendChild(this._breakpointPhone);
      this.element.appendChild(this._breakpointTablet);
      this.element.appendChild(this._breakpointDesktop);
      if (this._prevCtrl && this._nextCtrl) {
        this._prevCtrl.addEventListener("click", this._prevHandler);
        this._nextCtrl.addEventListener("click", this._nextHandler);
      }
      if (this._pagination) {
        this._pagination.addEventListener("click", this._paginationClickHandler);
      }
      this._slides = Array.from(this._wrapper.children);
      if (this._slides.length === 0) {
        throw Error("Provide at least one slide to the slider");
      }
      for (var i = 0; i < this._slides.length; i++) {
        var slide = this._slides[i];
        slide.setAttribute(ATTRIBUTE_INDEX, String(i));
      }
      this._updateResponsiveOptions();
      this._sliderWrapper.initialize();
      this.reset();
      this.element.addEventListener("keydown", this._keydownHandler);
      this._slideArea.addEventListener("mousedown", this._handleTouchstart);
      this._slideArea.addEventListener("touchstart", this._handleTouchstart);
      window.addEventListener("resize", this._resizeHandler);
      window.addEventListener("orientationchange", this._resizeHandler);
    };
    Carousel2.prototype._isBreakpointActive = function(breakpoint) {
      var style = window.getComputedStyle(breakpoint);
      return style.visibility === "visible";
    };
    Carousel2.prototype._onresize = function() {
      this.reset();
      this._updateCtrlOffsets();
    };
    Carousel2.prototype._adjustIndex = function(index) {
      if (typeof index !== "number") {
        index = 0;
      }
      if (this._nowrap) {
        if (index < 0) {
          index = 0;
        } else if (index >= this._slides.length) {
          index = this._slides.length - 1;
        }
      } else {
        if (index < 0) {
          index = this._wrapround(index, 0, this._slides.length);
        } else if (index >= this._slides.length) {
          index %= this._slides.length;
        }
      }
      return Math.floor(index / this._slidesPerGroup) * this._slidesPerGroup;
    };
    Carousel2.prototype._wrapround = function(n, min, max) {
      if (n >= max) {
        return min;
      }
      if (n < min) {
        return max - 1;
      }
      return n;
    };
    Carousel2.prototype._wraproundCount = function(a, b, min, max, direction) {
      if (direction === 0) {
        return 0;
      }
      if (a < min || a >= max) {
        throw new Error("Argument 'a' is out of range, Value: ".concat(a, " Min: ").concat(min, ", Max: ").concat(max));
      }
      if (b < min || b >= max) {
        throw new Error("Argument 'b' is out of range, Value: ".concat(b, " Min: ").concat(min, ", Max: ").concat(max));
      }
      var i = 0;
      while (a !== b) {
        i += 1;
        a = this._wrapround(a + direction, min, max);
      }
      return i;
    };
    Carousel2.prototype._updateCtrlOffsets = function() {
      if (!this._nextCtrl || !this._prevCtrl || !this._btnWrapper) {
        return;
      }
      var prevCtrlMargin = 0;
      var nextCtrlMargin = 0;
      if (!this._isBreakpointActive(this._breakpointPhone)) {
        var wrapperRect = this._btnWrapper.getBoundingClientRect();
        var prevSlideCount = Math.floor(0.5 * this._slidesPerGroup);
        var rightIndex = this._sliderWrapper.index + prevSlideCount + 1;
        var leftIndex = this._sliderWrapper.index - 1;
        if (this._slidesPerGroup % 2 !== 0) {
          leftIndex -= prevSlideCount;
        }
        if (this._nowrap) {
          leftIndex = Math.max(this._sliderWrapper.index - 1, 0);
          rightIndex = Math.min(this._sliderWrapper.index + 1, this._wrapper.children.length - 1);
        }
        if (leftIndex >= 0 && leftIndex < this._wrapper.children.length && rightIndex >= 0 && rightIndex < this._wrapper.children.length) {
          var leftSlide = this._sliderWrapper.getSlideProperties(leftIndex);
          var rightSlide = this._sliderWrapper.getSlideProperties(rightIndex);
          var btnWidth = this._prevCtrl.offsetWidth;
          if (btnWidth <= 0) {
            btnWidth = 60;
          }
          prevCtrlMargin = leftSlide.right - wrapperRect.left - btnWidth;
          nextCtrlMargin = wrapperRect.right - rightSlide.left - btnWidth;
        }
      }
      if (this._nowrap) {
        if (this._sliderWrapper.index === 0) {
          prevCtrlMargin = nextCtrlMargin;
        }
        if (this._sliderWrapper.index === this._wrapper.children.length - 1) {
          nextCtrlMargin = prevCtrlMargin;
        }
      }
      var left = prevCtrlMargin !== 0 ? "".concat(prevCtrlMargin, "px") : "";
      this._prevCtrl.style.left = left;
      var right = nextCtrlMargin !== 0 ? "".concat(nextCtrlMargin, "px") : "";
      this._nextCtrl.style.right = right;
    };
    Carousel2.prototype._updateActiveSlides = function(nextIndex) {
      var prevSlideCount = Math.floor(0.5 * (this._slidesPerGroup - 1));
      var evenGroup = this._slidesPerGroup % 2 === 0;
      for (var i = 0; i < this._wrapper.children.length; i++) {
        var slide = this._wrapper.children[i];
        if (i === nextIndex || evenGroup && i === nextIndex + 1) {
          addClass(slide, CLASS_ACTIVE6);
        } else {
          removeClass(slide, CLASS_ACTIVE6);
        }
        if (i < nextIndex && i >= nextIndex - prevSlideCount) {
          addClass(slide, CLASS_PREV);
        } else {
          removeClass(slide, CLASS_PREV);
        }
        if (i > nextIndex && (i <= nextIndex + prevSlideCount || evenGroup && i <= nextIndex + 1 + prevSlideCount)) {
          addClass(slide, CLASS_NEXT);
        } else {
          removeClass(slide, CLASS_NEXT);
        }
      }
    };
    Carousel2.prototype._updatePagination = function() {
      if (!this._pagination) {
        return;
      }
      var to = this._index;
      var bullets = this._pagination.children;
      var totalItems = Math.max(this._slides.length, bullets.length);
      var slideCount = Math.ceil(this._slides.length / this._slidesPerGroup);
      var activeSlideIndex = Math.floor(to / this._slidesPerGroup);
      for (var i = 0; i < totalItems; i++) {
        var bullet = void 0;
        if (bullets.length > i) {
          if (bullets.length <= slideCount) {
            bullet = bullets[i];
          } else {
            remove(bullets[i]);
          }
        } else if (i < slideCount) {
          bullet = new DomElement_default("div").addClass(CLASS_BULLET).element;
          this._pagination.appendChild(bullet);
        }
        if (bullet && i < slideCount) {
          if (i === activeSlideIndex) {
            addClass(bullet, CLASS_BULLET_ACTIVE);
          } else {
            removeClass(bullet, CLASS_BULLET_ACTIVE);
          }
        }
      }
    };
    Carousel2.prototype._updateCtrlState = function(index) {
      if (this._nowrap && this._prevCtrl && this._nextCtrl) {
        this._prevCtrl.disabled = index <= 0;
        this._nextCtrl.disabled = index >= this._slides.length - 1;
      }
    };
    Carousel2.prototype._handlePaginationClick = function(e) {
      if (!hasClass(e.target, CLASS_BULLET)) {
        return;
      }
      var index = Array.from(this._pagination.children).indexOf(e.target);
      var slideNumber = index * this._slidesPerGroup;
      this.slideTo(slideNumber);
    };
    Carousel2.prototype._handleKeydown = function(event) {
      var keycode = event.which || event.keyCode;
      switch (keycode) {
        case KEY_ARROW_LEFT:
          this.prev();
          break;
        case KEY_ARROW_RIGHT:
          this.next();
          break;
        case KEY_ESCAPE:
          this.element.blur();
          break;
      }
    };
    Carousel2.prototype._onTouchstart = function(event) {
      var touch = event.touches ? event.touches[0] : event;
      this._slideArea.removeEventListener("mousedown", this._handleTouchstart);
      this._slideArea.removeEventListener("touchstart", this._handleTouchstart);
      this._sliderWrapper.beginDrag();
      var pageX = touch.pageX;
      this._touchOffset = {
        x: pageX,
        time: Date.now()
      };
      this._delta = {
        x: 0,
        lastMove: pageX
      };
      document.addEventListener("mousemove", this._handleTouchmove);
      document.addEventListener("touchmove", this._handleTouchmove);
      document.addEventListener("mouseup", this._handleTouchend);
      document.addEventListener("mouseleave", this._handleTouchend);
      document.addEventListener("touchend", this._handleTouchend);
    };
    Carousel2.prototype._onTouchmove = function(event) {
      var touch = event.touches ? event.touches[0] : event;
      var pageX = touch.pageX;
      var deltaMove = pageX - this._delta.lastMove;
      this._delta = {
        x: pageX - this._touchOffset.x,
        lastMove: pageX
      };
      if (this._touchOffset) {
        preventDefault(event);
        this._sliderWrapper.move(deltaMove);
        this._cloneSlidesToFitWrapper(false, deltaMove);
      }
    };
    Carousel2.prototype._onTouchend = function() {
      var duration2 = this._touchOffset ? Date.now() - this._touchOffset.time : void 0;
      var isValid = Number(duration2) < TOUCH_DURATION && Math.abs(this._delta.x) > TOUCH_DELTA_MIN || Math.abs(this._delta.x) > this._frameWidth / 3;
      if (isValid) {
        var direction = clamp(this._delta.x, -1, 1) * -1;
        this.slide(false, direction, true);
        this._sliderWrapper.endDrag();
      } else {
        this._sliderWrapper.cancelDrag();
      }
      this._touchOffset = void 0;
      this._slideArea.addEventListener("mousedown", this._handleTouchstart);
      this._slideArea.addEventListener("touchstart", this._handleTouchstart);
      document.removeEventListener("mousemove", this._handleTouchmove);
      document.removeEventListener("mouseup", this._handleTouchend);
      document.removeEventListener("mouseleave", this._handleTouchend);
      document.removeEventListener("touchmove", this._handleTouchmove);
      document.removeEventListener("touchend", this._handleTouchend);
    };
    Carousel2.prototype._updateResponsiveOptions = function() {
      if (this._nowrap) {
        return;
      }
      if (this._isBreakpointActive(this._breakpointPhone)) {
        this._slidesPerGroup = 1;
      }
      if (this._isBreakpointActive(this._breakpointTablet)) {
        this._slidesPerGroup = 2;
      }
      if (this._isBreakpointActive(this._breakpointDesktop)) {
        this._slidesPerGroup = 3;
      }
      this._sliderWrapper.slidesPerGroup = this._slidesPerGroup;
    };
    Carousel2.prototype._cloneSlide = function(index, direction) {
      var clone = this._slides[index].cloneNode(true);
      removeClass(clone, CLASS_ACTIVE6);
      removeClass(clone, CLASS_PREV);
      removeClass(clone, CLASS_NEXT);
      this._sliderWrapper.addSlide(clone, direction);
      var slideMargin = this._additionalSlideMargin > 0 ? "".concat(this._additionalSlideMargin, "px") : "";
      clone.style.marginLeft = slideMargin;
      clone.style.marginRight = slideMargin;
      return clone.offsetWidth;
    };
    Carousel2.prototype._cloneSlidesByCount = function(slideCount, direction) {
      var originalIndex = direction < 0 ? 0 : this._wrapper.children.length - 1;
      var index = parseInt(this._wrapper.children[originalIndex].getAttribute(ATTRIBUTE_INDEX), 10);
      while (slideCount > 0) {
        index = this._wrapround(index + direction, 0, this._slides.length);
        this._cloneSlide(index, direction);
        slideCount -= 1;
      }
    };
    Carousel2.prototype._cloneSlidesByScrollCount = function(nextIndex, direction) {
      if (this._nowrap) {
        return;
      }
      var scrollCount = this._wraproundCount(this._index, nextIndex, 0, this._slides.length, direction);
      var outerSlideProps = this._sliderWrapper.getSlideProperties(direction > 0 ? this._wrapper.children.length - 1 : 0);
      var indexToOuterSlideCount = this._wraproundCount(this._index, outerSlideProps.index, 0, this._slides.length, direction);
      var slidesToInsert = scrollCount - indexToOuterSlideCount;
      if (slidesToInsert > 0) {
        this._cloneSlidesByCount(slidesToInsert, direction);
      }
    };
    Carousel2.prototype._cloneSlidesByToFill = function(spaceToFill, direction) {
      var originalIndex = direction < 0 ? 0 : this._wrapper.children.length - 1;
      var index = parseInt(this._wrapper.children[originalIndex].getAttribute(ATTRIBUTE_INDEX), 10);
      while (spaceToFill > 0) {
        index = this._wrapround(index + direction, 0, this._slides.length);
        spaceToFill -= this._cloneSlide(index, direction);
      }
    };
    Carousel2.prototype._cloneSlidesToFitWrapper = function(cleanup, slideDelta) {
      if (cleanup === void 0) {
        cleanup = true;
      }
      if (slideDelta === void 0) {
        slideDelta = 0;
      }
      if (this._nowrap) {
        return 0;
      }
      var realIndex = this._sliderWrapper.index;
      var first;
      var last;
      if (cleanup === false) {
        first = this._sliderWrapper.getSlideProperties(0);
        last = this._sliderWrapper.getSlideProperties(this._wrapper.children.length - 1);
      } else {
        var result = this._sliderWrapper.getRemovableSlides(slideDelta);
        first = result.first;
        last = result.last;
        for (var i = result.slides.length - 1; i >= 0; i--) {
          if (result.slides[i] === true) {
            this._sliderWrapper.removeSlide(i);
          }
        }
      }
      var spaceToFill = this._sliderWrapper.getEmptySpace(first.left, last.right);
      if (first.visible === true && spaceToFill.left > 0) {
        this._cloneSlidesByToFill(spaceToFill.left, -1);
      }
      if (last.visible === true && spaceToFill.right > 0) {
        this._cloneSlidesByToFill(spaceToFill.right, 1);
      }
      return realIndex - this._sliderWrapper.index;
    };
    Carousel2.prototype._getRealIndexFor = function(index, direction) {
      var i = this._sliderWrapper.index;
      while (i >= 0 && i < this._wrapper.children.length) {
        var slideIndex = parseInt(this._wrapper.children[i].getAttribute(ATTRIBUTE_INDEX), 10);
        if (slideIndex === index) {
          return i;
        }
        i += direction;
      }
      throw new Error("Could not find real index for slide ".concat(index, " in direction ").concat(direction));
    };
    Object.defineProperty(Carousel2.prototype, "index", {
      get: function() {
        return this._index;
      },
      enumerable: false,
      configurable: true
    });
    Carousel2.prototype.reset = function() {
      this._frameWidth = this._slider.getBoundingClientRect().width || this._slider.offsetWidth;
      this._updateResponsiveOptions();
      if (this._nextCtrl) {
        this._nextCtrl.disabled = false;
      }
      if (this._prevCtrl) {
        this._prevCtrl.disabled = false;
      }
      if (this._isBreakpointActive(this._breakpointPhone)) {
        var style = window.getComputedStyle(this._slider.parentElement);
        var parentWidth = this._slider.parentElement.clientWidth + (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);
        var outerMargin = Math.ceil(parentWidth - this._frameWidth);
        this._additionalSlideMargin = Math.ceil(outerMargin * 0.5) + 1;
      } else {
        this._additionalSlideMargin = 0;
      }
      var slideMargin = this._additionalSlideMargin > 0 ? "".concat(this._additionalSlideMargin, "px") : "";
      for (var i = 0; i < this._wrapper.children.length; i++) {
        var slide = this._wrapper.children[i];
        slide.style.marginLeft = slideMargin;
        slide.style.marginRight = slideMargin;
      }
      this._sliderWrapper.onresize();
      this._cloneSlidesToFitWrapper(false);
      this._sliderWrapper.moveTo(this._sliderWrapper.index);
      this._updatePagination();
      this._updateCtrlState(this._sliderWrapper.index);
      this._updateActiveSlides(this._sliderWrapper.index);
    };
    Carousel2.prototype.prev = function() {
      this.slide(false, -1);
    };
    Carousel2.prototype.next = function() {
      this.slide(false, 1);
    };
    Carousel2.prototype.slide = function(nextIndex, direction, animate) {
      if (animate === void 0) {
        animate = true;
      }
      if (typeof nextIndex !== "number") {
        if (direction > 0) {
          nextIndex = this._index + this._slidesPerGroup;
          direction = 1;
        } else {
          nextIndex = this._index - this._slidesPerGroup;
          direction = -1;
        }
      }
      nextIndex = this._adjustIndex(nextIndex);
      if (!direction) {
        direction = clamp(nextIndex - this._index, -1, 1);
      }
      this._cloneSlidesToFitWrapper(false);
      this._cloneSlidesByScrollCount(nextIndex, direction);
      var realIndex = this._getRealIndexFor(nextIndex, direction);
      var slideDelta = this._sliderWrapper.getSlideDelta(realIndex);
      realIndex = Math.max(realIndex - this._cloneSlidesToFitWrapper(true, slideDelta), 0);
      this._sliderWrapper.moveTo(realIndex, void 0, animate);
      this._index = nextIndex;
      this._updatePagination();
      this._updateCtrlState(realIndex);
      this._updateActiveSlides(realIndex);
    };
    Carousel2.prototype.slideTo = function(index, animate) {
      if (animate === void 0) {
        animate = true;
      }
      this.slide(index, void 0, animate);
    };
    Carousel2.prototype.destroy = function() {
      window.removeEventListener("resize", this._resizeHandler);
      window.removeEventListener("orientationchange", this._resizeHandler);
      this.element.removeEventListener("keydown", this._keydownHandler);
      this._slideArea.removeEventListener("mousedown", this._handleTouchstart);
      this._slideArea.removeEventListener("touchstart", this._handleTouchstart);
      this._breakpointPhone.remove();
      this._breakpointTablet.remove();
      this._breakpointDesktop.remove();
      if (this._prevCtrl && this._nextCtrl) {
        this._prevCtrl.removeEventListener("click", this._prevHandler);
        this._nextCtrl.removeEventListener("click", this._nextHandler);
      }
      ;
      this._prevCtrl = void 0;
      this._nextCtrl = void 0;
      if (this._pagination) {
        this._pagination.removeEventListener("click", this._paginationClickHandler);
        this._pagination = void 0;
      }
      this._sliderWrapper.destroy();
      this._sliderWrapper = void 0;
    };
    return Carousel2;
  }(DomElement_default);
  var TRANSFORM = "transform";
  var DURATION = "transitionDuration";
  var TIMING = "transitionTimingFunction";
  var SliderWrapper = function() {
    function SliderWrapper2(wrapperElement, slideAreaElement, carouselElement) {
      this._wrapperElement = wrapperElement;
      this._slideAreaElement = slideAreaElement;
      this._carouselElement = carouselElement;
      this._position = 0;
      this._index = 0;
      this._isdragging = false;
    }
    SliderWrapper2.prototype._getSlide = function(index) {
      if (index < 0 || index >= this._wrapperElement.children.length) {
        throw new Error("Argument 'index' is out of range, Value: ".concat(index, " Min: 0, Max: ").concat(this._wrapperElement.children.length - 1));
      }
      return this._wrapperElement.children[index];
    };
    SliderWrapper2.prototype._setTransform = function(targetPosition, animated, duration2, ease) {
      if (animated === void 0) {
        animated = false;
      }
      if (duration2 === void 0) {
        duration2 = ANIMATION_DURATION;
      }
      if (ease === void 0) {
        ease = ANIMATION_EASING;
      }
      if (animated === false) {
        duration2 = 0;
      }
      var style = this._wrapperElement.style;
      if (style) {
        style[DURATION] = "".concat(duration2, "ms");
        style[TIMING] = ease;
        targetPosition = Math.floor(targetPosition);
        style[TRANSFORM] = "translate(".concat(targetPosition, "px, 0)");
        this._position = targetPosition;
      }
    };
    SliderWrapper2.prototype._getWrapperSlidePosition = function(index) {
      var wrapperCenter = 0.5 * this._wrapperElement.offsetWidth;
      var slide = this._getSlide(index);
      var result = 0;
      if (this._slidesPerGroup % 2 === 0) {
        var slideStyle = window.getComputedStyle(slide);
        var slideMargin = slideStyle ? parseInt(slideStyle.marginRight, 10) : 0;
        result = -slide.offsetLeft - slide.clientWidth + wrapperCenter - slideMargin;
      } else {
        result = -slide.offsetLeft - 0.5 * slide.clientWidth + wrapperCenter;
      }
      return result;
    };
    Object.defineProperty(SliderWrapper2.prototype, "position", {
      get: function() {
        return this._position;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(SliderWrapper2.prototype, "index", {
      get: function() {
        return this._index;
      },
      set: function(index) {
        this._index = index;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(SliderWrapper2.prototype, "slidesPerGroup", {
      set: function(value) {
        this._slidesPerGroup = value;
      },
      enumerable: false,
      configurable: true
    });
    SliderWrapper2.prototype.initialize = function() {
      this.onresize();
    };
    SliderWrapper2.prototype.onresize = function() {
      this._areaOffset = this._slideAreaElement.getBoundingClientRect().left;
      var containerRect = this._carouselElement.getBoundingClientRect();
      this._containerMin = containerRect.left;
      this._containerMax = containerRect.right;
    };
    SliderWrapper2.prototype.beginDrag = function() {
      this._isdragging = true;
      this._dragStartPosition = this._position;
    };
    SliderWrapper2.prototype.cancelDrag = function() {
      this._isdragging = false;
      this._setTransform(this._dragStartPosition, true, ANIMATION_DURATION, ANIMATION_EASING);
      this._dragStartPosition = void 0;
    };
    SliderWrapper2.prototype.endDrag = function() {
      this._isdragging = false;
      this._dragStartPosition = void 0;
    };
    SliderWrapper2.prototype.move = function(delta, animated, duration2, ease) {
      if (animated === void 0) {
        animated = false;
      }
      if (duration2 === void 0) {
        duration2 = ANIMATION_DURATION;
      }
      if (ease === void 0) {
        ease = ANIMATION_EASING;
      }
      delta = Math.trunc(delta);
      if (Math.abs(delta) <= 0) {
        return;
      }
      var targetPosition = this._position += delta;
      this._setTransform(targetPosition, animated, duration2, ease);
    };
    SliderWrapper2.prototype.moveTo = function(index, delta, animated) {
      if (animated === void 0) {
        animated = false;
      }
      var newPosition = 0;
      if (!delta) {
        newPosition = this._getWrapperSlidePosition(index);
      } else {
        newPosition = this._position += delta;
      }
      this._index = index;
      this._setTransform(newPosition, animated);
    };
    SliderWrapper2.prototype.addSlide = function(slide, position) {
      if (!slide) {
        throw new Error("Cannot add an undefined slide");
      }
      if (position !== -1 && position !== 1) {
        throw new Error("Argument out of range, 'position' must be either 1 or -1. Value ".concat(position));
      }
      if (position > 0) {
        this._wrapperElement.appendChild(slide);
      } else {
        this._wrapperElement.insertBefore(slide, this._wrapperElement.children[0]);
        this._index += 1;
      }
      if (position < 0) {
        var width = slide.offsetWidth;
        var style = window.getComputedStyle(slide);
        var marginLeft = style ? parseInt(style.marginLeft, 10) : 0;
        var marginRight = style ? parseInt(style.marginRight, 10) : 0;
        this.move(-(width + marginLeft + marginRight));
      }
    };
    SliderWrapper2.prototype.removeSlide = function(index) {
      var slide = this._getSlide(index);
      var width = slide.offsetWidth;
      if (index <= this._index) {
        width *= -1;
        this._index -= 1;
      }
      remove(slide);
      if (width < 0) {
        this.move(-width);
      }
    };
    SliderWrapper2.prototype.getSlideDelta = function(index) {
      var currentPosition = this._position;
      if (this._isdragging === true) {
        currentPosition = this._dragStartPosition - this._position;
      }
      var newPosition = this._getWrapperSlidePosition(index);
      return newPosition - currentPosition;
    };
    SliderWrapper2.prototype.getSlideProperties = function(index, delta) {
      if (delta === void 0) {
        delta = 0;
      }
      var currentOffset = this._areaOffset + this._position + delta;
      var currentLeft = currentOffset;
      var currentRight = currentOffset;
      var _a = __read([0, 0], 2), currentMarginLeft = _a[0], currentMarginRight = _a[1];
      var slide = this._getSlide(index);
      var slideIndex = parseInt(slide.getAttribute(ATTRIBUTE_INDEX), 10);
      for (var i = 0; i <= index; i++) {
        slide = this._getSlide(i);
        var slideStyle = window.getComputedStyle(slide);
        currentMarginLeft = parseInt(slideStyle.marginLeft, 10);
        currentMarginRight = parseInt(slideStyle.marginRight, 10);
        currentOffset += currentMarginLeft;
        currentLeft = currentOffset;
        currentRight = currentLeft + slide.offsetWidth;
        if (i < index) {
          currentOffset = currentRight + currentMarginRight;
        }
      }
      var visible = false;
      if (currentLeft > this._containerMin && currentLeft < this._containerMax || currentRight > this._containerMin && currentRight < this._containerMax) {
        visible = true;
      }
      return {
        visible,
        index: slideIndex,
        left: currentLeft,
        right: currentRight,
        width: currentRight - currentLeft,
        marginLeft: currentMarginLeft,
        marginRight: currentMarginRight
      };
    };
    SliderWrapper2.prototype.getRemovableSlides = function(delta) {
      var slides = [];
      var first;
      var last;
      var index = this._wrapperElement.children.length;
      while (index > 0) {
        index -= 1;
        var propsNow = this.getSlideProperties(index);
        var propsNew = this.getSlideProperties(index, delta);
        if (index === this._wrapperElement.children.length - 1) {
          last = propsNew;
        }
        if (index === 0) {
          first = propsNew;
        }
        if (propsNow.visible === false && propsNew.visible === false && index !== this._index && this._isdragging === false) {
          slides.push(true);
        } else {
          slides.push(false);
        }
      }
      slides.reverse();
      var firstToKeep = slides.indexOf(false);
      var lastToKeep = slides.lastIndexOf(false);
      for (var i = firstToKeep; i < lastToKeep; i++) {
        slides[i] = false;
      }
      return {
        slides,
        first,
        last
      };
    };
    SliderWrapper2.prototype.getEmptySpace = function(left, right) {
      return {
        left: Math.max(Math.ceil(left - this._containerMin), 0),
        right: Math.max(Math.ceil(this._containerMax - right), 0)
      };
    };
    SliderWrapper2.prototype.destroy = function() {
      ;
      this._wrapperElement = null;
      this._slideAreaElement = null;
      this._carouselElement = null;
    };
    SliderWrapper2.prototype.destory = function() {
      this.destroy();
    };
    return SliderWrapper2;
  }();
  function init17() {
    searchAndInitialize(".carousel", function(e) {
      new Carousel(e);
    });
  }
  var Carousel_default = Carousel;

  // build/ts/main/src/table/Table.js
  var CLASS_SORTED_ASCENDING = "js-ascending";
  var CLASS_SORTED_DESCENDING = "js-descending";
  var CLASS_ARROW = "arrow-icon";
  var Table = function(_super) {
    __extends(Table2, _super);
    function Table2(element) {
      var _this = _super.call(this, element) || this;
      _this._headerClickHandler = _this._handleHeaderClick.bind(_this);
      _this._body = _this.element.querySelector("tbody");
      _this._header = _this.element.querySelector("thead");
      _this._rows = _this._body.children;
      _this._initialize();
      return _this;
    }
    Table2.prototype._initialize = function() {
      var _this = this;
      var _a;
      (_a = this._header) === null || _a === void 0 ? void 0 : _a.querySelectorAll("th").forEach(function(header) {
        if (header.getAttribute("data-type")) {
          header.addEventListener("click", _this._headerClickHandler);
          var arrowElement = new DomElement_default("div").addClass(CLASS_ARROW).element;
          header.appendChild(arrowElement);
        }
      });
    };
    Table2.prototype._handleHeaderClick = function(e) {
      var th = e.target;
      this.sort(th);
    };
    Table2.prototype.sort = function(tableHeader, direction, equalityComparer) {
      var e_1, _a;
      if (!tableHeader || tableHeader.tagName !== "TH") {
        throw new Error("The parameter 'tableHeader' must be a valid column header node");
      }
      if (direction !== 1 && direction !== -1 && direction) {
        throw new Error("Parameter out of range, parameter 'direction' with value '".concat(direction, "' must be either -1, 1 or undefined"));
      }
      var columnIndex = tableHeader.cellIndex;
      if (!equalityComparer) {
        var dataType = tableHeader.getAttribute("data-type");
        equalityComparer = this._getComparer(dataType);
      }
      if (columnIndex >= this.element.querySelectorAll("th").length) {
        throw new Error("Column out of range");
      }
      try {
        for (var _b = __values(this.element.querySelectorAll("th")), _c = _b.next(); !_c.done; _c = _b.next()) {
          var header = _c.value;
          if (header !== tableHeader) {
            removeClass(header, CLASS_SORTED_ASCENDING);
            removeClass(header, CLASS_SORTED_DESCENDING);
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      if (hasClass(tableHeader, CLASS_SORTED_ASCENDING)) {
        removeClass(tableHeader, CLASS_SORTED_ASCENDING);
        addClass(tableHeader, CLASS_SORTED_DESCENDING);
        direction = direction || -1;
      } else {
        removeClass(tableHeader, CLASS_SORTED_DESCENDING);
        addClass(tableHeader, CLASS_SORTED_ASCENDING);
        direction = direction || 1;
      }
      this._quicksort(columnIndex, 0, this._rows.length - 1, direction, equalityComparer);
    };
    Table2.prototype._getCell = function(column, row) {
      var rowEl = this._rows[row];
      return rowEl.cells[column];
    };
    Table2.prototype._getRow = function(row) {
      return this._rows[row];
    };
    Table2.prototype._getComparer = function(dataType) {
      switch (dataType) {
        case "number": {
          return function(a, b) {
            var A = parseFloat(a);
            var B = parseFloat(b);
            return (isNaN(A) ? Number.MAX_VALUE : A) - (isNaN(B) ? Number.MAX_VALUE : B);
          };
        }
        default: {
          return function(a, b) {
            if (a < b) {
              return -1;
            }
            if (a > b) {
              return 1;
            }
            return 0;
          };
        }
      }
    };
    Table2.prototype._quicksort = function(column, left, right, direction, equalityComparer) {
      if (direction === void 0) {
        direction = 1;
      }
      if (right - left > 0) {
        var partition = this._partition(column, left, right, direction, equalityComparer);
        if (left < partition - 1) {
          this._quicksort(column, left, partition - 1, direction, equalityComparer);
        }
        if (partition < right) {
          this._quicksort(column, partition, right, direction, equalityComparer);
        }
      }
    };
    Table2.prototype._partition = function(column, left, right, direction, equalityComparer) {
      if (direction === void 0) {
        direction = 1;
      }
      var pivot = this._getCell(column, Math.floor((right + left) / 2));
      var i = left;
      var j = right;
      while (i <= j) {
        while (this._equals(this._getCell(column, i), pivot, equalityComparer) * direction < 0) {
          i += 1;
        }
        while (this._equals(this._getCell(column, j), pivot, equalityComparer) * direction > 0) {
          j -= 1;
        }
        if (i <= j) {
          this._swap(i, j);
          i += 1;
          j -= 1;
        }
      }
      return i;
    };
    Table2.prototype._equals = function(a, b, equalityComparer) {
      var dataA = a.getAttribute("data-value");
      var dataB = b.getAttribute("data-value");
      dataA = dataA || a.textContent || a.innerText;
      dataB = dataB || b.textContent || b.innerText;
      return equalityComparer(dataA, dataB);
    };
    Table2.prototype._swap = function(i, j) {
      var rowI = this._getRow(i);
      var rowJ = this._getRow(j);
      var temp = document.createElement("div");
      rowI.parentNode.insertBefore(temp, rowI);
      rowJ.parentNode.insertBefore(rowI, rowJ);
      temp.parentNode.insertBefore(rowJ, temp);
      temp.parentNode.removeChild(temp);
    };
    Table2.prototype.destroy = function() {
      var e_2, _a;
      try {
        for (var _b = __values(this.element.querySelectorAll("th")), _c = _b.next(); !_c.done; _c = _b.next()) {
          var header = _c.value;
          header.removeEventListener("click", this._headerClickHandler);
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      ;
      this._headerClickHandler = null;
      this._body = null;
      this._rows = null;
    };
    return Table2;
  }(DomElement_default);
  function init18() {
    searchAndInitialize("table", function(e) {
      new Table(e);
    });
  }
  var Table_default = Table;

  // build/ts/main/src/charts/ChartFunctions.js
  var QUERY_DATA = ".js-data";
  function tryGetData(element) {
    var e_1, _a;
    var data = [];
    var elements = element.querySelectorAll(QUERY_DATA);
    try {
      for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
        var entry = elements_1_1.value;
        var value = parseFloat(entry.getAttribute("data-value"));
        var color = entry.getAttribute("data-color");
        var title = text(entry);
        var item = {
          title,
          value,
          color
        };
        data.push(item);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return))
          _a.call(elements_1);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    return data;
  }
  function removeAllChildren(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }
  function createLegendItem(data) {
    var bullet = new DomElement_default("span").addClass("bullet");
    if (isColor(data.color) === true) {
      bullet.setAttribute("style", "background-color: ".concat(data.color, ";"));
    } else {
      bullet.addClass(data.color);
    }
    var caption = new DomElement_default("span").setHtml(data.title);
    return new DomElement_default("li").appendChild(bullet).appendChild(caption).element;
  }
  function isColor(str) {
    var pattern = /^#/i;
    return pattern.test(str);
  }

  // build/ts/main/src/charts/PieChart.js
  var QUERY_CHART = ".js-chart";
  var QUERY_LEGEND = ".js-legend";
  var DASH_SEPARATOR_WIDTH = 3;
  var ANIMATION_DURATION2 = 200;
  var QUERY_META_TITLE = ".meta .title";
  var QUERY_META_SUBTITLE = ".meta .subtitle";
  var PieChart = function(_super) {
    __extends(PieChart2, _super);
    function PieChart2(element, data) {
      var _this = _super.call(this, element) || this;
      if (data) {
        _this._data = data;
      }
      _this._initialize();
      return _this;
    }
    PieChart2.prototype._initialize = function() {
      this._chart = this.element.querySelector(QUERY_CHART);
      this._legend = this.element.querySelector(QUERY_LEGEND);
      this._title = this.element.querySelector(QUERY_META_TITLE);
      this._subtitle = this.element.querySelector(QUERY_META_SUBTITLE);
      this._unit = this.getAttribute("data-unit") || "";
      this._alwaysShowLegend = this.element.hasAttribute("data-always-show-legend");
      if (!this._data) {
        this._data = tryGetData(this.element);
      }
      this._render();
    };
    PieChart2.prototype._render = function() {
      var total = this._data.reduce(function(a, b) {
        return a + b.value;
      }, 0);
      var r = 16;
      var dashTotal = 2 * r * Math.PI;
      var currentRotate = 9;
      removeAllChildren(this._chart);
      if (this._legend) {
        removeAllChildren(this._legend);
      }
      var percentageAdjustTotal = 0;
      var percentageAdjust = 0;
      var separatorPercentage = DASH_SEPARATOR_WIDTH / 100;
      for (var i = 0; i < this._data.length; i++) {
        var entry = this._data[i];
        var percentage = entry.value / total;
        if (percentage < separatorPercentage) {
          percentageAdjustTotal += separatorPercentage - percentage;
          percentageAdjust += 1;
        }
      }
      if (percentageAdjust > 0) {
        percentageAdjust = percentageAdjustTotal / (this._data.length - percentageAdjust);
      }
      for (var i = 0; i < this._data.length; i++) {
        var entry = this._data[i];
        var displayPercentage = entry.value / total;
        var percentage = Math.max(separatorPercentage, displayPercentage - percentageAdjust);
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewBox", "0 0 34 34");
        svg.setAttribute("role", "img");
        svg.setAttribute("aria-labelledby", "title desc");
        var title = document.createElementNS("http://www.w3.org/2000/svg", "title");
        title.setAttribute("id", "title");
        title.textContent = "Pie chart segment ".concat(Math.floor(displayPercentage * 100), "%");
        var description = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        description.setAttribute("id", "desc");
        description.textContent = "".concat(entry.title, ": ").concat(entry.value);
        var circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", "17");
        circle.setAttribute("cy", "17");
        circle.setAttribute("r", String(r));
        if (isColor(entry.color) === true) {
          circle.setAttribute("stroke", "".concat(entry.color));
        } else {
          circle.setAttribute("class", entry.color);
        }
        circle.setAttribute("role", "presentation");
        svg.setAttribute("style", "transform: rotate(".concat(currentRotate, "deg);"));
        svg.appendChild(title);
        svg.appendChild(description);
        svg.appendChild(circle);
        this._chart.appendChild(svg);
        animation.set(circle, { visibility: "hidden" });
        animation.start(circle, [
          {
            visibility: "visible",
            strokeDasharray: "0 ".concat(dashTotal)
          },
          {
            visibility: "visible",
            strokeDasharray: "".concat(percentage * dashTotal - DASH_SEPARATOR_WIDTH, " ").concat(dashTotal)
          }
        ], ANIMATION_DURATION2, { delay: i * ANIMATION_DURATION2 });
        if (this._legend && this._data.length > 1 || this._alwaysShowLegend) {
          var bullet = new DomElement_default("span").addClass("bullet");
          if (isColor(entry.color) === true) {
            bullet.setAttribute("style", "background-color: ".concat(entry.color));
          } else {
            bullet.addClass(entry.color);
          }
          var caption = new DomElement_default("span");
          var captionElement = caption.element;
          captionElement.innerText = entry.title;
          var legendItem = new DomElement_default("li").appendChild(bullet).appendChild(caption);
          this._legend.appendChild(legendItem.element);
          this._animateLegend(legendItem.element, i * ANIMATION_DURATION2);
        }
        currentRotate += 360 * percentage;
        if (i === this._data.length - 1) {
          this._title.textContent = "".concat(entry.value, " ").concat(this._unit);
          this._subtitle.textContent = entry.title;
        }
      }
    };
    PieChart2.prototype._animateLegend = function(legendItem, animationOffset) {
      animation.set(legendItem, { opacity: "0" });
      animation.start(legendItem, { opacity: "1" }, ANIMATION_DURATION2, {
        delay: animationOffset,
        finished: function() {
          return legendItem.style.removeProperty("opacity");
        }
      });
    };
    PieChart2.prototype.update = function(data) {
      if (data) {
        this._data = data;
      }
      this._render();
    };
    PieChart2.prototype.destroy = function() {
      ;
      this._data = void 0;
      this._title = void 0;
      this._subtitle = void 0;
      this._unit = void 0;
      removeAllChildren(this._chart);
      this._chart = void 0;
      if (this._legend) {
        removeAllChildren(this._legend);
        this._legend = void 0;
      }
    };
    PieChart2.prototype.destory = function() {
      this.destroy();
    };
    return PieChart2;
  }(DomElement_default);
  function init19() {
    searchAndInitialize(".pie-chart", function(e) {
      new PieChart(e);
    });
  }
  var PieChart_default = PieChart;

  // build/ts/main/src/charts/BarChartHorizontal.js
  var QUERY_DETAIL_RIGHT = ".detail-right";
  var QUERY_DETAIL_BOTTOM = ".detail-bottom";
  var QUERY_PROGRESS = ".bar-chart__progress";
  var CLASS_UNLIMITED = "bar-chart-horizontal--unlimited";
  var CLASS_LIMITED = "bar-chart-horizontal--limited";
  var CLASS_DETAIL_VALUE = "value";
  var CLASS_DETAIL_UNIT = "unit";
  var CLASS_INDICATOR2 = "indicator";
  var CLASS_INDICATOR_WRAPPER = "indicator-wrapper";
  var CLASS_TOOLTIP = "tooltip";
  var CLASS_TOOLTIP_MULTILINE = "tooltip--multiline";
  var ANIMATION_DURATION3 = 500;
  var BarChartHorizontal = function(_super) {
    __extends(BarChartHorizontal2, _super);
    function BarChartHorizontal2(element, data) {
      var _this = _super.call(this, element) || this;
      if (data) {
        _this._data = data;
      }
      _this._legendItems = [];
      _this._initialize();
      return _this;
    }
    BarChartHorizontal2.prototype._initialize = function() {
      this._unit = this.getAttribute("data-unit") || "";
      this._maxValue = parseFloat(this.getAttribute("data-max"));
      this._precision = parseInt(this.getAttribute("data-precision"), 10) || 0;
      this._isUnlimited = this.hasClass(CLASS_UNLIMITED);
      this._isLimited = this.hasClass(CLASS_LIMITED);
      this._progessWrapper = this.element.querySelector(QUERY_PROGRESS);
      if (this._isLimited === true) {
        this._detailRight = this.element.querySelector(QUERY_DETAIL_BOTTOM);
      } else {
        this._detailRight = this.element.querySelector(QUERY_DETAIL_RIGHT);
      }
      if (this._isUnlimited === false && this._isLimited === false) {
        this._legend = getAttributeReference(this.element, "data-legend");
      }
      if (!this._data) {
        this._data = tryGetData(this.element);
      }
      this._render();
    };
    BarChartHorizontal2.prototype._render = function() {
      var e_1, _a;
      var dataOne = this._data[0];
      var dataTwo = this._data[1];
      var tooltip = this._isLimited === false ? this._getTooltipContent(this._data) : void 0;
      var animatedValueElement;
      removeAllChildren(this._detailRight);
      removeAllChildren(this._progessWrapper);
      try {
        for (var _b = __values(this._legendItems), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          remove(item);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      this._legendItems = [];
      if (dataOne) {
        if (this._isUnlimited === false || this._isUnlimited === true && !dataTwo) {
          var valElement = animatedValueElement = this._createValueElement(dataOne);
          this._detailRight.appendChild(valElement);
          if (this._isLimited === false) {
            var separatorElement = new DomElement_default("div").addClass(CLASS_DETAIL_UNIT).element;
            separatorElement.innerText = " ".concat(this._unit);
            this._detailRight.appendChild(separatorElement);
          }
        }
        var indicator = this._addIndicator(dataOne, tooltip);
        this._animateIndicator(indicator, 0);
        if (animatedValueElement && this._isLimited === true) {
          this._animateValueElement(animatedValueElement, dataOne.value);
        }
        if (this._legend) {
          var legendItem = createLegendItem(dataOne);
          this._legend.appendChild(legendItem);
          this._legendItems.push(legendItem);
          this._animateLegend(legendItem, 0);
        }
      }
      if (dataTwo) {
        var valElement = this._createValueElement(dataTwo);
        var unitElement = new DomElement_default("div").addClass(CLASS_DETAIL_UNIT).element;
        unitElement.innerText = " ".concat(this._unit);
        this._detailRight.appendChild(valElement);
        this._detailRight.appendChild(unitElement);
        var indicator = this._addIndicator(dataTwo, tooltip);
        this._animateIndicator(indicator, ANIMATION_DURATION3);
        if (this._legend) {
          var legendItem = createLegendItem(dataTwo);
          this._legend.appendChild(legendItem);
          this._legendItems.push(legendItem);
          this._animateLegend(legendItem, ANIMATION_DURATION3);
        }
      }
      if (this._isLimited === true) {
        var valElement = this._createValueElement({ value: this._maxValue });
        var unitElement = new DomElement_default("div").addClass(CLASS_DETAIL_UNIT).element;
        unitElement.innerText = " ".concat(this._unit);
        this._detailRight.appendChild(valElement);
        this._detailRight.appendChild(unitElement);
      }
    };
    BarChartHorizontal2.prototype._animateValueElement = function(animatedValueElement, toValue) {
      var start = 0;
      var elapsed = 0;
      animatedValueElement.textContent = elapsed.toString();
      function step(time) {
        if (start === 0) {
          start = time;
        }
        elapsed = time - start;
        if (elapsed < ANIMATION_DURATION3) {
          animatedValueElement.textContent = "".concat(Math.round(toValue / ANIMATION_DURATION3 * elapsed));
          requestAnimationFrame(step);
        } else {
          animatedValueElement.textContent = "".concat(toValue);
        }
      }
      requestAnimationFrame(step);
    };
    BarChartHorizontal2.prototype._animateIndicator = function(indicatorWrapper, animationOffset) {
      var indicator = indicatorWrapper.getElementsByClassName("indicator")[0];
      var indicatorWidth = indicator.scrollWidth;
      animation.set(indicator, { width: "0" });
      animation.start(indicator, { width: "".concat(indicatorWidth, "px") }, ANIMATION_DURATION3, {
        delay: animationOffset,
        finished: function() {
          return animation.set(indicator, { width: "" });
        }
      });
    };
    BarChartHorizontal2.prototype._animateLegend = function(legendItem, animationOffset) {
      animation.set(legendItem, { opacity: "0" });
      animation.start(legendItem, { opacity: "1" }, ANIMATION_DURATION3, {
        delay: animationOffset,
        finished: function() {
          return legendItem.style.removeProperty("opacity");
        }
      });
    };
    BarChartHorizontal2.prototype._createValueElement = function(data) {
      var unlimitedPrefix = "";
      if (this._isUnlimited === true) {
        unlimitedPrefix = "+";
      }
      var value = parseFloat(data.value);
      if (value <= 0) {
        if (this._precision === 0) {
          value = "0";
        } else {
          value = ".";
          for (var i = 0; i < this._precision; i++) {
            value += "0";
          }
        }
      } else {
        value = value.toFixed(this._precision);
      }
      var valueElement = new DomElement_default("div").addClass(CLASS_DETAIL_VALUE).element;
      valueElement.innerText = "".concat(unlimitedPrefix).concat(value);
      return valueElement;
    };
    BarChartHorizontal2.prototype._addIndicator = function(data, tooltip) {
      var width = 100 / this._maxValue * data.value;
      var indicator = new DomElement_default("div").addClass(CLASS_INDICATOR2);
      if (isColor(data.color) === true) {
        indicator.setAttribute("style", "background-color: ".concat(data.color, ";"));
      } else {
        indicator.addClass(data.color);
      }
      var indicatorWrapper = new DomElement_default("div").addClass(CLASS_INDICATOR_WRAPPER).setAttribute("style", "width: ".concat(width, "%")).appendChild(indicator).setAttribute("onclick", "void(0)");
      if (tooltip && tooltip !== "") {
        indicatorWrapper.addClass(CLASS_TOOLTIP).addClass(CLASS_TOOLTIP_MULTILINE).setAttribute("aria-label", tooltip);
      }
      this._progessWrapper.appendChild(indicatorWrapper.element);
      return indicatorWrapper.element;
    };
    BarChartHorizontal2.prototype._getTooltipContent = function(dataList) {
      var e_2, _a;
      var tooltip = "";
      try {
        for (var dataList_1 = __values(dataList), dataList_1_1 = dataList_1.next(); !dataList_1_1.done; dataList_1_1 = dataList_1.next()) {
          var data = dataList_1_1.value;
          tooltip += "".concat(data.title, ": ").concat(data.value, " ").concat(this._unit, "\n");
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (dataList_1_1 && !dataList_1_1.done && (_a = dataList_1.return))
            _a.call(dataList_1);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      return tooltip.trim();
    };
    BarChartHorizontal2.prototype.update = function(data) {
      if (data) {
        this._data = data;
      }
      this._render();
    };
    BarChartHorizontal2.prototype.destroy = function() {
      var e_3, _a;
      ;
      this._data = void 0;
      removeAllChildren(this._detailRight);
      removeAllChildren(this._progessWrapper);
      this._detailRight = void 0;
      this._progessWrapper = void 0;
      try {
        for (var _b = __values(this._legendItems), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          remove(item);
        }
      } catch (e_3_1) {
        e_3 = { error: e_3_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return))
            _a.call(_b);
        } finally {
          if (e_3)
            throw e_3.error;
        }
      }
      ;
      this._legendItems = void 0;
      this._legend = void 0;
    };
    BarChartHorizontal2.prototype.destory = function() {
      this.destroy();
    };
    return BarChartHorizontal2;
  }(DomElement_default);
  function init20() {
    searchAndInitialize(".bar-chart-horizontal", function(e) {
      new BarChartHorizontal(e);
    });
  }
  var BarChartHorizontal_default = BarChartHorizontal;

  // build/ts/main/src/charts/BarChartVertical.js
  var QUERY_DATA_CATEGORIES = ".js-data-list .js-category";
  var QUERY_DATA_ITEMS = ".js-data-list .js-data";
  var QUERY_CHART2 = ".js-chart";
  var QUERY_LEGEND2 = ".bar-chart__legend";
  var CLASS_INDICATOR3 = "indicator";
  var CLASS_LABEL_X = "axis-x-label";
  var CLASS_INDICATOR_WRAPPER2 = "indicator-wrapper";
  var CLASS_INDICATOR_INNER_WRAPPER = "indicator-wrapper-inner";
  var CLASS_INDICATOR_EMPTY = "empty";
  var CLASS_TOOLTIP2 = "tooltip";
  var CLASS_TOOLTIP_LEFT = "tooltip--left";
  var CLASS_TOOLTIP_RIGHT = "tooltip--right";
  var CLASS_TOOLTIP_MULTILINE2 = "tooltip--multiline";
  var ANIMATION_DURATION4 = 500;
  var BarChartVertical = function(_super) {
    __extends(BarChartVertical2, _super);
    function BarChartVertical2(element, data) {
      var _this = _super.call(this, element) || this;
      if (data) {
        _this._data = data;
      }
      _this._initialize();
      return _this;
    }
    BarChartVertical2.prototype._initialize = function() {
      this._unit = this.getAttribute("data-unit") || "";
      this._maxValue = parseFloat(this.getAttribute("data-max")) || 100;
      this._chart = this.element.querySelector(QUERY_CHART2);
      this._legend = this.element.querySelector(QUERY_LEGEND2);
      if (!this._data) {
        this._data = this._tryGetData(this.element);
      }
      this._render();
    };
    BarChartVertical2.prototype._tryGetData = function(element) {
      var e_1, _a, e_2, _b, e_3, _c;
      var data = {
        categories: [],
        items: []
      };
      var categories = element.querySelectorAll(QUERY_DATA_CATEGORIES);
      var items = element.querySelectorAll(QUERY_DATA_ITEMS);
      try {
        for (var categories_1 = __values(categories), categories_1_1 = categories_1.next(); !categories_1_1.done; categories_1_1 = categories_1.next()) {
          var category = categories_1_1.value;
          data.categories.push({
            title: text(category),
            color: category.getAttribute("data-color")
          });
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (categories_1_1 && !categories_1_1.done && (_a = categories_1.return))
            _a.call(categories_1);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
          var item = items_1_1.value;
          var dataEnty = {
            title: text(item),
            class: item.getAttribute("data-class"),
            values: []
          };
          var vals = item.getAttribute("data-value");
          if (vals) {
            try {
              for (var _d = (e_3 = void 0, __values(vals.split(","))), _e = _d.next(); !_e.done; _e = _d.next()) {
                var val = _e.value;
                dataEnty.values.push(parseFloat(val));
              }
            } catch (e_3_1) {
              e_3 = { error: e_3_1 };
            } finally {
              try {
                if (_e && !_e.done && (_c = _d.return))
                  _c.call(_d);
              } finally {
                if (e_3)
                  throw e_3.error;
              }
            }
          }
          data.items.push(dataEnty);
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (items_1_1 && !items_1_1.done && (_b = items_1.return))
            _b.call(items_1);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      return data;
    };
    BarChartVertical2.prototype._getTooltipContent = function(entry, categories) {
      var tooltip = "";
      for (var i = 0; i < entry.values.length; i++) {
        tooltip += "".concat(categories[i].title, ": ").concat(entry.values[i], " ").concat(this._unit, "\n");
      }
      return tooltip.trim();
    };
    BarChartVertical2.prototype._render = function() {
      var e_4, _a, e_5, _b;
      if (this._legend) {
        removeAllChildren(this._legend);
        try {
          for (var _c = __values(this._data.categories), _d = _c.next(); !_d.done; _d = _c.next()) {
            var category = _d.value;
            var legendItem = createLegendItem(category);
            this._legend.appendChild(legendItem);
          }
        } catch (e_4_1) {
          e_4 = { error: e_4_1 };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return))
              _a.call(_c);
          } finally {
            if (e_4)
              throw e_4.error;
          }
        }
      }
      removeAllChildren(this._chart);
      var animationStages = [];
      var leftSideItems = Math.floor(this._data.items.length / 2);
      try {
        for (var _e = __values(this._data.items), _f = _e.next(); !_f.done; _f = _e.next()) {
          var item = _f.value;
          var element = new DomElement_default("li");
          if (item.class) {
            element.addClass(item.class);
          }
          var listElement = new DomElement_default("ul").addClass(CLASS_INDICATOR_WRAPPER2);
          var wrapper = new DomElement_default("div").addClass(CLASS_INDICATOR_INNER_WRAPPER);
          listElement.appendChild(wrapper);
          element.appendChild(listElement);
          var tooltip = this._getTooltipContent(item, this._data.categories);
          if (tooltip) {
            wrapper.addClass(CLASS_TOOLTIP2).addClass(leftSideItems <= 0 ? CLASS_TOOLTIP_LEFT : CLASS_TOOLTIP_RIGHT).setAttribute("aria-label", tooltip);
            if (item.values.length > 1) {
              wrapper.addClass(CLASS_TOOLTIP_MULTILINE2);
            }
          }
          for (var i = 0; i < item.values.length; i++) {
            var height = this._chart.offsetHeight / this._maxValue * item.values[i];
            var indicator = new DomElement_default("li").addClass(CLASS_INDICATOR3).setAttribute("style", "height: ".concat(height, "px;"));
            if (height > 0) {
              var color = this._data.categories[i].color;
              if (isColor(color)) {
                indicator.setAttribute("style", "background-color: ".concat(color, ";"));
              } else {
                indicator.addClass(color);
              }
              if (!animationStages[i]) {
                animationStages[i] = [];
              }
              animationStages[i].push(indicator.element);
            } else {
              indicator.addClass(CLASS_INDICATOR_EMPTY);
            }
            wrapper.appendChild(indicator);
          }
          var titleDomElement = new DomElement_default("div").addClass(CLASS_LABEL_X);
          var titleElement = titleDomElement.element;
          titleElement.innerText = item.title;
          element.appendChild(titleDomElement);
          this._chart.appendChild(element.element);
          leftSideItems -= 1;
        }
      } catch (e_5_1) {
        e_5 = { error: e_5_1 };
      } finally {
        try {
          if (_f && !_f.done && (_b = _e.return))
            _b.call(_e);
        } finally {
          if (e_5)
            throw e_5.error;
        }
      }
      for (var i = 0; i < animationStages.length; i++) {
        var offset = ANIMATION_DURATION4 * i;
        this._animateBars(animationStages[i], offset);
        if (this._legend) {
          this._animateLegend(this._legend.children[i], offset);
        }
      }
    };
    BarChartVertical2.prototype._animateBars = function(bars, animationOffset) {
      var e_6, _a;
      try {
        for (var bars_1 = __values(bars), bars_1_1 = bars_1.next(); !bars_1_1.done; bars_1_1 = bars_1.next()) {
          var bar = bars_1_1.value;
          var height = bar.style.height;
          animation.set(bar, { height: "0" });
          animation.start(bar, { height }, ANIMATION_DURATION4, {
            delay: animationOffset
          });
        }
      } catch (e_6_1) {
        e_6 = { error: e_6_1 };
      } finally {
        try {
          if (bars_1_1 && !bars_1_1.done && (_a = bars_1.return))
            _a.call(bars_1);
        } finally {
          if (e_6)
            throw e_6.error;
        }
      }
    };
    BarChartVertical2.prototype._animateLegend = function(legend, animationOffset) {
      animation.set(legend, { opacity: "0" });
      animation.start(legend, { opacity: "1" }, ANIMATION_DURATION4, {
        delay: animationOffset
      });
    };
    BarChartVertical2.prototype.update = function(data) {
      if (data) {
        this._data = data;
      }
      this._render();
    };
    BarChartVertical2.prototype.destroy = function() {
      ;
      this._data = void 0;
      if (this._legend) {
        removeAllChildren(this._legend);
        this._legend = void 0;
      }
    };
    BarChartVertical2.prototype.destory = function() {
      this.destroy();
    };
    return BarChartVertical2;
  }(DomElement_default);
  function init21() {
    searchAndInitialize(".bar-chart-vertical", function(e) {
      new BarChartVertical(e);
    });
  }
  var BarChartVertical_default = BarChartVertical;

  // build/ts/main/sdx.js
  var sdx = __assign(__assign(__assign({}, sdx_exports), window.sdx || {}), { VERSION: "2.126.0" });
  window.sdx = sdx;
  Utils_exports.onDocumentReady(function() {
    init2();
    init3();
    init4();
    init();
    init6();
    init7();
    init8();
    init5();
    init9();
    init11();
    init10();
    init12();
    init14();
    init15();
    init13();
    init16();
    init17();
    init18();
    init19();
    init20();
    init21();
  });
})();
